/* tslint:disable */
/* eslint-disable */
/**
 * Assisto API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI } from './base';
export const AddTopicRequestAssignToTypeEnum = {
    Groups: 'groups',
    Users: 'users'
};
/**
 * agb type
 * @export
 * @enum {string}
 */
export const AgbType = {
    Frontend: 'frontend',
    Backend: 'backend'
};
export const AgreementTypeTypeEnum = {
    LicenseAgreement: 'license_agreement',
    DataProcessing: 'data_processing'
};
/**
 * appointment staus
 * @export
 * @enum {string}
 */
export const AppointmentStatus = {
    Confirmed: 'confirmed',
    AdviserOpen: 'adviser_open',
    ClientOpen: 'client_open',
    Free: 'free',
    Reserved: 'reserved',
    Blocked: 'blocked',
    Rejected: 'rejected'
};
/**
 * appointment type
 * @export
 * @enum {string}
 */
export const AppointmentType = {
    Single: 'single',
    Group: 'group'
};
export const AssignTopicRequestAssignToTypeEnum = {
    Groups: 'groups',
    Users: 'users'
};
/**
 * assisto backend module
 * @export
 * @enum {string}
 */
export const AssistoModule = {
    Messenger: 'messenger',
    Groups: 'groups',
    Questions: 'questions',
    Users: 'users',
    Settings: 'settings',
    PopupNotifications: 'popup_notifications',
    Fachaustausch: 'fachaustausch',
    Webmessenger: 'webmessenger',
    MailRequests: 'mail_requests',
    Appointments: 'appointments',
    OfflineDb: 'offline_db',
    Documents: 'documents',
    AssistoVideo: 'assisto_video',
    Lessons: 'lessons',
    ReactBackend: 'react_backend',
    Registration: 'registration',
    Caldav: 'caldav'
};
export const CompanyContactTypeTypeEnum = {
    InvoiceDispatch: 'invoice_dispatch',
    Project: 'project'
};
export const ComplaintRequestItemTypeEnum = {
    Thread: 'thread',
    Group: 'group',
    Answer: 'answer'
};
/**
 * contactType
 * @export
 * @enum {string}
 */
export const ContactType = {
    Email: 'email',
    Telefon: 'telefon',
    FastRegister: 'fast_register',
    None: 'none',
    MessengerBasic: 'messenger_basic',
    Groups: 'groups'
};
export const GetStreamResponseDataStreamTypeEnum = {
    Single: 'single',
    Group: 'group'
};
export const GetStreamResponseDataMessagesInnerSenderEnum = {
    Self: 'self',
    Other: 'other'
};
export const GetStreamsResponseDataInnerStreamTypeEnum = {
    Single: 'single',
    Group: 'group'
};
/**
 * group invitation status
 * @export
 * @enum {string}
 */
export const GroupInvitationStatus = {
    Sent: 'sent',
    Accepted: 'accepted',
    Rejected: 'rejected'
};
/**
 * group modus
 * @export
 * @enum {string}
 */
export const GroupModus = {
    Open: 'open',
    Closed: 'closed',
    Public: 'public'
};
/**
 * user role in group
 * @export
 * @enum {string}
 */
export const GroupRole = {
    Member: 'member',
    Moderator: 'moderator',
    Admin: 'admin'
};
/**
 * identType
 * @export
 * @enum {string}
 */
export const IdentType = {
    Chat: 'chat',
    Phone: 'phone',
    Videochat: 'videochat',
    Local: 'local'
};
/**
 * message status
 * @export
 * @enum {string}
 */
export const MessageStatus = {
    NotSend: 'not_send',
    Send: 'send',
    Received: 'received',
    Read: 'read'
};
/**
 * message type
 * @export
 * @enum {string}
 */
export const MessageType = {
    Message: 'message',
    Answer: 'answer',
    Document: 'document',
    AdviserChange: 'adviser_change'
};
/**
 * hard limit for max items per page
 * @export
 * @enum {string}
 */
export const PaginationLimit = {
    NUMBER_50: 50
};
export const ProductKeyEnum = {
    WebBasic: 'web_basic',
    MessengerApp: 'messenger_app',
    Groups: 'groups',
    WebMessenger: 'web_messenger',
    Questo: 'questo'
};
/**
 * type of product agreement
 * @export
 * @enum {string}
 */
export const ProductAgreementType = {
    PrivacyPolicy: 'privacy_policy',
    TermsOfService: 'terms_of_service'
};
export const ProductOldKeyEnum = {
    WebBasic: 'web_basic',
    MessengerApp: 'messenger_app'
};
/**
 * registration status
 * @export
 * @enum {string}
 */
export const RegistrationStatus = {
    Placeholder: 'placeholder',
    CodeSend: 'code_send',
    Completed: 'completed'
};
/**
 * contactType
 * @export
 * @enum {string}
 */
export const TypeType = {
    Vacation: 'vacation',
    Other: 'other'
};
/**
 * user role
 * @export
 * @enum {string}
 */
export const UserRole = {
    Adviser: 'adviser',
    Client: 'client',
    Placeholder: 'placeholder',
    Moderator: 'moderator',
    Webmessenger: 'webmessenger',
    Landingpage: 'landingpage'
};
/**
 * user status
 * @export
 * @enum {string}
 */
export const UserStatus = {
    Available: 'available',
    NotAvailable: 'not_available',
    Disabled: 'disabled',
    Enabled: 'enabled',
    Paused: 'paused'
};
/**
 * AdvisersApi - axios parameter creator
 * @export
 */
export const AdvisersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Add a new adviser
         * @param {NewAdviserInfo} [newAdviserInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAdviser: (newAdviserInfo, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/advisers/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(newAdviserInfo, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdvisersApi - functional programming interface
 * @export
 */
export const AdvisersApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdvisersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Add a new adviser
         * @param {NewAdviserInfo} [newAdviserInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAdviser(newAdviserInfo, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addAdviser(newAdviserInfo, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdvisersApi - factory interface
 * @export
 */
export const AdvisersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdvisersApiFp(configuration);
    return {
        /**
         *
         * @summary Add a new adviser
         * @param {NewAdviserInfo} [newAdviserInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAdviser(newAdviserInfo, options) {
            return localVarFp.addAdviser(newAdviserInfo, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdvisersApi - object-oriented interface
 * @export
 * @class AdvisersApi
 * @extends {BaseAPI}
 */
export class AdvisersApi extends BaseAPI {
    /**
     *
     * @summary Add a new adviser
     * @param {NewAdviserInfo} [newAdviserInfo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisersApi
     */
    addAdviser(newAdviserInfo, options) {
        return AdvisersApiFp(this.configuration).addAdviser(newAdviserInfo, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AgreementsApi - axios parameter creator
 * @export
 */
export const AgreementsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary get
         * @param {number} agreementId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreement: (agreementId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('getAgreement', 'agreementId', agreementId);
            const localVarPath = `/backend/api/v1/agreements/get/{agreementId}`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get all agreements
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAgreements: (page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/agreements/get-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get latest agreement of type
         * @param {number} agreementType agreement type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestAgreement: (agreementType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'agreementType' is not null or undefined
            assertParamExists('getLatestAgreement', 'agreementType', agreementType);
            const localVarPath = `/backend/api/v1/agreements/get-latest/{agreement_type}`
                .replace(`{${"agreement_type"}}`, encodeURIComponent(String(agreementType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {Agreement} agreement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAgreements: (agreement, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'agreement' is not null or undefined
            assertParamExists('saveAgreements', 'agreement', agreement);
            const localVarPath = `/backend/api/v1/agreements/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(agreement, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AgreementsApi - functional programming interface
 * @export
 */
export const AgreementsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AgreementsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary get
         * @param {number} agreementId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreement(agreementId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAgreement(agreementId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get all agreements
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAgreements(page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllAgreements(page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get latest agreement of type
         * @param {number} agreementType agreement type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestAgreement(agreementType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLatestAgreement(agreementType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {Agreement} agreement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAgreements(agreement, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveAgreements(agreement, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AgreementsApi - factory interface
 * @export
 */
export const AgreementsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AgreementsApiFp(configuration);
    return {
        /**
         *
         * @summary get
         * @param {number} agreementId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreement(agreementId, options) {
            return localVarFp.getAgreement(agreementId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get all agreements
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAgreements(page, limit, options) {
            return localVarFp.getAllAgreements(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get latest agreement of type
         * @param {number} agreementType agreement type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestAgreement(agreementType, options) {
            return localVarFp.getLatestAgreement(agreementType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {Agreement} agreement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAgreements(agreement, options) {
            return localVarFp.saveAgreements(agreement, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AgreementsApi - object-oriented interface
 * @export
 * @class AgreementsApi
 * @extends {BaseAPI}
 */
export class AgreementsApi extends BaseAPI {
    /**
     *
     * @summary get
     * @param {number} agreementId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementsApi
     */
    getAgreement(agreementId, options) {
        return AgreementsApiFp(this.configuration).getAgreement(agreementId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get all agreements
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementsApi
     */
    getAllAgreements(page, limit, options) {
        return AgreementsApiFp(this.configuration).getAllAgreements(page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get latest agreement of type
     * @param {number} agreementType agreement type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementsApi
     */
    getLatestAgreement(agreementType, options) {
        return AgreementsApiFp(this.configuration).getLatestAgreement(agreementType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {Agreement} agreement
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementsApi
     */
    saveAgreements(agreement, options) {
        return AgreementsApiFp(this.configuration).saveAgreements(agreement, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AppVersionsApi - axios parameter creator
 * @export
 */
export const AppVersionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Gibt zurück, ob eine neuere App Version existiert. Erwartet die FirmaID und eine App Version als POST Daten. firmaId ; version
         * @summary checkVersion
         * @param {CheckVersionRequest} checkVersionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkVersion: (checkVersionRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'checkVersionRequest' is not null or undefined
            assertParamExists('checkVersion', 'checkVersionRequest', checkVersionRequest);
            const localVarPath = `/client/check-version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(checkVersionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AppVersionsApi - functional programming interface
 * @export
 */
export const AppVersionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AppVersionsApiAxiosParamCreator(configuration);
    return {
        /**
         * Gibt zurück, ob eine neuere App Version existiert. Erwartet die FirmaID und eine App Version als POST Daten. firmaId ; version
         * @summary checkVersion
         * @param {CheckVersionRequest} checkVersionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkVersion(checkVersionRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkVersion(checkVersionRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AppVersionsApi - factory interface
 * @export
 */
export const AppVersionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AppVersionsApiFp(configuration);
    return {
        /**
         * Gibt zurück, ob eine neuere App Version existiert. Erwartet die FirmaID und eine App Version als POST Daten. firmaId ; version
         * @summary checkVersion
         * @param {CheckVersionRequest} checkVersionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkVersion(checkVersionRequest, options) {
            return localVarFp.checkVersion(checkVersionRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AppVersionsApi - object-oriented interface
 * @export
 * @class AppVersionsApi
 * @extends {BaseAPI}
 */
export class AppVersionsApi extends BaseAPI {
    /**
     * Gibt zurück, ob eine neuere App Version existiert. Erwartet die FirmaID und eine App Version als POST Daten. firmaId ; version
     * @summary checkVersion
     * @param {CheckVersionRequest} checkVersionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppVersionsApi
     */
    checkVersion(checkVersionRequest, options) {
        return AppVersionsApiFp(this.configuration).checkVersion(checkVersionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AppointmentsApi - axios parameter creator
 * @export
 */
export const AppointmentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary delete
         * @param {number} adviserClosingTimeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdviserClosingTimes: (adviserClosingTimeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'adviserClosingTimeId' is not null or undefined
            assertParamExists('deleteAdviserClosingTimes', 'adviserClosingTimeId', adviserClosingTimeId);
            const localVarPath = `/backend/api/v1/appointments/adviser-closing-times/delete/{AdviserClosingTimeId}`
                .replace(`{${"AdviserClosingTimeId"}}`, encodeURIComponent(String(adviserClosingTimeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary delete
         * @param {number} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAppointment: (appointmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('deleteAppointment', 'appointmentId', appointmentId);
            const localVarPath = `/backend/api/v1/appointments/delete/{AppointmentId}`
                .replace(`{${"AppointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary delete
         * @param {number} communicationChannelId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommunicationChannel: (communicationChannelId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'communicationChannelId' is not null or undefined
            assertParamExists('deleteCommunicationChannel', 'communicationChannelId', communicationChannelId);
            const localVarPath = `/backend/api/v1/appointments/communication-channels/delete/{CommunicationChannelId}`
                .replace(`{${"CommunicationChannelId"}}`, encodeURIComponent(String(communicationChannelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary delete
         * @param {number} companyClosingTimeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyClosingTime: (companyClosingTimeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyClosingTimeId' is not null or undefined
            assertParamExists('deleteCompanyClosingTime', 'companyClosingTimeId', companyClosingTimeId);
            const localVarPath = `/backend/api/v1/appointments/company-closing-times/delete/{CompanyClosingTimeId}`
                .replace(`{${"CompanyClosingTimeId"}}`, encodeURIComponent(String(companyClosingTimeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary delete
         * @param {number} serviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteService: (serviceId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('deleteService', 'serviceId', serviceId);
            const localVarPath = `/backend/api/v1/appointments/services/delete/{ServiceId}`
                .replace(`{${"ServiceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary delete
         * @param {number} timeSlotId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTimeSlots: (timeSlotId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'timeSlotId' is not null or undefined
            assertParamExists('deleteTimeSlots', 'timeSlotId', timeSlotId);
            const localVarPath = `/backend/api/v1/appointments/time-slots/delete/{TimeSlotId}`
                .replace(`{${"TimeSlotId"}}`, encodeURIComponent(String(timeSlotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get single adviser closing times
         * @param {number} adviserclosingtimesId adviser closing time id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdviserClosingTime: (adviserclosingtimesId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'adviserclosingtimesId' is not null or undefined
            assertParamExists('getAdviserClosingTime', 'adviserclosingtimesId', adviserclosingtimesId);
            const localVarPath = `/backend/api/v1/appointments/adviser-closing-times/get/{adviserclosingtimesId}`
                .replace(`{${"adviserclosingtimesId"}}`, encodeURIComponent(String(adviserclosingtimesId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get all adviser closing times
         * @param {number} [startDatetime] adviser closing times from date
         * @param {number} [endDatetime] adviser closing times to date
         * @param {string} [userId] user to get closing times from
         * @param {string} [type] type
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAdviserClosingTimes: (startDatetime, endDatetime, userId, type, page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/appointments/adviser-closing-times/get-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (startDatetime !== undefined) {
                localVarQueryParameter['start_datetime'] = startDatetime;
            }
            if (endDatetime !== undefined) {
                localVarQueryParameter['end_datetime'] = endDatetime;
            }
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get all appointments
         * @param {number} [from] appointment from date
         * @param {number} [to] appointment to date
         * @param {Array<AppointmentType>} [type] Appointment types to filter by
         * @param {Array<number>} [adviserId] Adviser IDs to filter by
         * @param {Array<AppointmentStatus>} [status] Appointment statuses to filter by
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAppointments: (from, to, type, adviserId, status, page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/appointments/get-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (type) {
                localVarQueryParameter['type'] = type.join(COLLECTION_FORMATS.csv);
            }
            if (adviserId) {
                localVarQueryParameter['adviser_id'] = adviserId.join(COLLECTION_FORMATS.csv);
            }
            if (status) {
                localVarQueryParameter['status'] = status.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get all communication channels
         * @param {number} [page] page nr of requested page
         * @param {'chat' | 'phone' | 'videochat' | 'local'} [ident] communication channels type
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCommunicationChannels: (page, ident, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/appointments/communication-channels/get-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (ident !== undefined) {
                localVarQueryParameter['ident'] = ident;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get all company closing times
         * @param {number} [from] company closing times from date
         * @param {number} [to] company closing times to date
         * @param {'holiday' | 'other'} [type] type
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompanyClosingTimes: (from, to, type, page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/appointments/company-closing-times/get-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get all services
         * @param {number} [page] page nr of requested page
         * @param {string} [name] service name
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllServices: (page, name, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/appointments/services/get-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get all time slots
         * @param {string} [startTime] time slot start time
         * @param {string} [endTime] time slot end time
         * @param {number} [weekday] time slot weekday
         * @param {number} [appointmentsServiceId] service id
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTimeSlots: (startTime, endTime, weekday, appointmentsServiceId, page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/appointments/time-slots/get-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }
            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }
            if (weekday !== undefined) {
                localVarQueryParameter['weekday'] = weekday;
            }
            if (appointmentsServiceId !== undefined) {
                localVarQueryParameter['appointments_service_id'] = appointmentsServiceId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get single appointment
         * @param {number} appointmentId appointment id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointment: (appointmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('getAppointment', 'appointmentId', appointmentId);
            const localVarPath = `/backend/api/v1/appointments/get/{appointmentId}`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get single communication channel
         * @param {number} id communication channel id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunicationChannel: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCommunicationChannel', 'id', id);
            const localVarPath = `/backend/api/v1/appointments/communication-channels/get/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get single company closing times
         * @param {number} id company closing time id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyClosingTime: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCompanyClosingTime', 'id', id);
            const localVarPath = `/backend/api/v1/appointments/company-closing-times/get/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get single service
         * @param {number} id service id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getService: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getService', 'id', id);
            const localVarPath = `/backend/api/v1/appointments/services/get/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get single time slot
         * @param {number} id time slot id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeSlot: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTimeSlot', 'id', id);
            const localVarPath = `/backend/api/v1/appointments/time-slots/get/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary list available communication channels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCommunicationChannels: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/appointments/communication-channels/list/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {AdviserClosingTime} adviserClosingTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAdviserClosingTimes: (adviserClosingTime, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'adviserClosingTime' is not null or undefined
            assertParamExists('saveAdviserClosingTimes', 'adviserClosingTime', adviserClosingTime);
            const localVarPath = `/backend/api/v1/appointments/adviser-closing-times/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adviserClosingTime, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {SaveAppointmentsRequest} saveAppointmentsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAppointments: (saveAppointmentsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'saveAppointmentsRequest' is not null or undefined
            assertParamExists('saveAppointments', 'saveAppointmentsRequest', saveAppointmentsRequest);
            const localVarPath = `/backend/api/v1/appointments/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(saveAppointmentsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {CommunicationChannel} communicationChannel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCommunicationChannels: (communicationChannel, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'communicationChannel' is not null or undefined
            assertParamExists('saveCommunicationChannels', 'communicationChannel', communicationChannel);
            const localVarPath = `/backend/api/v1/appointments/communication-channels/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(communicationChannel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {CompanyClosingTime} companyClosingTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompanyClosingTimes: (companyClosingTime, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyClosingTime' is not null or undefined
            assertParamExists('saveCompanyClosingTimes', 'companyClosingTime', companyClosingTime);
            const localVarPath = `/backend/api/v1/appointments/company-closing-times/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(companyClosingTime, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {Service} service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveServices: (service, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'service' is not null or undefined
            assertParamExists('saveServices', 'service', service);
            const localVarPath = `/backend/api/v1/appointments/services/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(service, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {TimeSlot} timeSlot
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTimeSlots: (timeSlot, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'timeSlot' is not null or undefined
            assertParamExists('saveTimeSlots', 'timeSlot', timeSlot);
            const localVarPath = `/backend/api/v1/appointments/time-slots/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(timeSlot, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AppointmentsApi - functional programming interface
 * @export
 */
export const AppointmentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AppointmentsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} adviserClosingTimeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdviserClosingTimes(adviserClosingTimeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteAdviserClosingTimes(adviserClosingTimeId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary delete
         * @param {number} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAppointment(appointmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteAppointment(appointmentId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary delete
         * @param {number} communicationChannelId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommunicationChannel(communicationChannelId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteCommunicationChannel(communicationChannelId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary delete
         * @param {number} companyClosingTimeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyClosingTime(companyClosingTimeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteCompanyClosingTime(companyClosingTimeId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary delete
         * @param {number} serviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteService(serviceId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteService(serviceId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary delete
         * @param {number} timeSlotId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTimeSlots(timeSlotId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteTimeSlots(timeSlotId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get single adviser closing times
         * @param {number} adviserclosingtimesId adviser closing time id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdviserClosingTime(adviserclosingtimesId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAdviserClosingTime(adviserclosingtimesId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get all adviser closing times
         * @param {number} [startDatetime] adviser closing times from date
         * @param {number} [endDatetime] adviser closing times to date
         * @param {string} [userId] user to get closing times from
         * @param {string} [type] type
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAdviserClosingTimes(startDatetime, endDatetime, userId, type, page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllAdviserClosingTimes(startDatetime, endDatetime, userId, type, page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get all appointments
         * @param {number} [from] appointment from date
         * @param {number} [to] appointment to date
         * @param {Array<AppointmentType>} [type] Appointment types to filter by
         * @param {Array<number>} [adviserId] Adviser IDs to filter by
         * @param {Array<AppointmentStatus>} [status] Appointment statuses to filter by
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAppointments(from, to, type, adviserId, status, page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllAppointments(from, to, type, adviserId, status, page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get all communication channels
         * @param {number} [page] page nr of requested page
         * @param {'chat' | 'phone' | 'videochat' | 'local'} [ident] communication channels type
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCommunicationChannels(page, ident, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllCommunicationChannels(page, ident, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get all company closing times
         * @param {number} [from] company closing times from date
         * @param {number} [to] company closing times to date
         * @param {'holiday' | 'other'} [type] type
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompanyClosingTimes(from, to, type, page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllCompanyClosingTimes(from, to, type, page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get all services
         * @param {number} [page] page nr of requested page
         * @param {string} [name] service name
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllServices(page, name, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllServices(page, name, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get all time slots
         * @param {string} [startTime] time slot start time
         * @param {string} [endTime] time slot end time
         * @param {number} [weekday] time slot weekday
         * @param {number} [appointmentsServiceId] service id
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTimeSlots(startTime, endTime, weekday, appointmentsServiceId, page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllTimeSlots(startTime, endTime, weekday, appointmentsServiceId, page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get single appointment
         * @param {number} appointmentId appointment id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointment(appointmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAppointment(appointmentId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get single communication channel
         * @param {number} id communication channel id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunicationChannel(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCommunicationChannel(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get single company closing times
         * @param {number} id company closing time id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyClosingTime(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompanyClosingTime(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get single service
         * @param {number} id service id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getService(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getService(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get single time slot
         * @param {number} id time slot id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeSlot(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTimeSlot(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary list available communication channels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCommunicationChannels(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCommunicationChannels(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {AdviserClosingTime} adviserClosingTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAdviserClosingTimes(adviserClosingTime, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveAdviserClosingTimes(adviserClosingTime, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {SaveAppointmentsRequest} saveAppointmentsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAppointments(saveAppointmentsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveAppointments(saveAppointmentsRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {CommunicationChannel} communicationChannel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCommunicationChannels(communicationChannel, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveCommunicationChannels(communicationChannel, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {CompanyClosingTime} companyClosingTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompanyClosingTimes(companyClosingTime, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveCompanyClosingTimes(companyClosingTime, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {Service} service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveServices(service, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveServices(service, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {TimeSlot} timeSlot
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTimeSlots(timeSlot, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveTimeSlots(timeSlot, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AppointmentsApi - factory interface
 * @export
 */
export const AppointmentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AppointmentsApiFp(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} adviserClosingTimeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdviserClosingTimes(adviserClosingTimeId, options) {
            return localVarFp.deleteAdviserClosingTimes(adviserClosingTimeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary delete
         * @param {number} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAppointment(appointmentId, options) {
            return localVarFp.deleteAppointment(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary delete
         * @param {number} communicationChannelId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommunicationChannel(communicationChannelId, options) {
            return localVarFp.deleteCommunicationChannel(communicationChannelId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary delete
         * @param {number} companyClosingTimeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyClosingTime(companyClosingTimeId, options) {
            return localVarFp.deleteCompanyClosingTime(companyClosingTimeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary delete
         * @param {number} serviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteService(serviceId, options) {
            return localVarFp.deleteService(serviceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary delete
         * @param {number} timeSlotId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTimeSlots(timeSlotId, options) {
            return localVarFp.deleteTimeSlots(timeSlotId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get single adviser closing times
         * @param {number} adviserclosingtimesId adviser closing time id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdviserClosingTime(adviserclosingtimesId, options) {
            return localVarFp.getAdviserClosingTime(adviserclosingtimesId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get all adviser closing times
         * @param {number} [startDatetime] adviser closing times from date
         * @param {number} [endDatetime] adviser closing times to date
         * @param {string} [userId] user to get closing times from
         * @param {string} [type] type
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAdviserClosingTimes(startDatetime, endDatetime, userId, type, page, limit, options) {
            return localVarFp.getAllAdviserClosingTimes(startDatetime, endDatetime, userId, type, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get all appointments
         * @param {number} [from] appointment from date
         * @param {number} [to] appointment to date
         * @param {Array<AppointmentType>} [type] Appointment types to filter by
         * @param {Array<number>} [adviserId] Adviser IDs to filter by
         * @param {Array<AppointmentStatus>} [status] Appointment statuses to filter by
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAppointments(from, to, type, adviserId, status, page, limit, options) {
            return localVarFp.getAllAppointments(from, to, type, adviserId, status, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get all communication channels
         * @param {number} [page] page nr of requested page
         * @param {'chat' | 'phone' | 'videochat' | 'local'} [ident] communication channels type
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCommunicationChannels(page, ident, limit, options) {
            return localVarFp.getAllCommunicationChannels(page, ident, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get all company closing times
         * @param {number} [from] company closing times from date
         * @param {number} [to] company closing times to date
         * @param {'holiday' | 'other'} [type] type
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompanyClosingTimes(from, to, type, page, limit, options) {
            return localVarFp.getAllCompanyClosingTimes(from, to, type, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get all services
         * @param {number} [page] page nr of requested page
         * @param {string} [name] service name
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllServices(page, name, limit, options) {
            return localVarFp.getAllServices(page, name, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get all time slots
         * @param {string} [startTime] time slot start time
         * @param {string} [endTime] time slot end time
         * @param {number} [weekday] time slot weekday
         * @param {number} [appointmentsServiceId] service id
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTimeSlots(startTime, endTime, weekday, appointmentsServiceId, page, limit, options) {
            return localVarFp.getAllTimeSlots(startTime, endTime, weekday, appointmentsServiceId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get single appointment
         * @param {number} appointmentId appointment id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointment(appointmentId, options) {
            return localVarFp.getAppointment(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get single communication channel
         * @param {number} id communication channel id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunicationChannel(id, options) {
            return localVarFp.getCommunicationChannel(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get single company closing times
         * @param {number} id company closing time id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyClosingTime(id, options) {
            return localVarFp.getCompanyClosingTime(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get single service
         * @param {number} id service id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getService(id, options) {
            return localVarFp.getService(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get single time slot
         * @param {number} id time slot id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeSlot(id, options) {
            return localVarFp.getTimeSlot(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary list available communication channels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCommunicationChannels(options) {
            return localVarFp.listCommunicationChannels(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {AdviserClosingTime} adviserClosingTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAdviserClosingTimes(adviserClosingTime, options) {
            return localVarFp.saveAdviserClosingTimes(adviserClosingTime, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {SaveAppointmentsRequest} saveAppointmentsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAppointments(saveAppointmentsRequest, options) {
            return localVarFp.saveAppointments(saveAppointmentsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {CommunicationChannel} communicationChannel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCommunicationChannels(communicationChannel, options) {
            return localVarFp.saveCommunicationChannels(communicationChannel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {CompanyClosingTime} companyClosingTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompanyClosingTimes(companyClosingTime, options) {
            return localVarFp.saveCompanyClosingTimes(companyClosingTime, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {Service} service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveServices(service, options) {
            return localVarFp.saveServices(service, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {TimeSlot} timeSlot
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTimeSlots(timeSlot, options) {
            return localVarFp.saveTimeSlots(timeSlot, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AppointmentsApi - object-oriented interface
 * @export
 * @class AppointmentsApi
 * @extends {BaseAPI}
 */
export class AppointmentsApi extends BaseAPI {
    /**
     *
     * @summary delete
     * @param {number} adviserClosingTimeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    deleteAdviserClosingTimes(adviserClosingTimeId, options) {
        return AppointmentsApiFp(this.configuration).deleteAdviserClosingTimes(adviserClosingTimeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary delete
     * @param {number} appointmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    deleteAppointment(appointmentId, options) {
        return AppointmentsApiFp(this.configuration).deleteAppointment(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary delete
     * @param {number} communicationChannelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    deleteCommunicationChannel(communicationChannelId, options) {
        return AppointmentsApiFp(this.configuration).deleteCommunicationChannel(communicationChannelId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary delete
     * @param {number} companyClosingTimeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    deleteCompanyClosingTime(companyClosingTimeId, options) {
        return AppointmentsApiFp(this.configuration).deleteCompanyClosingTime(companyClosingTimeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary delete
     * @param {number} serviceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    deleteService(serviceId, options) {
        return AppointmentsApiFp(this.configuration).deleteService(serviceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary delete
     * @param {number} timeSlotId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    deleteTimeSlots(timeSlotId, options) {
        return AppointmentsApiFp(this.configuration).deleteTimeSlots(timeSlotId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get single adviser closing times
     * @param {number} adviserclosingtimesId adviser closing time id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    getAdviserClosingTime(adviserclosingtimesId, options) {
        return AppointmentsApiFp(this.configuration).getAdviserClosingTime(adviserclosingtimesId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get all adviser closing times
     * @param {number} [startDatetime] adviser closing times from date
     * @param {number} [endDatetime] adviser closing times to date
     * @param {string} [userId] user to get closing times from
     * @param {string} [type] type
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    getAllAdviserClosingTimes(startDatetime, endDatetime, userId, type, page, limit, options) {
        return AppointmentsApiFp(this.configuration).getAllAdviserClosingTimes(startDatetime, endDatetime, userId, type, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get all appointments
     * @param {number} [from] appointment from date
     * @param {number} [to] appointment to date
     * @param {Array<AppointmentType>} [type] Appointment types to filter by
     * @param {Array<number>} [adviserId] Adviser IDs to filter by
     * @param {Array<AppointmentStatus>} [status] Appointment statuses to filter by
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    getAllAppointments(from, to, type, adviserId, status, page, limit, options) {
        return AppointmentsApiFp(this.configuration).getAllAppointments(from, to, type, adviserId, status, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get all communication channels
     * @param {number} [page] page nr of requested page
     * @param {'chat' | 'phone' | 'videochat' | 'local'} [ident] communication channels type
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    getAllCommunicationChannels(page, ident, limit, options) {
        return AppointmentsApiFp(this.configuration).getAllCommunicationChannels(page, ident, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get all company closing times
     * @param {number} [from] company closing times from date
     * @param {number} [to] company closing times to date
     * @param {'holiday' | 'other'} [type] type
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    getAllCompanyClosingTimes(from, to, type, page, limit, options) {
        return AppointmentsApiFp(this.configuration).getAllCompanyClosingTimes(from, to, type, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get all services
     * @param {number} [page] page nr of requested page
     * @param {string} [name] service name
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    getAllServices(page, name, limit, options) {
        return AppointmentsApiFp(this.configuration).getAllServices(page, name, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get all time slots
     * @param {string} [startTime] time slot start time
     * @param {string} [endTime] time slot end time
     * @param {number} [weekday] time slot weekday
     * @param {number} [appointmentsServiceId] service id
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    getAllTimeSlots(startTime, endTime, weekday, appointmentsServiceId, page, limit, options) {
        return AppointmentsApiFp(this.configuration).getAllTimeSlots(startTime, endTime, weekday, appointmentsServiceId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get single appointment
     * @param {number} appointmentId appointment id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    getAppointment(appointmentId, options) {
        return AppointmentsApiFp(this.configuration).getAppointment(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get single communication channel
     * @param {number} id communication channel id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    getCommunicationChannel(id, options) {
        return AppointmentsApiFp(this.configuration).getCommunicationChannel(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get single company closing times
     * @param {number} id company closing time id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    getCompanyClosingTime(id, options) {
        return AppointmentsApiFp(this.configuration).getCompanyClosingTime(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get single service
     * @param {number} id service id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    getService(id, options) {
        return AppointmentsApiFp(this.configuration).getService(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get single time slot
     * @param {number} id time slot id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    getTimeSlot(id, options) {
        return AppointmentsApiFp(this.configuration).getTimeSlot(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary list available communication channels
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    listCommunicationChannels(options) {
        return AppointmentsApiFp(this.configuration).listCommunicationChannels(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {AdviserClosingTime} adviserClosingTime
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    saveAdviserClosingTimes(adviserClosingTime, options) {
        return AppointmentsApiFp(this.configuration).saveAdviserClosingTimes(adviserClosingTime, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {SaveAppointmentsRequest} saveAppointmentsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    saveAppointments(saveAppointmentsRequest, options) {
        return AppointmentsApiFp(this.configuration).saveAppointments(saveAppointmentsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {CommunicationChannel} communicationChannel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    saveCommunicationChannels(communicationChannel, options) {
        return AppointmentsApiFp(this.configuration).saveCommunicationChannels(communicationChannel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {CompanyClosingTime} companyClosingTime
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    saveCompanyClosingTimes(companyClosingTime, options) {
        return AppointmentsApiFp(this.configuration).saveCompanyClosingTimes(companyClosingTime, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {Service} service
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    saveServices(service, options) {
        return AppointmentsApiFp(this.configuration).saveServices(service, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {TimeSlot} timeSlot
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    saveTimeSlots(timeSlot, options) {
        return AppointmentsApiFp(this.configuration).saveTimeSlots(timeSlot, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * BeranetUserDataApi - axios parameter creator
 * @export
 */
export const BeranetUserDataApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary delete
         * @param {number} beranetUserDataId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBeranetUserData: (beranetUserDataId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'beranetUserDataId' is not null or undefined
            assertParamExists('deleteBeranetUserData', 'beranetUserDataId', beranetUserDataId);
            const localVarPath = `/backend/api/v1/users/beranet-users/beranet-user-data/delete/{beranetUserDataId}`
                .replace(`{${"beranetUserDataId"}}`, encodeURIComponent(String(beranetUserDataId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get all beranet user data
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {string} [search] search for items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBeranetUserData: (page, limit, search, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/users/beranet-users/beranet-user-data/get-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get all documentations by user id
         * @param {number} clientId
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBeranetUserDataByuserId: (clientId, page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getAllBeranetUserDataByuserId', 'clientId', clientId);
            const localVarPath = `/backend/api/v1/users/beranet-users/beranet-user-data/get-by-client-id/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} beranetUserDataId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBeranetUserData: (beranetUserDataId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'beranetUserDataId' is not null or undefined
            assertParamExists('getBeranetUserData', 'beranetUserDataId', beranetUserDataId);
            const localVarPath = `/backend/api/v1/users/beranet-users/beranet-user-data/get/{beranetUserDataId}`
                .replace(`{${"beranetUserDataId"}}`, encodeURIComponent(String(beranetUserDataId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary saves beranet user data
         * @param {SaveRequest} saveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save: (saveRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'saveRequest' is not null or undefined
            assertParamExists('save', 'saveRequest', saveRequest);
            const localVarPath = `/api/beranet-user-data/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(saveRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {BeranetUserData} beranetUserData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBeranetUserData: (beranetUserData, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'beranetUserData' is not null or undefined
            assertParamExists('saveBeranetUserData', 'beranetUserData', beranetUserData);
            const localVarPath = `/backend/api/v1/users/beranet-users/beranet-user-data/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(beranetUserData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BeranetUserDataApi - functional programming interface
 * @export
 */
export const BeranetUserDataApiFp = function (configuration) {
    const localVarAxiosParamCreator = BeranetUserDataApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} beranetUserDataId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBeranetUserData(beranetUserDataId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteBeranetUserData(beranetUserDataId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get all beranet user data
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {string} [search] search for items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBeranetUserData(page, limit, search, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllBeranetUserData(page, limit, search, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get all documentations by user id
         * @param {number} clientId
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBeranetUserDataByuserId(clientId, page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllBeranetUserDataByuserId(clientId, page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} beranetUserDataId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBeranetUserData(beranetUserDataId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBeranetUserData(beranetUserDataId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary saves beranet user data
         * @param {SaveRequest} saveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save(saveRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.save(saveRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {BeranetUserData} beranetUserData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBeranetUserData(beranetUserData, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveBeranetUserData(beranetUserData, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BeranetUserDataApi - factory interface
 * @export
 */
export const BeranetUserDataApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BeranetUserDataApiFp(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} beranetUserDataId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBeranetUserData(beranetUserDataId, options) {
            return localVarFp.deleteBeranetUserData(beranetUserDataId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get all beranet user data
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {string} [search] search for items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBeranetUserData(page, limit, search, options) {
            return localVarFp.getAllBeranetUserData(page, limit, search, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get all documentations by user id
         * @param {number} clientId
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBeranetUserDataByuserId(clientId, page, limit, options) {
            return localVarFp.getAllBeranetUserDataByuserId(clientId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} beranetUserDataId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBeranetUserData(beranetUserDataId, options) {
            return localVarFp.getBeranetUserData(beranetUserDataId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary saves beranet user data
         * @param {SaveRequest} saveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save(saveRequest, options) {
            return localVarFp.save(saveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {BeranetUserData} beranetUserData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBeranetUserData(beranetUserData, options) {
            return localVarFp.saveBeranetUserData(beranetUserData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BeranetUserDataApi - object-oriented interface
 * @export
 * @class BeranetUserDataApi
 * @extends {BaseAPI}
 */
export class BeranetUserDataApi extends BaseAPI {
    /**
     *
     * @summary delete
     * @param {number} beranetUserDataId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeranetUserDataApi
     */
    deleteBeranetUserData(beranetUserDataId, options) {
        return BeranetUserDataApiFp(this.configuration).deleteBeranetUserData(beranetUserDataId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get all beranet user data
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {string} [search] search for items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeranetUserDataApi
     */
    getAllBeranetUserData(page, limit, search, options) {
        return BeranetUserDataApiFp(this.configuration).getAllBeranetUserData(page, limit, search, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get all documentations by user id
     * @param {number} clientId
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeranetUserDataApi
     */
    getAllBeranetUserDataByuserId(clientId, page, limit, options) {
        return BeranetUserDataApiFp(this.configuration).getAllBeranetUserDataByuserId(clientId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} beranetUserDataId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeranetUserDataApi
     */
    getBeranetUserData(beranetUserDataId, options) {
        return BeranetUserDataApiFp(this.configuration).getBeranetUserData(beranetUserDataId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary saves beranet user data
     * @param {SaveRequest} saveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeranetUserDataApi
     */
    save(saveRequest, options) {
        return BeranetUserDataApiFp(this.configuration).save(saveRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {BeranetUserData} beranetUserData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeranetUserDataApi
     */
    saveBeranetUserData(beranetUserData, options) {
        return BeranetUserDataApiFp(this.configuration).saveBeranetUserData(beranetUserData, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * BeranetUsersApi - axios parameter creator
 * @export
 */
export const BeranetUsersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary get all beranet users
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {string} [search] search for items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBeranetUsers: (page, limit, search, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/users/beranet-users/get-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} beranetUsersId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBeranetUsers: (beranetUsersId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'beranetUsersId' is not null or undefined
            assertParamExists('getBeranetUsers', 'beranetUsersId', beranetUsersId);
            const localVarPath = `/backend/api/v1/users/beranet-users/get/{beranetUsersId}`
                .replace(`{${"beranetUsersId"}}`, encodeURIComponent(String(beranetUsersId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {BeranetUser} beranetUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBeranetUser: (beranetUser, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'beranetUser' is not null or undefined
            assertParamExists('saveBeranetUser', 'beranetUser', beranetUser);
            const localVarPath = `/backend/api/v1/users/beranet-users/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(beranetUser, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BeranetUsersApi - functional programming interface
 * @export
 */
export const BeranetUsersApiFp = function (configuration) {
    const localVarAxiosParamCreator = BeranetUsersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary get all beranet users
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {string} [search] search for items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBeranetUsers(page, limit, search, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllBeranetUsers(page, limit, search, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} beranetUsersId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBeranetUsers(beranetUsersId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBeranetUsers(beranetUsersId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {BeranetUser} beranetUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBeranetUser(beranetUser, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveBeranetUser(beranetUser, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BeranetUsersApi - factory interface
 * @export
 */
export const BeranetUsersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BeranetUsersApiFp(configuration);
    return {
        /**
         *
         * @summary get all beranet users
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {string} [search] search for items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBeranetUsers(page, limit, search, options) {
            return localVarFp.getAllBeranetUsers(page, limit, search, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} beranetUsersId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBeranetUsers(beranetUsersId, options) {
            return localVarFp.getBeranetUsers(beranetUsersId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {BeranetUser} beranetUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBeranetUser(beranetUser, options) {
            return localVarFp.saveBeranetUser(beranetUser, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BeranetUsersApi - object-oriented interface
 * @export
 * @class BeranetUsersApi
 * @extends {BaseAPI}
 */
export class BeranetUsersApi extends BaseAPI {
    /**
     *
     * @summary get all beranet users
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {string} [search] search for items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeranetUsersApi
     */
    getAllBeranetUsers(page, limit, search, options) {
        return BeranetUsersApiFp(this.configuration).getAllBeranetUsers(page, limit, search, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} beranetUsersId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeranetUsersApi
     */
    getBeranetUsers(beranetUsersId, options) {
        return BeranetUsersApiFp(this.configuration).getBeranetUsers(beranetUsersId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {BeranetUser} beranetUser
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeranetUsersApi
     */
    saveBeranetUser(beranetUser, options) {
        return BeranetUsersApiFp(this.configuration).saveBeranetUser(beranetUser, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ClientsApi - axios parameter creator
 * @export
 */
export const ClientsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Add a new client
         * @param {NewClientInfo} [newClientInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClient: (newClientInfo, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/clients/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(newClientInfo, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Block a user
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockUser: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('blockUser', 'userId', userId);
            const localVarPath = `/backend/api/v1/clients/block/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Unblock a user
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockUser: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('unblockUser', 'userId', userId);
            const localVarPath = `/backend/api/v1/clients/unblock/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ClientsApi - functional programming interface
 * @export
 */
export const ClientsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ClientsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Add a new client
         * @param {NewClientInfo} [newClientInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClient(newClientInfo, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addClient(newClientInfo, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Block a user
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockUser(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.blockUser(userId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Unblock a user
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockUser(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.unblockUser(userId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ClientsApi - factory interface
 * @export
 */
export const ClientsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ClientsApiFp(configuration);
    return {
        /**
         *
         * @summary Add a new client
         * @param {NewClientInfo} [newClientInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClient(newClientInfo, options) {
            return localVarFp.addClient(newClientInfo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Block a user
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockUser(userId, options) {
            return localVarFp.blockUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Unblock a user
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockUser(userId, options) {
            return localVarFp.unblockUser(userId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ClientsApi - object-oriented interface
 * @export
 * @class ClientsApi
 * @extends {BaseAPI}
 */
export class ClientsApi extends BaseAPI {
    /**
     *
     * @summary Add a new client
     * @param {NewClientInfo} [newClientInfo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    addClient(newClientInfo, options) {
        return ClientsApiFp(this.configuration).addClient(newClientInfo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Block a user
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    blockUser(userId, options) {
        return ClientsApiFp(this.configuration).blockUser(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Unblock a user
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    unblockUser(userId, options) {
        return ClientsApiFp(this.configuration).unblockUser(userId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CompanyApi - axios parameter creator
 * @export
 */
export const CompanyApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary get
         * @param {number} addressId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddress: (addressId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('getAddress', 'addressId', addressId);
            const localVarPath = `/backend/api/v1/company/addresses/get/{addressId}`
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get all agreements
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAddresses: (page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/company/addresses/get-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get all
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBankings: (page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/company/banking/get-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get all agreements
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {string} [search] search for items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompanies: (page, limit, search, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/company/get-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get all agreements
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompanyAgreements: (page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/company/agreements/get-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get all agreements
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllContacts: (page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/company/contacts/get-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get all
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {number} [companyId] companyId of history
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMaskHistory: (page, limit, companyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/company/masks/mask-history/get-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get all
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMaskTemplate: (page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/company/masks/mask-template/get-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get assisto config
         * @param {number} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssistoConfig: (companyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getAssistoConfig', 'companyId', companyId);
            const localVarPath = `/backend/api/v1/company/get-assisto-config/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} bankingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBanking: (bankingId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'bankingId' is not null or undefined
            assertParamExists('getBanking', 'bankingId', bankingId);
            const localVarPath = `/backend/api/v1/company/banking/get/{bankingId}`
                .replace(`{${"bankingId"}}`, encodeURIComponent(String(bankingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany: (companyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getCompany', 'companyId', companyId);
            const localVarPath = `/backend/api/v1/company/get/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} agreementId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAgreement: (agreementId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('getCompanyAgreement', 'agreementId', agreementId);
            const localVarPath = `/backend/api/v1/company/agreements/get/{agreementId}`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get a beranet config of a given company
         * @param {number} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyBeranetConfig: (companyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getCompanyBeranetConfig', 'companyId', companyId);
            const localVarPath = `/backend/api/v1/company/get-beranet-config/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyConfig: (companyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getCompanyConfig', 'companyId', companyId);
            const localVarPath = `/backend/api/v1/company/get-config/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} contactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContact: (contactId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('getContact', 'contactId', contactId);
            const localVarPath = `/backend/api/v1/company/contacts/get/{contactId}`
                .replace(`{${"contactId"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} maskHistoryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaskHistory: (maskHistoryId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'maskHistoryId' is not null or undefined
            assertParamExists('getMaskHistory', 'maskHistoryId', maskHistoryId);
            const localVarPath = `/backend/api/v1/company/masks/mask-history/get/{maskHistoryId}`
                .replace(`{${"maskHistoryId"}}`, encodeURIComponent(String(maskHistoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} maskTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaskTemplate: (maskTemplateId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'maskTemplateId' is not null or undefined
            assertParamExists('getMaskTemplate', 'maskTemplateId', maskTemplateId);
            const localVarPath = `/backend/api/v1/company/masks/mask-template/get/{maskTemplateId}`
                .replace(`{${"maskTemplateId"}}`, encodeURIComponent(String(maskTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get static text from company
         * @param {string} staticType
         * @param {number} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticText: (staticType, companyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'staticType' is not null or undefined
            assertParamExists('getStaticText', 'staticType', staticType);
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getStaticText', 'companyId', companyId);
            const localVarPath = `/backend/api/v1/company/get-static-text/{staticType}/{companyId}`
                .replace(`{${"staticType"}}`, encodeURIComponent(String(staticType)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {Company} company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompany: (company, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'company' is not null or undefined
            assertParamExists('saveCompany', 'company', company);
            const localVarPath = `/backend/api/v1/company/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(company, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {CompanyAddress} companyAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompanyAddresses: (companyAddress, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyAddress' is not null or undefined
            assertParamExists('saveCompanyAddresses', 'companyAddress', companyAddress);
            const localVarPath = `/backend/api/v1/company/addresses/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(companyAddress, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {CompanyAgreement} companyAgreement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompanyAgreements: (companyAgreement, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyAgreement' is not null or undefined
            assertParamExists('saveCompanyAgreements', 'companyAgreement', companyAgreement);
            const localVarPath = `/backend/api/v1/company/agreements/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(companyAgreement, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {CompanyBanking} companyBanking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompanyBankings: (companyBanking, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyBanking' is not null or undefined
            assertParamExists('saveCompanyBankings', 'companyBanking', companyBanking);
            const localVarPath = `/backend/api/v1/company/banking/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(companyBanking, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save a beranet config of a given company
         * @param {BeranetConfig} beranetConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompanyBeranetConfig: (beranetConfig, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'beranetConfig' is not null or undefined
            assertParamExists('saveCompanyBeranetConfig', 'beranetConfig', beranetConfig);
            const localVarPath = `/backend/api/v1/company/save-beranet-config/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(beranetConfig, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {CompanyContact} companyContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompanyContacts: (companyContact, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyContact' is not null or undefined
            assertParamExists('saveCompanyContacts', 'companyContact', companyContact);
            const localVarPath = `/backend/api/v1/company/contacts/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(companyContact, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {MaskHistory} maskHistory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMaskHistory: (maskHistory, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'maskHistory' is not null or undefined
            assertParamExists('saveMaskHistory', 'maskHistory', maskHistory);
            const localVarPath = `/backend/api/v1/company/masks/mask-history/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(maskHistory, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {MaskTemplate} maskTemplate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMaskTemplate: (maskTemplate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'maskTemplate' is not null or undefined
            assertParamExists('saveMaskTemplate', 'maskTemplate', maskTemplate);
            const localVarPath = `/backend/api/v1/company/masks/mask-template/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(maskTemplate, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary set active or not of global notifications
         * @param {string} status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGlobalNotificationConfig: (status, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'status' is not null or undefined
            assertParamExists('setGlobalNotificationConfig', 'status', status);
            const localVarPath = `/backend/api/v1/company/set-global-notification-config/{status}`
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary upgrade config of company
         * @param {Company} company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upgradeCompanyConfig: (company, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'company' is not null or undefined
            assertParamExists('upgradeCompanyConfig', 'company', company);
            const localVarPath = `/backend/api/v1/company/upgrade-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(company, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary upgrade data of a given company
         * @param {Company} company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upgradeCompanyData: (company, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'company' is not null or undefined
            assertParamExists('upgradeCompanyData', 'company', company);
            const localVarPath = `/backend/api/v1/company/upgrade-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(company, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CompanyApi - functional programming interface
 * @export
 */
export const CompanyApiFp = function (configuration) {
    const localVarAxiosParamCreator = CompanyApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary get
         * @param {number} addressId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddress(addressId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAddress(addressId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get all agreements
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAddresses(page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllAddresses(page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get all
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBankings(page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllBankings(page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get all agreements
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {string} [search] search for items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompanies(page, limit, search, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllCompanies(page, limit, search, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get all agreements
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompanyAgreements(page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllCompanyAgreements(page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get all agreements
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllContacts(page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllContacts(page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get all
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {number} [companyId] companyId of history
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMaskHistory(page, limit, companyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllMaskHistory(page, limit, companyId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get all
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMaskTemplate(page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllMaskTemplate(page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get assisto config
         * @param {number} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssistoConfig(companyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAssistoConfig(companyId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} bankingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBanking(bankingId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBanking(bankingId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany(companyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompany(companyId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} agreementId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAgreement(agreementId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompanyAgreement(agreementId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get a beranet config of a given company
         * @param {number} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyBeranetConfig(companyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompanyBeranetConfig(companyId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyConfig(companyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompanyConfig(companyId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} contactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContact(contactId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getContact(contactId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} maskHistoryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaskHistory(maskHistoryId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMaskHistory(maskHistoryId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} maskTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaskTemplate(maskTemplateId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMaskTemplate(maskTemplateId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get static text from company
         * @param {string} staticType
         * @param {number} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticText(staticType, companyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStaticText(staticType, companyId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {Company} company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompany(company, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveCompany(company, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {CompanyAddress} companyAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompanyAddresses(companyAddress, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveCompanyAddresses(companyAddress, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {CompanyAgreement} companyAgreement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompanyAgreements(companyAgreement, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveCompanyAgreements(companyAgreement, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {CompanyBanking} companyBanking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompanyBankings(companyBanking, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveCompanyBankings(companyBanking, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save a beranet config of a given company
         * @param {BeranetConfig} beranetConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompanyBeranetConfig(beranetConfig, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveCompanyBeranetConfig(beranetConfig, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {CompanyContact} companyContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompanyContacts(companyContact, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveCompanyContacts(companyContact, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {MaskHistory} maskHistory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMaskHistory(maskHistory, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveMaskHistory(maskHistory, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {MaskTemplate} maskTemplate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMaskTemplate(maskTemplate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveMaskTemplate(maskTemplate, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary set active or not of global notifications
         * @param {string} status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGlobalNotificationConfig(status, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setGlobalNotificationConfig(status, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary upgrade config of company
         * @param {Company} company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upgradeCompanyConfig(company, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.upgradeCompanyConfig(company, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary upgrade data of a given company
         * @param {Company} company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upgradeCompanyData(company, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.upgradeCompanyData(company, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CompanyApi - factory interface
 * @export
 */
export const CompanyApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CompanyApiFp(configuration);
    return {
        /**
         *
         * @summary get
         * @param {number} addressId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddress(addressId, options) {
            return localVarFp.getAddress(addressId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get all agreements
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAddresses(page, limit, options) {
            return localVarFp.getAllAddresses(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get all
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBankings(page, limit, options) {
            return localVarFp.getAllBankings(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get all agreements
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {string} [search] search for items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompanies(page, limit, search, options) {
            return localVarFp.getAllCompanies(page, limit, search, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get all agreements
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompanyAgreements(page, limit, options) {
            return localVarFp.getAllCompanyAgreements(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get all agreements
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllContacts(page, limit, options) {
            return localVarFp.getAllContacts(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get all
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {number} [companyId] companyId of history
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMaskHistory(page, limit, companyId, options) {
            return localVarFp.getAllMaskHistory(page, limit, companyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get all
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMaskTemplate(page, limit, options) {
            return localVarFp.getAllMaskTemplate(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get assisto config
         * @param {number} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssistoConfig(companyId, options) {
            return localVarFp.getAssistoConfig(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} bankingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBanking(bankingId, options) {
            return localVarFp.getBanking(bankingId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany(companyId, options) {
            return localVarFp.getCompany(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} agreementId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAgreement(agreementId, options) {
            return localVarFp.getCompanyAgreement(agreementId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get a beranet config of a given company
         * @param {number} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyBeranetConfig(companyId, options) {
            return localVarFp.getCompanyBeranetConfig(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyConfig(companyId, options) {
            return localVarFp.getCompanyConfig(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} contactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContact(contactId, options) {
            return localVarFp.getContact(contactId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} maskHistoryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaskHistory(maskHistoryId, options) {
            return localVarFp.getMaskHistory(maskHistoryId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} maskTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaskTemplate(maskTemplateId, options) {
            return localVarFp.getMaskTemplate(maskTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get static text from company
         * @param {string} staticType
         * @param {number} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticText(staticType, companyId, options) {
            return localVarFp.getStaticText(staticType, companyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {Company} company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompany(company, options) {
            return localVarFp.saveCompany(company, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {CompanyAddress} companyAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompanyAddresses(companyAddress, options) {
            return localVarFp.saveCompanyAddresses(companyAddress, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {CompanyAgreement} companyAgreement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompanyAgreements(companyAgreement, options) {
            return localVarFp.saveCompanyAgreements(companyAgreement, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {CompanyBanking} companyBanking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompanyBankings(companyBanking, options) {
            return localVarFp.saveCompanyBankings(companyBanking, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save a beranet config of a given company
         * @param {BeranetConfig} beranetConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompanyBeranetConfig(beranetConfig, options) {
            return localVarFp.saveCompanyBeranetConfig(beranetConfig, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {CompanyContact} companyContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompanyContacts(companyContact, options) {
            return localVarFp.saveCompanyContacts(companyContact, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {MaskHistory} maskHistory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMaskHistory(maskHistory, options) {
            return localVarFp.saveMaskHistory(maskHistory, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {MaskTemplate} maskTemplate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMaskTemplate(maskTemplate, options) {
            return localVarFp.saveMaskTemplate(maskTemplate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary set active or not of global notifications
         * @param {string} status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGlobalNotificationConfig(status, options) {
            return localVarFp.setGlobalNotificationConfig(status, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary upgrade config of company
         * @param {Company} company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upgradeCompanyConfig(company, options) {
            return localVarFp.upgradeCompanyConfig(company, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary upgrade data of a given company
         * @param {Company} company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upgradeCompanyData(company, options) {
            return localVarFp.upgradeCompanyData(company, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CompanyApi - object-oriented interface
 * @export
 * @class CompanyApi
 * @extends {BaseAPI}
 */
export class CompanyApi extends BaseAPI {
    /**
     *
     * @summary get
     * @param {number} addressId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getAddress(addressId, options) {
        return CompanyApiFp(this.configuration).getAddress(addressId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get all agreements
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getAllAddresses(page, limit, options) {
        return CompanyApiFp(this.configuration).getAllAddresses(page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get all
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getAllBankings(page, limit, options) {
        return CompanyApiFp(this.configuration).getAllBankings(page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get all agreements
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {string} [search] search for items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getAllCompanies(page, limit, search, options) {
        return CompanyApiFp(this.configuration).getAllCompanies(page, limit, search, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get all agreements
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getAllCompanyAgreements(page, limit, options) {
        return CompanyApiFp(this.configuration).getAllCompanyAgreements(page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get all agreements
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getAllContacts(page, limit, options) {
        return CompanyApiFp(this.configuration).getAllContacts(page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get all
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {number} [companyId] companyId of history
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getAllMaskHistory(page, limit, companyId, options) {
        return CompanyApiFp(this.configuration).getAllMaskHistory(page, limit, companyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get all
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getAllMaskTemplate(page, limit, options) {
        return CompanyApiFp(this.configuration).getAllMaskTemplate(page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get assisto config
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getAssistoConfig(companyId, options) {
        return CompanyApiFp(this.configuration).getAssistoConfig(companyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} bankingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getBanking(bankingId, options) {
        return CompanyApiFp(this.configuration).getBanking(bankingId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getCompany(companyId, options) {
        return CompanyApiFp(this.configuration).getCompany(companyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} agreementId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getCompanyAgreement(agreementId, options) {
        return CompanyApiFp(this.configuration).getCompanyAgreement(agreementId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get a beranet config of a given company
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getCompanyBeranetConfig(companyId, options) {
        return CompanyApiFp(this.configuration).getCompanyBeranetConfig(companyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getCompanyConfig(companyId, options) {
        return CompanyApiFp(this.configuration).getCompanyConfig(companyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} contactId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getContact(contactId, options) {
        return CompanyApiFp(this.configuration).getContact(contactId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} maskHistoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getMaskHistory(maskHistoryId, options) {
        return CompanyApiFp(this.configuration).getMaskHistory(maskHistoryId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} maskTemplateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getMaskTemplate(maskTemplateId, options) {
        return CompanyApiFp(this.configuration).getMaskTemplate(maskTemplateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get static text from company
     * @param {string} staticType
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getStaticText(staticType, companyId, options) {
        return CompanyApiFp(this.configuration).getStaticText(staticType, companyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {Company} company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    saveCompany(company, options) {
        return CompanyApiFp(this.configuration).saveCompany(company, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {CompanyAddress} companyAddress
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    saveCompanyAddresses(companyAddress, options) {
        return CompanyApiFp(this.configuration).saveCompanyAddresses(companyAddress, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {CompanyAgreement} companyAgreement
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    saveCompanyAgreements(companyAgreement, options) {
        return CompanyApiFp(this.configuration).saveCompanyAgreements(companyAgreement, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {CompanyBanking} companyBanking
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    saveCompanyBankings(companyBanking, options) {
        return CompanyApiFp(this.configuration).saveCompanyBankings(companyBanking, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save a beranet config of a given company
     * @param {BeranetConfig} beranetConfig
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    saveCompanyBeranetConfig(beranetConfig, options) {
        return CompanyApiFp(this.configuration).saveCompanyBeranetConfig(beranetConfig, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {CompanyContact} companyContact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    saveCompanyContacts(companyContact, options) {
        return CompanyApiFp(this.configuration).saveCompanyContacts(companyContact, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {MaskHistory} maskHistory
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    saveMaskHistory(maskHistory, options) {
        return CompanyApiFp(this.configuration).saveMaskHistory(maskHistory, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {MaskTemplate} maskTemplate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    saveMaskTemplate(maskTemplate, options) {
        return CompanyApiFp(this.configuration).saveMaskTemplate(maskTemplate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary set active or not of global notifications
     * @param {string} status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    setGlobalNotificationConfig(status, options) {
        return CompanyApiFp(this.configuration).setGlobalNotificationConfig(status, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary upgrade config of company
     * @param {Company} company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    upgradeCompanyConfig(company, options) {
        return CompanyApiFp(this.configuration).upgradeCompanyConfig(company, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary upgrade data of a given company
     * @param {Company} company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    upgradeCompanyData(company, options) {
        return CompanyApiFp(this.configuration).upgradeCompanyData(company, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CompanyProductsApi - axios parameter creator
 * @export
 */
export const CompanyProductsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary save
         * @param {CompanyProduct} companyProduct
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyProducts: (companyProduct, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProduct' is not null or undefined
            assertParamExists('createCompanyProducts', 'companyProduct', companyProduct);
            const localVarPath = `/backend/api/v1/products/company/create/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(companyProduct, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {CompanyProduct} companyProduct
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPresetCompanyProducts: (companyProduct, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProduct' is not null or undefined
            assertParamExists('createPresetCompanyProducts', 'companyProduct', companyProduct);
            const localVarPath = `/backend/api/v1/products/company/create-preset/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(companyProduct, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary delete
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyProduct: (companyProductId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('deleteCompanyProduct', 'companyProductId', companyProductId);
            const localVarPath = `/backend/api/v1/products/company/delete/{companyProductId}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get all company products
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {string} [search] search for items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompanyProducts: (page, limit, search, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/products/company/get-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyProduct: (companyProductId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getCompanyProduct', 'companyProductId', companyProductId);
            const localVarPath = `/backend/api/v1/products/company/get/{companyProductId}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {number} compositeId
         * @param {string} [zipCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsByComposite: (compositeId, zipCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'compositeId' is not null or undefined
            assertParamExists('getProductsByComposite', 'compositeId', compositeId);
            const localVarPath = `/backend/api/v1/products/company/get-products-by-composite/{compositeId}/`
                .replace(`{${"compositeId"}}`, encodeURIComponent(String(compositeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (zipCode !== undefined) {
                localVarQueryParameter['zipCode'] = zipCode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {CompanyProduct} companyProduct
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompanyProducts: (companyProduct, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProduct' is not null or undefined
            assertParamExists('saveCompanyProducts', 'companyProduct', companyProduct);
            const localVarPath = `/backend/api/v1/products/company/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(companyProduct, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CompanyProductsApi - functional programming interface
 * @export
 */
export const CompanyProductsApiFp = function (configuration) {
    const localVarAxiosParamCreator = CompanyProductsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary save
         * @param {CompanyProduct} companyProduct
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyProducts(companyProduct, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createCompanyProducts(companyProduct, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {CompanyProduct} companyProduct
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPresetCompanyProducts(companyProduct, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createPresetCompanyProducts(companyProduct, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary delete
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyProduct(companyProductId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteCompanyProduct(companyProductId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get all company products
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {string} [search] search for items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompanyProducts(page, limit, search, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllCompanyProducts(page, limit, search, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyProduct(companyProductId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompanyProduct(companyProductId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {number} compositeId
         * @param {string} [zipCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsByComposite(compositeId, zipCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductsByComposite(compositeId, zipCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {CompanyProduct} companyProduct
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompanyProducts(companyProduct, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveCompanyProducts(companyProduct, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CompanyProductsApi - factory interface
 * @export
 */
export const CompanyProductsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CompanyProductsApiFp(configuration);
    return {
        /**
         *
         * @summary save
         * @param {CompanyProduct} companyProduct
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyProducts(companyProduct, options) {
            return localVarFp.createCompanyProducts(companyProduct, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {CompanyProduct} companyProduct
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPresetCompanyProducts(companyProduct, options) {
            return localVarFp.createPresetCompanyProducts(companyProduct, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary delete
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyProduct(companyProductId, options) {
            return localVarFp.deleteCompanyProduct(companyProductId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get all company products
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {string} [search] search for items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompanyProducts(page, limit, search, options) {
            return localVarFp.getAllCompanyProducts(page, limit, search, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyProduct(companyProductId, options) {
            return localVarFp.getCompanyProduct(companyProductId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {number} compositeId
         * @param {string} [zipCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsByComposite(compositeId, zipCode, options) {
            return localVarFp.getProductsByComposite(compositeId, zipCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {CompanyProduct} companyProduct
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompanyProducts(companyProduct, options) {
            return localVarFp.saveCompanyProducts(companyProduct, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CompanyProductsApi - object-oriented interface
 * @export
 * @class CompanyProductsApi
 * @extends {BaseAPI}
 */
export class CompanyProductsApi extends BaseAPI {
    /**
     *
     * @summary save
     * @param {CompanyProduct} companyProduct
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyProductsApi
     */
    createCompanyProducts(companyProduct, options) {
        return CompanyProductsApiFp(this.configuration).createCompanyProducts(companyProduct, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {CompanyProduct} companyProduct
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyProductsApi
     */
    createPresetCompanyProducts(companyProduct, options) {
        return CompanyProductsApiFp(this.configuration).createPresetCompanyProducts(companyProduct, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary delete
     * @param {number} companyProductId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyProductsApi
     */
    deleteCompanyProduct(companyProductId, options) {
        return CompanyProductsApiFp(this.configuration).deleteCompanyProduct(companyProductId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get all company products
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {string} [search] search for items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyProductsApi
     */
    getAllCompanyProducts(page, limit, search, options) {
        return CompanyProductsApiFp(this.configuration).getAllCompanyProducts(page, limit, search, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} companyProductId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyProductsApi
     */
    getCompanyProduct(companyProductId, options) {
        return CompanyProductsApiFp(this.configuration).getCompanyProduct(companyProductId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {number} compositeId
     * @param {string} [zipCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyProductsApi
     */
    getProductsByComposite(compositeId, zipCode, options) {
        return CompanyProductsApiFp(this.configuration).getProductsByComposite(compositeId, zipCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {CompanyProduct} companyProduct
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyProductsApi
     */
    saveCompanyProducts(companyProduct, options) {
        return CompanyProductsApiFp(this.configuration).saveCompanyProducts(companyProduct, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CompositesApi - axios parameter creator
 * @export
 */
export const CompositesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary delete
         * @param {number} compositeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComposites: (compositeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'compositeId' is not null or undefined
            assertParamExists('deleteComposites', 'compositeId', compositeId);
            const localVarPath = `/backend/api/v1/composites/delete/{compositeId}`
                .replace(`{${"compositeId"}}`, encodeURIComponent(String(compositeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary fill product data by composite id
         * @param {number} compositeId
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fillProductDataFromPreset: (compositeId, companyProductId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'compositeId' is not null or undefined
            assertParamExists('fillProductDataFromPreset', 'compositeId', compositeId);
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('fillProductDataFromPreset', 'companyProductId', companyProductId);
            const localVarPath = `/backend/api/v1/composites/fill-product-data-from-preset/{compositeId}/{companyProductId}`
                .replace(`{${"compositeId"}}`, encodeURIComponent(String(compositeId)))
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get all composites
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllComposites: (page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/composites/get-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {string} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIdentifier: (identifier, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'identifier' is not null or undefined
            assertParamExists('getByIdentifier', 'identifier', identifier);
            const localVarPath = `/backend/api/v1/composites/get-by-identifier/{identifier}`
                .replace(`{${"identifier"}}`, encodeURIComponent(String(identifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} compositeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComposite: (compositeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'compositeId' is not null or undefined
            assertParamExists('getComposite', 'compositeId', compositeId);
            const localVarPath = `/backend/api/v1/composites/get/{compositeId}`
                .replace(`{${"compositeId"}}`, encodeURIComponent(String(compositeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get by product id
         * @param {number} productId
         * @param {number} [page] page number for requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompositesByProductId: (productId, page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getCompositesByProductId', 'productId', productId);
            const localVarPath = `/backend/api/v1/composites/get-by-product-id/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save all composites
         * @param {Array<Composite>} composite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllComposites: (composite, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'composite' is not null or undefined
            assertParamExists('saveAllComposites', 'composite', composite);
            const localVarPath = `/backend/api/v1/composites/save-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(composite, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {Composite} composite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveComposite: (composite, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'composite' is not null or undefined
            assertParamExists('saveComposite', 'composite', composite);
            const localVarPath = `/backend/api/v1/composites/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(composite, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CompositesApi - functional programming interface
 * @export
 */
export const CompositesApiFp = function (configuration) {
    const localVarAxiosParamCreator = CompositesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} compositeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComposites(compositeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteComposites(compositeId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary fill product data by composite id
         * @param {number} compositeId
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fillProductDataFromPreset(compositeId, companyProductId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fillProductDataFromPreset(compositeId, companyProductId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get all composites
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllComposites(page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllComposites(page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {string} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIdentifier(identifier, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getByIdentifier(identifier, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} compositeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComposite(compositeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getComposite(compositeId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get by product id
         * @param {number} productId
         * @param {number} [page] page number for requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompositesByProductId(productId, page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompositesByProductId(productId, page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save all composites
         * @param {Array<Composite>} composite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllComposites(composite, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveAllComposites(composite, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {Composite} composite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveComposite(composite, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveComposite(composite, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CompositesApi - factory interface
 * @export
 */
export const CompositesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CompositesApiFp(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} compositeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComposites(compositeId, options) {
            return localVarFp.deleteComposites(compositeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary fill product data by composite id
         * @param {number} compositeId
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fillProductDataFromPreset(compositeId, companyProductId, options) {
            return localVarFp.fillProductDataFromPreset(compositeId, companyProductId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get all composites
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllComposites(page, limit, options) {
            return localVarFp.getAllComposites(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {string} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIdentifier(identifier, options) {
            return localVarFp.getByIdentifier(identifier, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} compositeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComposite(compositeId, options) {
            return localVarFp.getComposite(compositeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get by product id
         * @param {number} productId
         * @param {number} [page] page number for requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompositesByProductId(productId, page, limit, options) {
            return localVarFp.getCompositesByProductId(productId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save all composites
         * @param {Array<Composite>} composite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllComposites(composite, options) {
            return localVarFp.saveAllComposites(composite, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {Composite} composite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveComposite(composite, options) {
            return localVarFp.saveComposite(composite, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CompositesApi - object-oriented interface
 * @export
 * @class CompositesApi
 * @extends {BaseAPI}
 */
export class CompositesApi extends BaseAPI {
    /**
     *
     * @summary delete
     * @param {number} compositeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompositesApi
     */
    deleteComposites(compositeId, options) {
        return CompositesApiFp(this.configuration).deleteComposites(compositeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary fill product data by composite id
     * @param {number} compositeId
     * @param {number} companyProductId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompositesApi
     */
    fillProductDataFromPreset(compositeId, companyProductId, options) {
        return CompositesApiFp(this.configuration).fillProductDataFromPreset(compositeId, companyProductId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get all composites
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompositesApi
     */
    getAllComposites(page, limit, options) {
        return CompositesApiFp(this.configuration).getAllComposites(page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {string} identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompositesApi
     */
    getByIdentifier(identifier, options) {
        return CompositesApiFp(this.configuration).getByIdentifier(identifier, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} compositeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompositesApi
     */
    getComposite(compositeId, options) {
        return CompositesApiFp(this.configuration).getComposite(compositeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get by product id
     * @param {number} productId
     * @param {number} [page] page number for requested page
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompositesApi
     */
    getCompositesByProductId(productId, page, limit, options) {
        return CompositesApiFp(this.configuration).getCompositesByProductId(productId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save all composites
     * @param {Array<Composite>} composite
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompositesApi
     */
    saveAllComposites(composite, options) {
        return CompositesApiFp(this.configuration).saveAllComposites(composite, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {Composite} composite
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompositesApi
     */
    saveComposite(composite, options) {
        return CompositesApiFp(this.configuration).saveComposite(composite, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ConsultingTopicsApi - axios parameter creator
 * @export
 */
export const ConsultingTopicsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary get all
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTopics: (page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/company/consulting-topics/get-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} topicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopics: (topicId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('getTopics', 'topicId', topicId);
            const localVarPath = `/backend/api/v1/company/consulting-topics/get/{topicId}`
                .replace(`{${"topicId"}}`, encodeURIComponent(String(topicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {BeranetTopic} beranetTopic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTopic: (beranetTopic, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'beranetTopic' is not null or undefined
            assertParamExists('saveTopic', 'beranetTopic', beranetTopic);
            const localVarPath = `/backend/api/v1/company/consulting-topics/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(beranetTopic, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ConsultingTopicsApi - functional programming interface
 * @export
 */
export const ConsultingTopicsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ConsultingTopicsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary get all
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTopics(page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllTopics(page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} topicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopics(topicId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTopics(topicId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {BeranetTopic} beranetTopic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTopic(beranetTopic, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveTopic(beranetTopic, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ConsultingTopicsApi - factory interface
 * @export
 */
export const ConsultingTopicsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ConsultingTopicsApiFp(configuration);
    return {
        /**
         *
         * @summary get all
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTopics(page, limit, options) {
            return localVarFp.getAllTopics(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} topicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopics(topicId, options) {
            return localVarFp.getTopics(topicId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {BeranetTopic} beranetTopic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTopic(beranetTopic, options) {
            return localVarFp.saveTopic(beranetTopic, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ConsultingTopicsApi - object-oriented interface
 * @export
 * @class ConsultingTopicsApi
 * @extends {BaseAPI}
 */
export class ConsultingTopicsApi extends BaseAPI {
    /**
     *
     * @summary get all
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsultingTopicsApi
     */
    getAllTopics(page, limit, options) {
        return ConsultingTopicsApiFp(this.configuration).getAllTopics(page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} topicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsultingTopicsApi
     */
    getTopics(topicId, options) {
        return ConsultingTopicsApiFp(this.configuration).getTopics(topicId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {BeranetTopic} beranetTopic
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsultingTopicsApi
     */
    saveTopic(beranetTopic, options) {
        return ConsultingTopicsApiFp(this.configuration).saveTopic(beranetTopic, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DocumentsApi - axios parameter creator
 * @export
 */
export const DocumentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary delete
         * @param {number} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocuments: (documentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('deleteDocuments', 'documentId', documentId);
            const localVarPath = `/backend/api/v1/documents/delete/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get documents
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDocumentss: (limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/documents/get-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary getAllFiles
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFiles: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAllFiles', 'userId', userId);
            const localVarPath = `/backend/api/v1/documents/get-all-files/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary getBeraterImg
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBeraterImg: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getBeraterImg', 'userId', userId);
            const localVarPath = `/client/berater-img/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary getDocument
         * @param {string} [document] document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument: (document, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/client/get-document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            if (document !== undefined) {
                localVarQueryParameter['document'] = document;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments: (documentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('getDocuments', 'documentId', documentId);
            const localVarPath = `/backend/api/v1/documents/get/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary getThreadDocument
         * @param {string} [document] document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThreadDocument: (document, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/client/get-thread-document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            if (document !== undefined) {
                localVarQueryParameter['document'] = document;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * liefert ein Dokument Thumbnail zurück
         * @summary getThumbnail
         * @param {string} [file] file id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThumbnail: (file, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/client/get-thumbnail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            if (file !== undefined) {
                localVarQueryParameter['file'] = file;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {Array<Document>} document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllDocuments: (document, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'document' is not null or undefined
            assertParamExists('saveAllDocuments', 'document', document);
            const localVarPath = `/backend/api/v1/documents/save-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(document, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {Document} document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDocuments: (document, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'document' is not null or undefined
            assertParamExists('saveDocuments', 'document', document);
            const localVarPath = `/backend/api/v1/documents/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(document, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary sendDocument
         * @param {number} receiverId receiver id
         * @param {File} file file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendDocument: (receiverId, file, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'receiverId' is not null or undefined
            assertParamExists('sendDocument', 'receiverId', receiverId);
            // verify required parameter 'file' is not null or undefined
            assertParamExists('sendDocument', 'file', file);
            const localVarPath = `/client/document-send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            if (receiverId !== undefined) {
                localVarFormParams.append('receiverId', receiverId);
            }
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary upload Document
         * @param {number} receiverId receiver id
         * @param {File} file file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNewDocument: (receiverId, file, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'receiverId' is not null or undefined
            assertParamExists('sendNewDocument', 'receiverId', receiverId);
            // verify required parameter 'file' is not null or undefined
            assertParamExists('sendNewDocument', 'file', file);
            const localVarPath = `/backend/api/v1/documents/send-file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (receiverId !== undefined) {
                localVarFormParams.append('receiverId', receiverId);
            }
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DocumentsApi - functional programming interface
 * @export
 */
export const DocumentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = DocumentsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocuments(documentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteDocuments(documentId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get documents
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDocumentss(limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllDocumentss(limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary getAllFiles
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFiles(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllFiles(userId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary getBeraterImg
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBeraterImg(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBeraterImg(userId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary getDocument
         * @param {string} [document] document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument(document, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDocument(document, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments(documentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDocuments(documentId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary getThreadDocument
         * @param {string} [document] document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThreadDocument(document, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getThreadDocument(document, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * liefert ein Dokument Thumbnail zurück
         * @summary getThumbnail
         * @param {string} [file] file id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThumbnail(file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getThumbnail(file, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {Array<Document>} document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllDocuments(document, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveAllDocuments(document, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {Document} document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDocuments(document, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveDocuments(document, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary sendDocument
         * @param {number} receiverId receiver id
         * @param {File} file file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendDocument(receiverId, file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendDocument(receiverId, file, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary upload Document
         * @param {number} receiverId receiver id
         * @param {File} file file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNewDocument(receiverId, file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendNewDocument(receiverId, file, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * DocumentsApi - factory interface
 * @export
 */
export const DocumentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DocumentsApiFp(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocuments(documentId, options) {
            return localVarFp.deleteDocuments(documentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get documents
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDocumentss(limit, options) {
            return localVarFp.getAllDocumentss(limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary getAllFiles
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFiles(userId, options) {
            return localVarFp.getAllFiles(userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary getBeraterImg
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBeraterImg(userId, options) {
            return localVarFp.getBeraterImg(userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary getDocument
         * @param {string} [document] document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument(document, options) {
            return localVarFp.getDocument(document, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments(documentId, options) {
            return localVarFp.getDocuments(documentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary getThreadDocument
         * @param {string} [document] document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThreadDocument(document, options) {
            return localVarFp.getThreadDocument(document, options).then((request) => request(axios, basePath));
        },
        /**
         * liefert ein Dokument Thumbnail zurück
         * @summary getThumbnail
         * @param {string} [file] file id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThumbnail(file, options) {
            return localVarFp.getThumbnail(file, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {Array<Document>} document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllDocuments(document, options) {
            return localVarFp.saveAllDocuments(document, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {Document} document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDocuments(document, options) {
            return localVarFp.saveDocuments(document, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary sendDocument
         * @param {number} receiverId receiver id
         * @param {File} file file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendDocument(receiverId, file, options) {
            return localVarFp.sendDocument(receiverId, file, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary upload Document
         * @param {number} receiverId receiver id
         * @param {File} file file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNewDocument(receiverId, file, options) {
            return localVarFp.sendNewDocument(receiverId, file, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DocumentsApi - object-oriented interface
 * @export
 * @class DocumentsApi
 * @extends {BaseAPI}
 */
export class DocumentsApi extends BaseAPI {
    /**
     *
     * @summary delete
     * @param {number} documentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    deleteDocuments(documentId, options) {
        return DocumentsApiFp(this.configuration).deleteDocuments(documentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get documents
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    getAllDocumentss(limit, options) {
        return DocumentsApiFp(this.configuration).getAllDocumentss(limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary getAllFiles
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    getAllFiles(userId, options) {
        return DocumentsApiFp(this.configuration).getAllFiles(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary getBeraterImg
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    getBeraterImg(userId, options) {
        return DocumentsApiFp(this.configuration).getBeraterImg(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary getDocument
     * @param {string} [document] document id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    getDocument(document, options) {
        return DocumentsApiFp(this.configuration).getDocument(document, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} documentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    getDocuments(documentId, options) {
        return DocumentsApiFp(this.configuration).getDocuments(documentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary getThreadDocument
     * @param {string} [document] document id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    getThreadDocument(document, options) {
        return DocumentsApiFp(this.configuration).getThreadDocument(document, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * liefert ein Dokument Thumbnail zurück
     * @summary getThumbnail
     * @param {string} [file] file id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    getThumbnail(file, options) {
        return DocumentsApiFp(this.configuration).getThumbnail(file, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {Array<Document>} document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    saveAllDocuments(document, options) {
        return DocumentsApiFp(this.configuration).saveAllDocuments(document, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {Document} document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    saveDocuments(document, options) {
        return DocumentsApiFp(this.configuration).saveDocuments(document, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary sendDocument
     * @param {number} receiverId receiver id
     * @param {File} file file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    sendDocument(receiverId, file, options) {
        return DocumentsApiFp(this.configuration).sendDocument(receiverId, file, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary upload Document
     * @param {number} receiverId receiver id
     * @param {File} file file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    sendNewDocument(receiverId, file, options) {
        return DocumentsApiFp(this.configuration).sendNewDocument(receiverId, file, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ExercisesApi - axios parameter creator
 * @export
 */
export const ExercisesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary addFavorite
         * @param {number} pageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavorite: (pageId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'pageId' is not null or undefined
            assertParamExists('addFavorite', 'pageId', pageId);
            const localVarPath = `/lessons/api/add-favorite/{pageId}`
                .replace(`{${"pageId"}}`, encodeURIComponent(String(pageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Complete an exercise by updating the finished timestamp
         * @summary finishExercise
         * @param {FinishExerciseRequest} finishExerciseRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishExercise: (finishExerciseRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'finishExerciseRequest' is not null or undefined
            assertParamExists('finishExercise', 'finishExerciseRequest', finishExerciseRequest);
            const localVarPath = `/lessons/api/finish-exercise`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(finishExerciseRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get exercises and items for a company via the session token
         * @summary getCompanyExercises
         * @param {GetCompanyExercisesRequest} getCompanyExercisesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyExercises: (getCompanyExercisesRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'getCompanyExercisesRequest' is not null or undefined
            assertParamExists('getCompanyExercises', 'getCompanyExercisesRequest', getCompanyExercisesRequest);
            const localVarPath = `/lessons/api/get-company-exercises`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getCompanyExercisesRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get an array of answers (inclusive adviser answers) for a user by an exercise
         * @summary getExerciseAnswers
         * @param {number} exerciseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExerciseAnswers: (exerciseId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'exerciseId' is not null or undefined
            assertParamExists('getExerciseAnswers', 'exerciseId', exerciseId);
            const localVarPath = `/lessons/api/get-exercise-answers/{exerciseId}`
                .replace(`{${"exerciseId"}}`, encodeURIComponent(String(exerciseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get an array of exercise items for a user by an exercise id
         * @summary getExerciseItems
         * @param {number} exerciseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExerciseItems: (exerciseId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'exerciseId' is not null or undefined
            assertParamExists('getExerciseItems', 'exerciseId', exerciseId);
            const localVarPath = `/lessons/api/get-exercise-items/{exerciseId}`
                .replace(`{${"exerciseId"}}`, encodeURIComponent(String(exerciseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get array of exercises for a user
         * @summary getExercises
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExercises: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/lessons/api/get-exercises`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary getFavorites
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavorites: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/lessons/api/get-favorites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary removeFavorite
         * @param {number} pageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFavorite: (pageId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'pageId' is not null or undefined
            assertParamExists('removeFavorite', 'pageId', pageId);
            const localVarPath = `/lessons/api/remove-favorite/{pageId}`
                .replace(`{${"pageId"}}`, encodeURIComponent(String(pageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Set/Create answers for items for a user
         * @summary setExerciseAnswers
         * @param {SetExerciseAnswersRequest} setExerciseAnswersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setExerciseAnswers: (setExerciseAnswersRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'setExerciseAnswersRequest' is not null or undefined
            assertParamExists('setExerciseAnswers', 'setExerciseAnswersRequest', setExerciseAnswersRequest);
            const localVarPath = `/lessons/api/set-exercise-answers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(setExerciseAnswersRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Begin an exercise by updating the finished timestamp
         * @summary startExercise
         * @param {FinishExerciseRequest} finishExerciseRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startExercise: (finishExerciseRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'finishExerciseRequest' is not null or undefined
            assertParamExists('startExercise', 'finishExerciseRequest', finishExerciseRequest);
            const localVarPath = `/lessons/api/start-exercise`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(finishExerciseRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ExercisesApi - functional programming interface
 * @export
 */
export const ExercisesApiFp = function (configuration) {
    const localVarAxiosParamCreator = ExercisesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary addFavorite
         * @param {number} pageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavorite(pageId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addFavorite(pageId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Complete an exercise by updating the finished timestamp
         * @summary finishExercise
         * @param {FinishExerciseRequest} finishExerciseRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishExercise(finishExerciseRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.finishExercise(finishExerciseRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Get exercises and items for a company via the session token
         * @summary getCompanyExercises
         * @param {GetCompanyExercisesRequest} getCompanyExercisesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyExercises(getCompanyExercisesRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompanyExercises(getCompanyExercisesRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Get an array of answers (inclusive adviser answers) for a user by an exercise
         * @summary getExerciseAnswers
         * @param {number} exerciseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExerciseAnswers(exerciseId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getExerciseAnswers(exerciseId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Get an array of exercise items for a user by an exercise id
         * @summary getExerciseItems
         * @param {number} exerciseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExerciseItems(exerciseId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getExerciseItems(exerciseId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Get array of exercises for a user
         * @summary getExercises
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExercises(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getExercises(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary getFavorites
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavorites(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getFavorites(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary removeFavorite
         * @param {number} pageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFavorite(pageId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeFavorite(pageId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Set/Create answers for items for a user
         * @summary setExerciseAnswers
         * @param {SetExerciseAnswersRequest} setExerciseAnswersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setExerciseAnswers(setExerciseAnswersRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setExerciseAnswers(setExerciseAnswersRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Begin an exercise by updating the finished timestamp
         * @summary startExercise
         * @param {FinishExerciseRequest} finishExerciseRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startExercise(finishExerciseRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.startExercise(finishExerciseRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ExercisesApi - factory interface
 * @export
 */
export const ExercisesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ExercisesApiFp(configuration);
    return {
        /**
         *
         * @summary addFavorite
         * @param {number} pageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavorite(pageId, options) {
            return localVarFp.addFavorite(pageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Complete an exercise by updating the finished timestamp
         * @summary finishExercise
         * @param {FinishExerciseRequest} finishExerciseRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishExercise(finishExerciseRequest, options) {
            return localVarFp.finishExercise(finishExerciseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get exercises and items for a company via the session token
         * @summary getCompanyExercises
         * @param {GetCompanyExercisesRequest} getCompanyExercisesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyExercises(getCompanyExercisesRequest, options) {
            return localVarFp.getCompanyExercises(getCompanyExercisesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get an array of answers (inclusive adviser answers) for a user by an exercise
         * @summary getExerciseAnswers
         * @param {number} exerciseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExerciseAnswers(exerciseId, options) {
            return localVarFp.getExerciseAnswers(exerciseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get an array of exercise items for a user by an exercise id
         * @summary getExerciseItems
         * @param {number} exerciseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExerciseItems(exerciseId, options) {
            return localVarFp.getExerciseItems(exerciseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get array of exercises for a user
         * @summary getExercises
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExercises(options) {
            return localVarFp.getExercises(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary getFavorites
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavorites(options) {
            return localVarFp.getFavorites(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary removeFavorite
         * @param {number} pageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFavorite(pageId, options) {
            return localVarFp.removeFavorite(pageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Set/Create answers for items for a user
         * @summary setExerciseAnswers
         * @param {SetExerciseAnswersRequest} setExerciseAnswersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setExerciseAnswers(setExerciseAnswersRequest, options) {
            return localVarFp.setExerciseAnswers(setExerciseAnswersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Begin an exercise by updating the finished timestamp
         * @summary startExercise
         * @param {FinishExerciseRequest} finishExerciseRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startExercise(finishExerciseRequest, options) {
            return localVarFp.startExercise(finishExerciseRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ExercisesApi - object-oriented interface
 * @export
 * @class ExercisesApi
 * @extends {BaseAPI}
 */
export class ExercisesApi extends BaseAPI {
    /**
     *
     * @summary addFavorite
     * @param {number} pageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExercisesApi
     */
    addFavorite(pageId, options) {
        return ExercisesApiFp(this.configuration).addFavorite(pageId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Complete an exercise by updating the finished timestamp
     * @summary finishExercise
     * @param {FinishExerciseRequest} finishExerciseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExercisesApi
     */
    finishExercise(finishExerciseRequest, options) {
        return ExercisesApiFp(this.configuration).finishExercise(finishExerciseRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get exercises and items for a company via the session token
     * @summary getCompanyExercises
     * @param {GetCompanyExercisesRequest} getCompanyExercisesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExercisesApi
     */
    getCompanyExercises(getCompanyExercisesRequest, options) {
        return ExercisesApiFp(this.configuration).getCompanyExercises(getCompanyExercisesRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get an array of answers (inclusive adviser answers) for a user by an exercise
     * @summary getExerciseAnswers
     * @param {number} exerciseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExercisesApi
     */
    getExerciseAnswers(exerciseId, options) {
        return ExercisesApiFp(this.configuration).getExerciseAnswers(exerciseId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get an array of exercise items for a user by an exercise id
     * @summary getExerciseItems
     * @param {number} exerciseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExercisesApi
     */
    getExerciseItems(exerciseId, options) {
        return ExercisesApiFp(this.configuration).getExerciseItems(exerciseId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get array of exercises for a user
     * @summary getExercises
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExercisesApi
     */
    getExercises(options) {
        return ExercisesApiFp(this.configuration).getExercises(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary getFavorites
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExercisesApi
     */
    getFavorites(options) {
        return ExercisesApiFp(this.configuration).getFavorites(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary removeFavorite
     * @param {number} pageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExercisesApi
     */
    removeFavorite(pageId, options) {
        return ExercisesApiFp(this.configuration).removeFavorite(pageId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set/Create answers for items for a user
     * @summary setExerciseAnswers
     * @param {SetExerciseAnswersRequest} setExerciseAnswersRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExercisesApi
     */
    setExerciseAnswers(setExerciseAnswersRequest, options) {
        return ExercisesApiFp(this.configuration).setExerciseAnswers(setExerciseAnswersRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Begin an exercise by updating the finished timestamp
     * @summary startExercise
     * @param {FinishExerciseRequest} finishExerciseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExercisesApi
     */
    startExercise(finishExerciseRequest, options) {
        return ExercisesApiFp(this.configuration).startExercise(finishExerciseRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * GlobalNotificationsApi - axios parameter creator
 * @export
 */
export const GlobalNotificationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary delete
         * @param {number} globalNotificationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGlobalNotifications: (globalNotificationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'globalNotificationId' is not null or undefined
            assertParamExists('deleteGlobalNotifications', 'globalNotificationId', globalNotificationId);
            const localVarPath = `/backend/api/v1/global-notifications/delete/{globalNotificationId}`
                .replace(`{${"globalNotificationId"}}`, encodeURIComponent(String(globalNotificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get all global notifications
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGlobalNotifications: (page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/global-notifications/get-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} globalNotificationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalNotification: (globalNotificationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'globalNotificationId' is not null or undefined
            assertParamExists('globalNotification', 'globalNotificationId', globalNotificationId);
            const localVarPath = `/backend/api/v1/global-notifications/get/{globalNotificationId}`
                .replace(`{${"globalNotificationId"}}`, encodeURIComponent(String(globalNotificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {GlobalNotification} globalNotification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGlobalNotification: (globalNotification, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'globalNotification' is not null or undefined
            assertParamExists('saveGlobalNotification', 'globalNotification', globalNotification);
            const localVarPath = `/backend/api/v1/global-notifications/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(globalNotification, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * GlobalNotificationsApi - functional programming interface
 * @export
 */
export const GlobalNotificationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = GlobalNotificationsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} globalNotificationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGlobalNotifications(globalNotificationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteGlobalNotifications(globalNotificationId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get all global notifications
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGlobalNotifications(page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllGlobalNotifications(page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} globalNotificationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalNotification(globalNotificationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.globalNotification(globalNotificationId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {GlobalNotification} globalNotification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGlobalNotification(globalNotification, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveGlobalNotification(globalNotification, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * GlobalNotificationsApi - factory interface
 * @export
 */
export const GlobalNotificationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = GlobalNotificationsApiFp(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} globalNotificationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGlobalNotifications(globalNotificationId, options) {
            return localVarFp.deleteGlobalNotifications(globalNotificationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get all global notifications
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGlobalNotifications(page, limit, options) {
            return localVarFp.getAllGlobalNotifications(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} globalNotificationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalNotification(globalNotificationId, options) {
            return localVarFp.globalNotification(globalNotificationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {GlobalNotification} globalNotification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGlobalNotification(globalNotification, options) {
            return localVarFp.saveGlobalNotification(globalNotification, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * GlobalNotificationsApi - object-oriented interface
 * @export
 * @class GlobalNotificationsApi
 * @extends {BaseAPI}
 */
export class GlobalNotificationsApi extends BaseAPI {
    /**
     *
     * @summary delete
     * @param {number} globalNotificationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalNotificationsApi
     */
    deleteGlobalNotifications(globalNotificationId, options) {
        return GlobalNotificationsApiFp(this.configuration).deleteGlobalNotifications(globalNotificationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get all global notifications
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalNotificationsApi
     */
    getAllGlobalNotifications(page, limit, options) {
        return GlobalNotificationsApiFp(this.configuration).getAllGlobalNotifications(page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} globalNotificationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalNotificationsApi
     */
    globalNotification(globalNotificationId, options) {
        return GlobalNotificationsApiFp(this.configuration).globalNotification(globalNotificationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {GlobalNotification} globalNotification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalNotificationsApi
     */
    saveGlobalNotification(globalNotification, options) {
        return GlobalNotificationsApiFp(this.configuration).saveGlobalNotification(globalNotification, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * GroupsApi - axios parameter creator
 * @export
 */
export const GroupsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary accessWebRtc
         * @param {number} [firmaId]
         * @param {number} [userId]
         * @param {number} [groupId]
         * @param {string} [connectionType]
         * @param {string} [accessToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessWebRtc: (firmaId, userId, groupId, connectionType, accessToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/client/access-web-rtc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (firmaId !== undefined) {
                localVarQueryParameter['firma_id'] = firmaId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }
            if (connectionType !== undefined) {
                localVarQueryParameter['connection_type'] = connectionType;
            }
            if (accessToken !== undefined) {
                localVarQueryParameter['access_token'] = accessToken;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * addGroup  seems to be broken
         * @summary addGroup
         * @param {AddGroupRequest} addGroupRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGroup: (addGroupRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'addGroupRequest' is not null or undefined
            assertParamExists('addGroup', 'addGroupRequest', addGroupRequest);
            const localVarPath = `/client/add-group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(addGroupRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary getWebRTCAccsessCredentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebRTCAccsessCredentials: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/client/get-web-rtc-accsess-credentials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary groupsList
         * @param {GroupsListRequest} groupsListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsList: (groupsListRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupsListRequest' is not null or undefined
            assertParamExists('groupsList', 'groupsListRequest', groupsListRequest);
            const localVarPath = `/client/groups-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(groupsListRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary joinGroup
         * @param {JoinGroupRequest} joinGroupRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinGroup: (joinGroupRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'joinGroupRequest' is not null or undefined
            assertParamExists('joinGroup', 'joinGroupRequest', joinGroupRequest);
            const localVarPath = `/client/join-group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(joinGroupRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary publicGroupsList
         * @param {PublicGroupsListRequest} publicGroupsListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicGroupsList: (publicGroupsListRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'publicGroupsListRequest' is not null or undefined
            assertParamExists('publicGroupsList', 'publicGroupsListRequest', publicGroupsListRequest);
            const localVarPath = `/client/get-public-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(publicGroupsListRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary setAnswerToGroupJoinRequest
         * @param {SetAnswerToGroupJoinRequestRequest} setAnswerToGroupJoinRequestRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        setAnswerToGroupJoinRequest: (setAnswerToGroupJoinRequestRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'setAnswerToGroupJoinRequestRequest' is not null or undefined
            assertParamExists('setAnswerToGroupJoinRequest', 'setAnswerToGroupJoinRequestRequest', setAnswerToGroupJoinRequestRequest);
            const localVarPath = `/client/set-answer-to-group-join-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(setAnswerToGroupJoinRequestRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary setGroupNotify
         * @param {SetGroupNotifyRequest} setGroupNotifyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGroupNotify: (setGroupNotifyRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'setGroupNotifyRequest' is not null or undefined
            assertParamExists('setGroupNotify', 'setGroupNotifyRequest', setGroupNotifyRequest);
            const localVarPath = `/client/set-group-notify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(setGroupNotifyRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * GroupsApi - functional programming interface
 * @export
 */
export const GroupsApiFp = function (configuration) {
    const localVarAxiosParamCreator = GroupsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary accessWebRtc
         * @param {number} [firmaId]
         * @param {number} [userId]
         * @param {number} [groupId]
         * @param {string} [connectionType]
         * @param {string} [accessToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessWebRtc(firmaId, userId, groupId, connectionType, accessToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessWebRtc(firmaId, userId, groupId, connectionType, accessToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * addGroup  seems to be broken
         * @summary addGroup
         * @param {AddGroupRequest} addGroupRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGroup(addGroupRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addGroup(addGroupRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary getWebRTCAccsessCredentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebRTCAccsessCredentials(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWebRTCAccsessCredentials(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary groupsList
         * @param {GroupsListRequest} groupsListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsList(groupsListRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.groupsList(groupsListRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary joinGroup
         * @param {JoinGroupRequest} joinGroupRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinGroup(joinGroupRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.joinGroup(joinGroupRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary publicGroupsList
         * @param {PublicGroupsListRequest} publicGroupsListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicGroupsList(publicGroupsListRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.publicGroupsList(publicGroupsListRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary setAnswerToGroupJoinRequest
         * @param {SetAnswerToGroupJoinRequestRequest} setAnswerToGroupJoinRequestRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        setAnswerToGroupJoinRequest(setAnswerToGroupJoinRequestRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setAnswerToGroupJoinRequest(setAnswerToGroupJoinRequestRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary setGroupNotify
         * @param {SetGroupNotifyRequest} setGroupNotifyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGroupNotify(setGroupNotifyRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setGroupNotify(setGroupNotifyRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * GroupsApi - factory interface
 * @export
 */
export const GroupsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = GroupsApiFp(configuration);
    return {
        /**
         *
         * @summary accessWebRtc
         * @param {number} [firmaId]
         * @param {number} [userId]
         * @param {number} [groupId]
         * @param {string} [connectionType]
         * @param {string} [accessToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessWebRtc(firmaId, userId, groupId, connectionType, accessToken, options) {
            return localVarFp.accessWebRtc(firmaId, userId, groupId, connectionType, accessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * addGroup  seems to be broken
         * @summary addGroup
         * @param {AddGroupRequest} addGroupRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGroup(addGroupRequest, options) {
            return localVarFp.addGroup(addGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary getWebRTCAccsessCredentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebRTCAccsessCredentials(options) {
            return localVarFp.getWebRTCAccsessCredentials(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary groupsList
         * @param {GroupsListRequest} groupsListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsList(groupsListRequest, options) {
            return localVarFp.groupsList(groupsListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary joinGroup
         * @param {JoinGroupRequest} joinGroupRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinGroup(joinGroupRequest, options) {
            return localVarFp.joinGroup(joinGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary publicGroupsList
         * @param {PublicGroupsListRequest} publicGroupsListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicGroupsList(publicGroupsListRequest, options) {
            return localVarFp.publicGroupsList(publicGroupsListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary setAnswerToGroupJoinRequest
         * @param {SetAnswerToGroupJoinRequestRequest} setAnswerToGroupJoinRequestRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        setAnswerToGroupJoinRequest(setAnswerToGroupJoinRequestRequest, options) {
            return localVarFp.setAnswerToGroupJoinRequest(setAnswerToGroupJoinRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary setGroupNotify
         * @param {SetGroupNotifyRequest} setGroupNotifyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGroupNotify(setGroupNotifyRequest, options) {
            return localVarFp.setGroupNotify(setGroupNotifyRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * GroupsApi - object-oriented interface
 * @export
 * @class GroupsApi
 * @extends {BaseAPI}
 */
export class GroupsApi extends BaseAPI {
    /**
     *
     * @summary accessWebRtc
     * @param {number} [firmaId]
     * @param {number} [userId]
     * @param {number} [groupId]
     * @param {string} [connectionType]
     * @param {string} [accessToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    accessWebRtc(firmaId, userId, groupId, connectionType, accessToken, options) {
        return GroupsApiFp(this.configuration).accessWebRtc(firmaId, userId, groupId, connectionType, accessToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * addGroup  seems to be broken
     * @summary addGroup
     * @param {AddGroupRequest} addGroupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    addGroup(addGroupRequest, options) {
        return GroupsApiFp(this.configuration).addGroup(addGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary getWebRTCAccsessCredentials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    getWebRTCAccsessCredentials(options) {
        return GroupsApiFp(this.configuration).getWebRTCAccsessCredentials(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary groupsList
     * @param {GroupsListRequest} groupsListRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    groupsList(groupsListRequest, options) {
        return GroupsApiFp(this.configuration).groupsList(groupsListRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary joinGroup
     * @param {JoinGroupRequest} joinGroupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    joinGroup(joinGroupRequest, options) {
        return GroupsApiFp(this.configuration).joinGroup(joinGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary publicGroupsList
     * @param {PublicGroupsListRequest} publicGroupsListRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    publicGroupsList(publicGroupsListRequest, options) {
        return GroupsApiFp(this.configuration).publicGroupsList(publicGroupsListRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary setAnswerToGroupJoinRequest
     * @param {SetAnswerToGroupJoinRequestRequest} setAnswerToGroupJoinRequestRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    setAnswerToGroupJoinRequest(setAnswerToGroupJoinRequestRequest, options) {
        return GroupsApiFp(this.configuration).setAnswerToGroupJoinRequest(setAnswerToGroupJoinRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary setGroupNotify
     * @param {SetGroupNotifyRequest} setGroupNotifyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    setGroupNotify(setGroupNotifyRequest, options) {
        return GroupsApiFp(this.configuration).setGroupNotify(setGroupNotifyRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * LikesApi - axios parameter creator
 * @export
 */
export const LikesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary addLike
         * @param {AddLikeRequest} addLikeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLike: (addLikeRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'addLikeRequest' is not null or undefined
            assertParamExists('addLike', 'addLikeRequest', addLikeRequest);
            const localVarPath = `/client/add-like`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(addLikeRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * LikesApi - functional programming interface
 * @export
 */
export const LikesApiFp = function (configuration) {
    const localVarAxiosParamCreator = LikesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary addLike
         * @param {AddLikeRequest} addLikeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLike(addLikeRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addLike(addLikeRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * LikesApi - factory interface
 * @export
 */
export const LikesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LikesApiFp(configuration);
    return {
        /**
         *
         * @summary addLike
         * @param {AddLikeRequest} addLikeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLike(addLikeRequest, options) {
            return localVarFp.addLike(addLikeRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LikesApi - object-oriented interface
 * @export
 * @class LikesApi
 * @extends {BaseAPI}
 */
export class LikesApi extends BaseAPI {
    /**
     *
     * @summary addLike
     * @param {AddLikeRequest} addLikeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LikesApi
     */
    addLike(addLikeRequest, options) {
        return LikesApiFp(this.configuration).addLike(addLikeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MasksApi - axios parameter creator
 * @export
 */
export const MasksApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary get all
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {number} [companyId] companyId of history
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMaskHistory: (page, limit, companyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/company/masks/mask-history/get-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get all
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMaskTemplate: (page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/company/masks/mask-template/get-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} maskHistoryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaskHistory: (maskHistoryId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'maskHistoryId' is not null or undefined
            assertParamExists('getMaskHistory', 'maskHistoryId', maskHistoryId);
            const localVarPath = `/backend/api/v1/company/masks/mask-history/get/{maskHistoryId}`
                .replace(`{${"maskHistoryId"}}`, encodeURIComponent(String(maskHistoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} maskTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaskTemplate: (maskTemplateId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'maskTemplateId' is not null or undefined
            assertParamExists('getMaskTemplate', 'maskTemplateId', maskTemplateId);
            const localVarPath = `/backend/api/v1/company/masks/mask-template/get/{maskTemplateId}`
                .replace(`{${"maskTemplateId"}}`, encodeURIComponent(String(maskTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {MaskHistory} maskHistory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMaskHistory: (maskHistory, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'maskHistory' is not null or undefined
            assertParamExists('saveMaskHistory', 'maskHistory', maskHistory);
            const localVarPath = `/backend/api/v1/company/masks/mask-history/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(maskHistory, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {MaskTemplate} maskTemplate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMaskTemplate: (maskTemplate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'maskTemplate' is not null or undefined
            assertParamExists('saveMaskTemplate', 'maskTemplate', maskTemplate);
            const localVarPath = `/backend/api/v1/company/masks/mask-template/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(maskTemplate, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MasksApi - functional programming interface
 * @export
 */
export const MasksApiFp = function (configuration) {
    const localVarAxiosParamCreator = MasksApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary get all
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {number} [companyId] companyId of history
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMaskHistory(page, limit, companyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllMaskHistory(page, limit, companyId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get all
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMaskTemplate(page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllMaskTemplate(page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} maskHistoryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaskHistory(maskHistoryId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMaskHistory(maskHistoryId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} maskTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaskTemplate(maskTemplateId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMaskTemplate(maskTemplateId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {MaskHistory} maskHistory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMaskHistory(maskHistory, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveMaskHistory(maskHistory, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {MaskTemplate} maskTemplate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMaskTemplate(maskTemplate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveMaskTemplate(maskTemplate, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MasksApi - factory interface
 * @export
 */
export const MasksApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MasksApiFp(configuration);
    return {
        /**
         *
         * @summary get all
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {number} [companyId] companyId of history
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMaskHistory(page, limit, companyId, options) {
            return localVarFp.getAllMaskHistory(page, limit, companyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get all
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMaskTemplate(page, limit, options) {
            return localVarFp.getAllMaskTemplate(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} maskHistoryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaskHistory(maskHistoryId, options) {
            return localVarFp.getMaskHistory(maskHistoryId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} maskTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaskTemplate(maskTemplateId, options) {
            return localVarFp.getMaskTemplate(maskTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {MaskHistory} maskHistory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMaskHistory(maskHistory, options) {
            return localVarFp.saveMaskHistory(maskHistory, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {MaskTemplate} maskTemplate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMaskTemplate(maskTemplate, options) {
            return localVarFp.saveMaskTemplate(maskTemplate, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MasksApi - object-oriented interface
 * @export
 * @class MasksApi
 * @extends {BaseAPI}
 */
export class MasksApi extends BaseAPI {
    /**
     *
     * @summary get all
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {number} [companyId] companyId of history
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasksApi
     */
    getAllMaskHistory(page, limit, companyId, options) {
        return MasksApiFp(this.configuration).getAllMaskHistory(page, limit, companyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get all
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasksApi
     */
    getAllMaskTemplate(page, limit, options) {
        return MasksApiFp(this.configuration).getAllMaskTemplate(page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} maskHistoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasksApi
     */
    getMaskHistory(maskHistoryId, options) {
        return MasksApiFp(this.configuration).getMaskHistory(maskHistoryId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} maskTemplateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasksApi
     */
    getMaskTemplate(maskTemplateId, options) {
        return MasksApiFp(this.configuration).getMaskTemplate(maskTemplateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {MaskHistory} maskHistory
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasksApi
     */
    saveMaskHistory(maskHistory, options) {
        return MasksApiFp(this.configuration).saveMaskHistory(maskHistory, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {MaskTemplate} maskTemplate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasksApi
     */
    saveMaskTemplate(maskTemplate, options) {
        return MasksApiFp(this.configuration).saveMaskTemplate(maskTemplate, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MessagesApi - axios parameter creator
 * @export
 */
export const MessagesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary delete
         * @param {number} messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMessages: (messageId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('deleteMessages', 'messageId', messageId);
            const localVarPath = `/backend/api/v1/messages/delete/{messageId}`
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get messages
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMessagess: (limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/messages/get-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessages: (messageId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('getMessages', 'messageId', messageId);
            const localVarPath = `/backend/api/v1/messages/get/{messageId}`
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {Array<Message>} message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllMessages: (message, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'message' is not null or undefined
            assertParamExists('saveAllMessages', 'message', message);
            const localVarPath = `/backend/api/v1/messages/save-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(message, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {Message} message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMessages: (message, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'message' is not null or undefined
            assertParamExists('saveMessages', 'message', message);
            const localVarPath = `/backend/api/v1/messages/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(message, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MessagesApi - functional programming interface
 * @export
 */
export const MessagesApiFp = function (configuration) {
    const localVarAxiosParamCreator = MessagesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMessages(messageId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteMessages(messageId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get messages
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMessagess(limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllMessagess(limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessages(messageId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMessages(messageId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {Array<Message>} message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllMessages(message, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveAllMessages(message, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {Message} message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMessages(message, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveMessages(message, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MessagesApi - factory interface
 * @export
 */
export const MessagesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MessagesApiFp(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMessages(messageId, options) {
            return localVarFp.deleteMessages(messageId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get messages
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMessagess(limit, options) {
            return localVarFp.getAllMessagess(limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessages(messageId, options) {
            return localVarFp.getMessages(messageId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {Array<Message>} message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllMessages(message, options) {
            return localVarFp.saveAllMessages(message, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {Message} message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMessages(message, options) {
            return localVarFp.saveMessages(message, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MessagesApi - object-oriented interface
 * @export
 * @class MessagesApi
 * @extends {BaseAPI}
 */
export class MessagesApi extends BaseAPI {
    /**
     *
     * @summary delete
     * @param {number} messageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    deleteMessages(messageId, options) {
        return MessagesApiFp(this.configuration).deleteMessages(messageId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get messages
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    getAllMessagess(limit, options) {
        return MessagesApiFp(this.configuration).getAllMessagess(limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} messageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    getMessages(messageId, options) {
        return MessagesApiFp(this.configuration).getMessages(messageId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {Array<Message>} message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    saveAllMessages(message, options) {
        return MessagesApiFp(this.configuration).saveAllMessages(message, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {Message} message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    saveMessages(message, options) {
        return MessagesApiFp(this.configuration).saveMessages(message, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * NotesApi - axios parameter creator
 * @export
 */
export const NotesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary delete
         * @param {number} noteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotes: (noteId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('deleteNotes', 'noteId', noteId);
            const localVarPath = `/backend/api/v1/notes/delete/{noteId}`
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get notes
         * @param {number} [userId] notes user
         * @param {number} [limit] limit for items page
         * @param {number} [page] page number for requested page
         * @param {string} [search] string to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNotes: (userId, limit, page, search, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/notes/get-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} noteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotes: (noteId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('getNotes', 'noteId', noteId);
            const localVarPath = `/backend/api/v1/notes/get/{noteId}`
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get by user id
         * @param {number} userId
         * @param {number} [limit] limit for items page
         * @param {number} [page] page number for requested page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotesByUserId: (userId, limit, page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getNotesByUserId', 'userId', userId);
            const localVarPath = `/backend/api/v1/notes/get-by-user-id/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save all notes
         * @param {Array<Note>} note
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllNotes: (note, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'note' is not null or undefined
            assertParamExists('saveAllNotes', 'note', note);
            const localVarPath = `/backend/api/v1/notes/save-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(note, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {Note} note
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveNotes: (note, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'note' is not null or undefined
            assertParamExists('saveNotes', 'note', note);
            const localVarPath = `/backend/api/v1/notes/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(note, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * NotesApi - functional programming interface
 * @export
 */
export const NotesApiFp = function (configuration) {
    const localVarAxiosParamCreator = NotesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} noteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotes(noteId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteNotes(noteId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get notes
         * @param {number} [userId] notes user
         * @param {number} [limit] limit for items page
         * @param {number} [page] page number for requested page
         * @param {string} [search] string to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNotes(userId, limit, page, search, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllNotes(userId, limit, page, search, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} noteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotes(noteId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getNotes(noteId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get by user id
         * @param {number} userId
         * @param {number} [limit] limit for items page
         * @param {number} [page] page number for requested page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotesByUserId(userId, limit, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getNotesByUserId(userId, limit, page, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save all notes
         * @param {Array<Note>} note
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllNotes(note, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveAllNotes(note, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {Note} note
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveNotes(note, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveNotes(note, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * NotesApi - factory interface
 * @export
 */
export const NotesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = NotesApiFp(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} noteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotes(noteId, options) {
            return localVarFp.deleteNotes(noteId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get notes
         * @param {number} [userId] notes user
         * @param {number} [limit] limit for items page
         * @param {number} [page] page number for requested page
         * @param {string} [search] string to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNotes(userId, limit, page, search, options) {
            return localVarFp.getAllNotes(userId, limit, page, search, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} noteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotes(noteId, options) {
            return localVarFp.getNotes(noteId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get by user id
         * @param {number} userId
         * @param {number} [limit] limit for items page
         * @param {number} [page] page number for requested page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotesByUserId(userId, limit, page, options) {
            return localVarFp.getNotesByUserId(userId, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save all notes
         * @param {Array<Note>} note
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllNotes(note, options) {
            return localVarFp.saveAllNotes(note, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {Note} note
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveNotes(note, options) {
            return localVarFp.saveNotes(note, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * NotesApi - object-oriented interface
 * @export
 * @class NotesApi
 * @extends {BaseAPI}
 */
export class NotesApi extends BaseAPI {
    /**
     *
     * @summary delete
     * @param {number} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotesApi
     */
    deleteNotes(noteId, options) {
        return NotesApiFp(this.configuration).deleteNotes(noteId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get notes
     * @param {number} [userId] notes user
     * @param {number} [limit] limit for items page
     * @param {number} [page] page number for requested page
     * @param {string} [search] string to search for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotesApi
     */
    getAllNotes(userId, limit, page, search, options) {
        return NotesApiFp(this.configuration).getAllNotes(userId, limit, page, search, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotesApi
     */
    getNotes(noteId, options) {
        return NotesApiFp(this.configuration).getNotes(noteId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get by user id
     * @param {number} userId
     * @param {number} [limit] limit for items page
     * @param {number} [page] page number for requested page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotesApi
     */
    getNotesByUserId(userId, limit, page, options) {
        return NotesApiFp(this.configuration).getNotesByUserId(userId, limit, page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save all notes
     * @param {Array<Note>} note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotesApi
     */
    saveAllNotes(note, options) {
        return NotesApiFp(this.configuration).saveAllNotes(note, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {Note} note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotesApi
     */
    saveNotes(note, options) {
        return NotesApiFp(this.configuration).saveNotes(note, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary delete
         * @param {number} notificationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotification: (notificationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('deleteNotification', 'notificationId', notificationId);
            const localVarPath = `/backend/api/v1/notifications/delete/{notificationId}`
                .replace(`{${"notificationId"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNotifications: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/notifications/get-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} notificationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotification: (notificationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('getNotification', 'notificationId', notificationId);
            const localVarPath = `/backend/api/v1/notifications/get/{notificationId}`
                .replace(`{${"notificationId"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save all notifications
         * @param {Array<Notification>} notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllNotifications: (notification, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'notification' is not null or undefined
            assertParamExists('saveAllNotifications', 'notification', notification);
            const localVarPath = `/backend/api/v1/notifications/save-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(notification, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {Notification} notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveNotifications: (notification, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'notification' is not null or undefined
            assertParamExists('saveNotifications', 'notification', notification);
            const localVarPath = `/backend/api/v1/notifications/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(notification, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary test notification
         * @param {string} event
         * @param {string} receiverGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testNotification: (event, receiverGroup, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'event' is not null or undefined
            assertParamExists('testNotification', 'event', event);
            // verify required parameter 'receiverGroup' is not null or undefined
            assertParamExists('testNotification', 'receiverGroup', receiverGroup);
            const localVarPath = `/backend/api/v1/notifications/test-notification/{event}/{receiverGroup}`
                .replace(`{${"event"}}`, encodeURIComponent(String(event)))
                .replace(`{${"receiverGroup"}}`, encodeURIComponent(String(receiverGroup)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} notificationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotification(notificationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteNotification(notificationId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNotifications(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllNotifications(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} notificationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotification(notificationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getNotification(notificationId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save all notifications
         * @param {Array<Notification>} notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllNotifications(notification, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveAllNotifications(notification, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {Notification} notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveNotifications(notification, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveNotifications(notification, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary test notification
         * @param {string} event
         * @param {string} receiverGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testNotification(event, receiverGroup, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.testNotification(event, receiverGroup, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = NotificationsApiFp(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} notificationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotification(notificationId, options) {
            return localVarFp.deleteNotification(notificationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNotifications(options) {
            return localVarFp.getAllNotifications(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} notificationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotification(notificationId, options) {
            return localVarFp.getNotification(notificationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save all notifications
         * @param {Array<Notification>} notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllNotifications(notification, options) {
            return localVarFp.saveAllNotifications(notification, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {Notification} notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveNotifications(notification, options) {
            return localVarFp.saveNotifications(notification, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary test notification
         * @param {string} event
         * @param {string} receiverGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testNotification(event, receiverGroup, options) {
            return localVarFp.testNotification(event, receiverGroup, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     *
     * @summary delete
     * @param {number} notificationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    deleteNotification(notificationId, options) {
        return NotificationsApiFp(this.configuration).deleteNotification(notificationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get notifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    getAllNotifications(options) {
        return NotificationsApiFp(this.configuration).getAllNotifications(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} notificationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    getNotification(notificationId, options) {
        return NotificationsApiFp(this.configuration).getNotification(notificationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save all notifications
     * @param {Array<Notification>} notification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    saveAllNotifications(notification, options) {
        return NotificationsApiFp(this.configuration).saveAllNotifications(notification, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {Notification} notification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    saveNotifications(notification, options) {
        return NotificationsApiFp(this.configuration).saveNotifications(notification, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary test notification
     * @param {string} event
     * @param {string} receiverGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    testNotification(event, receiverGroup, options) {
        return NotificationsApiFp(this.configuration).testNotification(event, receiverGroup, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OnboardingPagesApi - axios parameter creator
 * @export
 */
export const OnboardingPagesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary delete
         * @param {number} onboardingPageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroupOnboardingPage: (onboardingPageId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'onboardingPageId' is not null or undefined
            assertParamExists('deleteGroupOnboardingPage', 'onboardingPageId', onboardingPageId);
            const localVarPath = `/backend/api/v1/products/groups/onboarding-pages/delete/{onboardingPageId}`
                .replace(`{${"onboardingPageId"}}`, encodeURIComponent(String(onboardingPageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary delete
         * @param {number} onboardingPageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOnboardingPage: (onboardingPageId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'onboardingPageId' is not null or undefined
            assertParamExists('deleteOnboardingPage', 'onboardingPageId', onboardingPageId);
            const localVarPath = `/backend/api/v1/products/messenger-app/onboarding-pages/delete/{onboardingPageId}`
                .replace(`{${"onboardingPageId"}}`, encodeURIComponent(String(onboardingPageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary delete
         * @param {number} onboardingPageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWebMessengerOnboardingPage: (onboardingPageId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'onboardingPageId' is not null or undefined
            assertParamExists('deleteWebMessengerOnboardingPage', 'onboardingPageId', onboardingPageId);
            const localVarPath = `/backend/api/v1/products/web-messenger/onboarding-pages/delete/{onboardingPageId}`
                .replace(`{${"onboardingPageId"}}`, encodeURIComponent(String(onboardingPageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get onboarding page elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGroupOnboardingPages: (companyProductId, filtered, page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getAllGroupOnboardingPages', 'companyProductId', companyProductId);
            // verify required parameter 'filtered' is not null or undefined
            assertParamExists('getAllGroupOnboardingPages', 'filtered', filtered);
            const localVarPath = `/backend/api/v1/products/groups/onboarding-pages/get-all/{companyProductId}/{filtered}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)))
                .replace(`{${"filtered"}}`, encodeURIComponent(String(filtered)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get onboarding page elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOnboardingPages: (companyProductId, filtered, page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getAllOnboardingPages', 'companyProductId', companyProductId);
            // verify required parameter 'filtered' is not null or undefined
            assertParamExists('getAllOnboardingPages', 'filtered', filtered);
            const localVarPath = `/backend/api/v1/products/messenger-app/onboarding-pages/get-all/{companyProductId}/{filtered}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)))
                .replace(`{${"filtered"}}`, encodeURIComponent(String(filtered)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get onboarding page elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWebMessengerOnboardingPages: (companyProductId, filtered, page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getAllWebMessengerOnboardingPages', 'companyProductId', companyProductId);
            // verify required parameter 'filtered' is not null or undefined
            assertParamExists('getAllWebMessengerOnboardingPages', 'filtered', filtered);
            const localVarPath = `/backend/api/v1/products/web-messenger/onboarding-pages/get-all/{companyProductId}/{filtered}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)))
                .replace(`{${"filtered"}}`, encodeURIComponent(String(filtered)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} onboardingPageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupOnboardingPage: (onboardingPageId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'onboardingPageId' is not null or undefined
            assertParamExists('getGroupOnboardingPage', 'onboardingPageId', onboardingPageId);
            const localVarPath = `/backend/api/v1/products/groups/onboarding-pages/get/{onboardingPageId}`
                .replace(`{${"onboardingPageId"}}`, encodeURIComponent(String(onboardingPageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} onboardingPageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingPage: (onboardingPageId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'onboardingPageId' is not null or undefined
            assertParamExists('getOnboardingPage', 'onboardingPageId', onboardingPageId);
            const localVarPath = `/backend/api/v1/products/messenger-app/onboarding-pages/get/{onboardingPageId}`
                .replace(`{${"onboardingPageId"}}`, encodeURIComponent(String(onboardingPageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} onboardingPageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebMessengerOnboardingPage: (onboardingPageId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'onboardingPageId' is not null or undefined
            assertParamExists('getWebMessengerOnboardingPage', 'onboardingPageId', onboardingPageId);
            const localVarPath = `/backend/api/v1/products/web-messenger/onboarding-pages/get/{onboardingPageId}`
                .replace(`{${"onboardingPageId"}}`, encodeURIComponent(String(onboardingPageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {Array<OnboardingPage>} onboardingPage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllGroupOnboardingPages: (onboardingPage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'onboardingPage' is not null or undefined
            assertParamExists('saveAllGroupOnboardingPages', 'onboardingPage', onboardingPage);
            const localVarPath = `/backend/api/v1/products/groups/onboarding-pages/save-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(onboardingPage, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {Array<OnboardingPage>} onboardingPage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllOnboardingPages: (onboardingPage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'onboardingPage' is not null or undefined
            assertParamExists('saveAllOnboardingPages', 'onboardingPage', onboardingPage);
            const localVarPath = `/backend/api/v1/products/messenger-app/onboarding-pages/save-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(onboardingPage, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {Array<OnboardingPage>} onboardingPage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllWebMessengerOnboardingPages: (onboardingPage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'onboardingPage' is not null or undefined
            assertParamExists('saveAllWebMessengerOnboardingPages', 'onboardingPage', onboardingPage);
            const localVarPath = `/backend/api/v1/products/web-messenger/onboarding-pages/save-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(onboardingPage, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {string} [uploadImage] uploadImage
         * @param {number} [id] id
         * @param {number} [companyProductId] company_product_id
         * @param {string} [title] title
         * @param {string} [description] description
         * @param {string} [buttonText] button text
         * @param {string} [image] image
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {number} [placement] placement
         * @param {boolean} [isActive] is_active
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGroupOnboardingPage: (uploadImage, id, companyProductId, title, description, buttonText, image, created, modified, deleted, placement, isActive, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/products/groups/onboarding-pages/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (uploadImage !== undefined) {
                localVarFormParams.append('uploadImage', uploadImage);
            }
            if (id !== undefined) {
                localVarFormParams.append('id', id);
            }
            if (companyProductId !== undefined) {
                localVarFormParams.append('company_product_id', companyProductId);
            }
            if (title !== undefined) {
                localVarFormParams.append('title', title);
            }
            if (description !== undefined) {
                localVarFormParams.append('description', description);
            }
            if (buttonText !== undefined) {
                localVarFormParams.append('button_text', buttonText);
            }
            if (image !== undefined) {
                localVarFormParams.append('image', image);
            }
            if (created !== undefined) {
                localVarFormParams.append('created', created);
            }
            if (modified !== undefined) {
                localVarFormParams.append('modified', modified);
            }
            if (deleted !== undefined) {
                localVarFormParams.append('deleted', deleted);
            }
            if (placement !== undefined) {
                localVarFormParams.append('placement', placement);
            }
            if (isActive !== undefined) {
                localVarFormParams.append('is_active', isActive);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {string} [uploadImage] uploadImage
         * @param {number} [id] id
         * @param {number} [companyProductId] company_product_id
         * @param {string} [title] title
         * @param {string} [description] description
         * @param {string} [buttonText] button text
         * @param {string} [image] image
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {number} [placement] placement
         * @param {boolean} [isActive] is_active
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOnboardingPage: (uploadImage, id, companyProductId, title, description, buttonText, image, created, modified, deleted, placement, isActive, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/products/messenger-app/onboarding-pages/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (uploadImage !== undefined) {
                localVarFormParams.append('uploadImage', uploadImage);
            }
            if (id !== undefined) {
                localVarFormParams.append('id', id);
            }
            if (companyProductId !== undefined) {
                localVarFormParams.append('company_product_id', companyProductId);
            }
            if (title !== undefined) {
                localVarFormParams.append('title', title);
            }
            if (description !== undefined) {
                localVarFormParams.append('description', description);
            }
            if (buttonText !== undefined) {
                localVarFormParams.append('button_text', buttonText);
            }
            if (image !== undefined) {
                localVarFormParams.append('image', image);
            }
            if (created !== undefined) {
                localVarFormParams.append('created', created);
            }
            if (modified !== undefined) {
                localVarFormParams.append('modified', modified);
            }
            if (deleted !== undefined) {
                localVarFormParams.append('deleted', deleted);
            }
            if (placement !== undefined) {
                localVarFormParams.append('placement', placement);
            }
            if (isActive !== undefined) {
                localVarFormParams.append('is_active', isActive);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {string} [uploadImage] uploadImage
         * @param {number} [id] id
         * @param {number} [companyProductId] company_product_id
         * @param {string} [title] title
         * @param {string} [description] description
         * @param {string} [buttonText] button text
         * @param {string} [image] image
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {number} [placement] placement
         * @param {boolean} [isActive] is_active
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWebMessengerOnboardingPage: (uploadImage, id, companyProductId, title, description, buttonText, image, created, modified, deleted, placement, isActive, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/products/web-messenger/onboarding-pages/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (uploadImage !== undefined) {
                localVarFormParams.append('uploadImage', uploadImage);
            }
            if (id !== undefined) {
                localVarFormParams.append('id', id);
            }
            if (companyProductId !== undefined) {
                localVarFormParams.append('company_product_id', companyProductId);
            }
            if (title !== undefined) {
                localVarFormParams.append('title', title);
            }
            if (description !== undefined) {
                localVarFormParams.append('description', description);
            }
            if (buttonText !== undefined) {
                localVarFormParams.append('button_text', buttonText);
            }
            if (image !== undefined) {
                localVarFormParams.append('image', image);
            }
            if (created !== undefined) {
                localVarFormParams.append('created', created);
            }
            if (modified !== undefined) {
                localVarFormParams.append('modified', modified);
            }
            if (deleted !== undefined) {
                localVarFormParams.append('deleted', deleted);
            }
            if (placement !== undefined) {
                localVarFormParams.append('placement', placement);
            }
            if (isActive !== undefined) {
                localVarFormParams.append('is_active', isActive);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OnboardingPagesApi - functional programming interface
 * @export
 */
export const OnboardingPagesApiFp = function (configuration) {
    const localVarAxiosParamCreator = OnboardingPagesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} onboardingPageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroupOnboardingPage(onboardingPageId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteGroupOnboardingPage(onboardingPageId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary delete
         * @param {number} onboardingPageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOnboardingPage(onboardingPageId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOnboardingPage(onboardingPageId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary delete
         * @param {number} onboardingPageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWebMessengerOnboardingPage(onboardingPageId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteWebMessengerOnboardingPage(onboardingPageId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get onboarding page elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGroupOnboardingPages(companyProductId, filtered, page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllGroupOnboardingPages(companyProductId, filtered, page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get onboarding page elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOnboardingPages(companyProductId, filtered, page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllOnboardingPages(companyProductId, filtered, page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get onboarding page elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWebMessengerOnboardingPages(companyProductId, filtered, page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllWebMessengerOnboardingPages(companyProductId, filtered, page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} onboardingPageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupOnboardingPage(onboardingPageId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getGroupOnboardingPage(onboardingPageId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} onboardingPageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingPage(onboardingPageId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOnboardingPage(onboardingPageId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} onboardingPageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebMessengerOnboardingPage(onboardingPageId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWebMessengerOnboardingPage(onboardingPageId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {Array<OnboardingPage>} onboardingPage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllGroupOnboardingPages(onboardingPage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveAllGroupOnboardingPages(onboardingPage, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {Array<OnboardingPage>} onboardingPage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllOnboardingPages(onboardingPage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveAllOnboardingPages(onboardingPage, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {Array<OnboardingPage>} onboardingPage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllWebMessengerOnboardingPages(onboardingPage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveAllWebMessengerOnboardingPages(onboardingPage, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {string} [uploadImage] uploadImage
         * @param {number} [id] id
         * @param {number} [companyProductId] company_product_id
         * @param {string} [title] title
         * @param {string} [description] description
         * @param {string} [buttonText] button text
         * @param {string} [image] image
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {number} [placement] placement
         * @param {boolean} [isActive] is_active
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGroupOnboardingPage(uploadImage, id, companyProductId, title, description, buttonText, image, created, modified, deleted, placement, isActive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveGroupOnboardingPage(uploadImage, id, companyProductId, title, description, buttonText, image, created, modified, deleted, placement, isActive, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {string} [uploadImage] uploadImage
         * @param {number} [id] id
         * @param {number} [companyProductId] company_product_id
         * @param {string} [title] title
         * @param {string} [description] description
         * @param {string} [buttonText] button text
         * @param {string} [image] image
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {number} [placement] placement
         * @param {boolean} [isActive] is_active
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOnboardingPage(uploadImage, id, companyProductId, title, description, buttonText, image, created, modified, deleted, placement, isActive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveOnboardingPage(uploadImage, id, companyProductId, title, description, buttonText, image, created, modified, deleted, placement, isActive, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {string} [uploadImage] uploadImage
         * @param {number} [id] id
         * @param {number} [companyProductId] company_product_id
         * @param {string} [title] title
         * @param {string} [description] description
         * @param {string} [buttonText] button text
         * @param {string} [image] image
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {number} [placement] placement
         * @param {boolean} [isActive] is_active
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWebMessengerOnboardingPage(uploadImage, id, companyProductId, title, description, buttonText, image, created, modified, deleted, placement, isActive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveWebMessengerOnboardingPage(uploadImage, id, companyProductId, title, description, buttonText, image, created, modified, deleted, placement, isActive, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * OnboardingPagesApi - factory interface
 * @export
 */
export const OnboardingPagesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OnboardingPagesApiFp(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} onboardingPageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroupOnboardingPage(onboardingPageId, options) {
            return localVarFp.deleteGroupOnboardingPage(onboardingPageId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary delete
         * @param {number} onboardingPageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOnboardingPage(onboardingPageId, options) {
            return localVarFp.deleteOnboardingPage(onboardingPageId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary delete
         * @param {number} onboardingPageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWebMessengerOnboardingPage(onboardingPageId, options) {
            return localVarFp.deleteWebMessengerOnboardingPage(onboardingPageId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get onboarding page elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGroupOnboardingPages(companyProductId, filtered, page, limit, options) {
            return localVarFp.getAllGroupOnboardingPages(companyProductId, filtered, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get onboarding page elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOnboardingPages(companyProductId, filtered, page, limit, options) {
            return localVarFp.getAllOnboardingPages(companyProductId, filtered, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get onboarding page elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWebMessengerOnboardingPages(companyProductId, filtered, page, limit, options) {
            return localVarFp.getAllWebMessengerOnboardingPages(companyProductId, filtered, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} onboardingPageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupOnboardingPage(onboardingPageId, options) {
            return localVarFp.getGroupOnboardingPage(onboardingPageId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} onboardingPageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingPage(onboardingPageId, options) {
            return localVarFp.getOnboardingPage(onboardingPageId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} onboardingPageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebMessengerOnboardingPage(onboardingPageId, options) {
            return localVarFp.getWebMessengerOnboardingPage(onboardingPageId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {Array<OnboardingPage>} onboardingPage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllGroupOnboardingPages(onboardingPage, options) {
            return localVarFp.saveAllGroupOnboardingPages(onboardingPage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {Array<OnboardingPage>} onboardingPage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllOnboardingPages(onboardingPage, options) {
            return localVarFp.saveAllOnboardingPages(onboardingPage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {Array<OnboardingPage>} onboardingPage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllWebMessengerOnboardingPages(onboardingPage, options) {
            return localVarFp.saveAllWebMessengerOnboardingPages(onboardingPage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {string} [uploadImage] uploadImage
         * @param {number} [id] id
         * @param {number} [companyProductId] company_product_id
         * @param {string} [title] title
         * @param {string} [description] description
         * @param {string} [buttonText] button text
         * @param {string} [image] image
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {number} [placement] placement
         * @param {boolean} [isActive] is_active
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGroupOnboardingPage(uploadImage, id, companyProductId, title, description, buttonText, image, created, modified, deleted, placement, isActive, options) {
            return localVarFp.saveGroupOnboardingPage(uploadImage, id, companyProductId, title, description, buttonText, image, created, modified, deleted, placement, isActive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {string} [uploadImage] uploadImage
         * @param {number} [id] id
         * @param {number} [companyProductId] company_product_id
         * @param {string} [title] title
         * @param {string} [description] description
         * @param {string} [buttonText] button text
         * @param {string} [image] image
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {number} [placement] placement
         * @param {boolean} [isActive] is_active
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOnboardingPage(uploadImage, id, companyProductId, title, description, buttonText, image, created, modified, deleted, placement, isActive, options) {
            return localVarFp.saveOnboardingPage(uploadImage, id, companyProductId, title, description, buttonText, image, created, modified, deleted, placement, isActive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {string} [uploadImage] uploadImage
         * @param {number} [id] id
         * @param {number} [companyProductId] company_product_id
         * @param {string} [title] title
         * @param {string} [description] description
         * @param {string} [buttonText] button text
         * @param {string} [image] image
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {number} [placement] placement
         * @param {boolean} [isActive] is_active
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWebMessengerOnboardingPage(uploadImage, id, companyProductId, title, description, buttonText, image, created, modified, deleted, placement, isActive, options) {
            return localVarFp.saveWebMessengerOnboardingPage(uploadImage, id, companyProductId, title, description, buttonText, image, created, modified, deleted, placement, isActive, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OnboardingPagesApi - object-oriented interface
 * @export
 * @class OnboardingPagesApi
 * @extends {BaseAPI}
 */
export class OnboardingPagesApi extends BaseAPI {
    /**
     *
     * @summary delete
     * @param {number} onboardingPageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingPagesApi
     */
    deleteGroupOnboardingPage(onboardingPageId, options) {
        return OnboardingPagesApiFp(this.configuration).deleteGroupOnboardingPage(onboardingPageId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary delete
     * @param {number} onboardingPageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingPagesApi
     */
    deleteOnboardingPage(onboardingPageId, options) {
        return OnboardingPagesApiFp(this.configuration).deleteOnboardingPage(onboardingPageId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary delete
     * @param {number} onboardingPageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingPagesApi
     */
    deleteWebMessengerOnboardingPage(onboardingPageId, options) {
        return OnboardingPagesApiFp(this.configuration).deleteWebMessengerOnboardingPage(onboardingPageId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get onboarding page elements
     * @param {number} companyProductId
     * @param {number} filtered
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingPagesApi
     */
    getAllGroupOnboardingPages(companyProductId, filtered, page, limit, options) {
        return OnboardingPagesApiFp(this.configuration).getAllGroupOnboardingPages(companyProductId, filtered, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get onboarding page elements
     * @param {number} companyProductId
     * @param {number} filtered
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingPagesApi
     */
    getAllOnboardingPages(companyProductId, filtered, page, limit, options) {
        return OnboardingPagesApiFp(this.configuration).getAllOnboardingPages(companyProductId, filtered, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get onboarding page elements
     * @param {number} companyProductId
     * @param {number} filtered
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingPagesApi
     */
    getAllWebMessengerOnboardingPages(companyProductId, filtered, page, limit, options) {
        return OnboardingPagesApiFp(this.configuration).getAllWebMessengerOnboardingPages(companyProductId, filtered, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} onboardingPageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingPagesApi
     */
    getGroupOnboardingPage(onboardingPageId, options) {
        return OnboardingPagesApiFp(this.configuration).getGroupOnboardingPage(onboardingPageId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} onboardingPageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingPagesApi
     */
    getOnboardingPage(onboardingPageId, options) {
        return OnboardingPagesApiFp(this.configuration).getOnboardingPage(onboardingPageId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} onboardingPageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingPagesApi
     */
    getWebMessengerOnboardingPage(onboardingPageId, options) {
        return OnboardingPagesApiFp(this.configuration).getWebMessengerOnboardingPage(onboardingPageId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {Array<OnboardingPage>} onboardingPage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingPagesApi
     */
    saveAllGroupOnboardingPages(onboardingPage, options) {
        return OnboardingPagesApiFp(this.configuration).saveAllGroupOnboardingPages(onboardingPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {Array<OnboardingPage>} onboardingPage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingPagesApi
     */
    saveAllOnboardingPages(onboardingPage, options) {
        return OnboardingPagesApiFp(this.configuration).saveAllOnboardingPages(onboardingPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {Array<OnboardingPage>} onboardingPage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingPagesApi
     */
    saveAllWebMessengerOnboardingPages(onboardingPage, options) {
        return OnboardingPagesApiFp(this.configuration).saveAllWebMessengerOnboardingPages(onboardingPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {string} [uploadImage] uploadImage
     * @param {number} [id] id
     * @param {number} [companyProductId] company_product_id
     * @param {string} [title] title
     * @param {string} [description] description
     * @param {string} [buttonText] button text
     * @param {string} [image] image
     * @param {number} [created] created
     * @param {number} [modified] modified
     * @param {number} [deleted] deleted
     * @param {number} [placement] placement
     * @param {boolean} [isActive] is_active
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingPagesApi
     */
    saveGroupOnboardingPage(uploadImage, id, companyProductId, title, description, buttonText, image, created, modified, deleted, placement, isActive, options) {
        return OnboardingPagesApiFp(this.configuration).saveGroupOnboardingPage(uploadImage, id, companyProductId, title, description, buttonText, image, created, modified, deleted, placement, isActive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {string} [uploadImage] uploadImage
     * @param {number} [id] id
     * @param {number} [companyProductId] company_product_id
     * @param {string} [title] title
     * @param {string} [description] description
     * @param {string} [buttonText] button text
     * @param {string} [image] image
     * @param {number} [created] created
     * @param {number} [modified] modified
     * @param {number} [deleted] deleted
     * @param {number} [placement] placement
     * @param {boolean} [isActive] is_active
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingPagesApi
     */
    saveOnboardingPage(uploadImage, id, companyProductId, title, description, buttonText, image, created, modified, deleted, placement, isActive, options) {
        return OnboardingPagesApiFp(this.configuration).saveOnboardingPage(uploadImage, id, companyProductId, title, description, buttonText, image, created, modified, deleted, placement, isActive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {string} [uploadImage] uploadImage
     * @param {number} [id] id
     * @param {number} [companyProductId] company_product_id
     * @param {string} [title] title
     * @param {string} [description] description
     * @param {string} [buttonText] button text
     * @param {string} [image] image
     * @param {number} [created] created
     * @param {number} [modified] modified
     * @param {number} [deleted] deleted
     * @param {number} [placement] placement
     * @param {boolean} [isActive] is_active
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingPagesApi
     */
    saveWebMessengerOnboardingPage(uploadImage, id, companyProductId, title, description, buttonText, image, created, modified, deleted, placement, isActive, options) {
        return OnboardingPagesApiFp(this.configuration).saveWebMessengerOnboardingPage(uploadImage, id, companyProductId, title, description, buttonText, image, created, modified, deleted, placement, isActive, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PopUpNotificationsApi - axios parameter creator
 * @export
 */
export const PopUpNotificationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Gibt alle Notifications einer Firma zurück. Es wird erwartet, dass ein UserJWT am Request vorhanden ist.
         * @summary getPopup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopup: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/client/get-popup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PopUpNotificationsApi - functional programming interface
 * @export
 */
export const PopUpNotificationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PopUpNotificationsApiAxiosParamCreator(configuration);
    return {
        /**
         * Gibt alle Notifications einer Firma zurück. Es wird erwartet, dass ein UserJWT am Request vorhanden ist.
         * @summary getPopup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopup(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPopup(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PopUpNotificationsApi - factory interface
 * @export
 */
export const PopUpNotificationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PopUpNotificationsApiFp(configuration);
    return {
        /**
         * Gibt alle Notifications einer Firma zurück. Es wird erwartet, dass ein UserJWT am Request vorhanden ist.
         * @summary getPopup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopup(options) {
            return localVarFp.getPopup(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PopUpNotificationsApi - object-oriented interface
 * @export
 * @class PopUpNotificationsApi
 * @extends {BaseAPI}
 */
export class PopUpNotificationsApi extends BaseAPI {
    /**
     * Gibt alle Notifications einer Firma zurück. Es wird erwartet, dass ein UserJWT am Request vorhanden ist.
     * @summary getPopup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopUpNotificationsApi
     */
    getPopup(options) {
        return PopUpNotificationsApiFp(this.configuration).getPopup(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PrivacyConfirmationsApi - axios parameter creator
 * @export
 */
export const PrivacyConfirmationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary save
         * @param {PrivacyConfirmation} privacyConfirmation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePrivacyConfirmations: (privacyConfirmation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'privacyConfirmation' is not null or undefined
            assertParamExists('savePrivacyConfirmations', 'privacyConfirmation', privacyConfirmation);
            const localVarPath = `/backend/api/v1/products/privacy-confirmations/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(privacyConfirmation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PrivacyConfirmationsApi - functional programming interface
 * @export
 */
export const PrivacyConfirmationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PrivacyConfirmationsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary save
         * @param {PrivacyConfirmation} privacyConfirmation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePrivacyConfirmations(privacyConfirmation, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.savePrivacyConfirmations(privacyConfirmation, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PrivacyConfirmationsApi - factory interface
 * @export
 */
export const PrivacyConfirmationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PrivacyConfirmationsApiFp(configuration);
    return {
        /**
         *
         * @summary save
         * @param {PrivacyConfirmation} privacyConfirmation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePrivacyConfirmations(privacyConfirmation, options) {
            return localVarFp.savePrivacyConfirmations(privacyConfirmation, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PrivacyConfirmationsApi - object-oriented interface
 * @export
 * @class PrivacyConfirmationsApi
 * @extends {BaseAPI}
 */
export class PrivacyConfirmationsApi extends BaseAPI {
    /**
     *
     * @summary save
     * @param {PrivacyConfirmation} privacyConfirmation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivacyConfirmationsApi
     */
    savePrivacyConfirmations(privacyConfirmation, options) {
        return PrivacyConfirmationsApiFp(this.configuration).savePrivacyConfirmations(privacyConfirmation, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PrivacyPolicyApi - axios parameter creator
 * @export
 */
export const PrivacyPolicyApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary get privacy policies
         * @param {number} companyProductId
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPrivacyPolicies: (companyProductId, page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getAllPrivacyPolicies', 'companyProductId', companyProductId);
            const localVarPath = `/backend/api/v1/products/privacy-policies/get-all/{companyProductId}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get latest privacy policies
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestPrivacyPolicies: (companyProductId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getLatestPrivacyPolicies', 'companyProductId', companyProductId);
            const localVarPath = `/backend/api/v1/products/privacy-policies/get-latest/{companyProductId}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} privacyPolicyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrivacyPolicy: (privacyPolicyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'privacyPolicyId' is not null or undefined
            assertParamExists('getPrivacyPolicy', 'privacyPolicyId', privacyPolicyId);
            const localVarPath = `/backend/api/v1/products/privacy-policies/get/{privacyPolicyId}`
                .replace(`{${"privacyPolicyId"}}`, encodeURIComponent(String(privacyPolicyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {PrivacyPolicy} privacyPolicy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePrivacyPolicy: (privacyPolicy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'privacyPolicy' is not null or undefined
            assertParamExists('savePrivacyPolicy', 'privacyPolicy', privacyPolicy);
            const localVarPath = `/backend/api/v1/products/privacy-policies/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(privacyPolicy, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PrivacyPolicyApi - functional programming interface
 * @export
 */
export const PrivacyPolicyApiFp = function (configuration) {
    const localVarAxiosParamCreator = PrivacyPolicyApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary get privacy policies
         * @param {number} companyProductId
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPrivacyPolicies(companyProductId, page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllPrivacyPolicies(companyProductId, page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get latest privacy policies
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestPrivacyPolicies(companyProductId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLatestPrivacyPolicies(companyProductId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} privacyPolicyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrivacyPolicy(privacyPolicyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPrivacyPolicy(privacyPolicyId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {PrivacyPolicy} privacyPolicy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePrivacyPolicy(privacyPolicy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.savePrivacyPolicy(privacyPolicy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PrivacyPolicyApi - factory interface
 * @export
 */
export const PrivacyPolicyApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PrivacyPolicyApiFp(configuration);
    return {
        /**
         *
         * @summary get privacy policies
         * @param {number} companyProductId
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPrivacyPolicies(companyProductId, page, limit, options) {
            return localVarFp.getAllPrivacyPolicies(companyProductId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get latest privacy policies
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestPrivacyPolicies(companyProductId, options) {
            return localVarFp.getLatestPrivacyPolicies(companyProductId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} privacyPolicyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrivacyPolicy(privacyPolicyId, options) {
            return localVarFp.getPrivacyPolicy(privacyPolicyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {PrivacyPolicy} privacyPolicy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePrivacyPolicy(privacyPolicy, options) {
            return localVarFp.savePrivacyPolicy(privacyPolicy, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PrivacyPolicyApi - object-oriented interface
 * @export
 * @class PrivacyPolicyApi
 * @extends {BaseAPI}
 */
export class PrivacyPolicyApi extends BaseAPI {
    /**
     *
     * @summary get privacy policies
     * @param {number} companyProductId
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivacyPolicyApi
     */
    getAllPrivacyPolicies(companyProductId, page, limit, options) {
        return PrivacyPolicyApiFp(this.configuration).getAllPrivacyPolicies(companyProductId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get latest privacy policies
     * @param {number} companyProductId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivacyPolicyApi
     */
    getLatestPrivacyPolicies(companyProductId, options) {
        return PrivacyPolicyApiFp(this.configuration).getLatestPrivacyPolicies(companyProductId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} privacyPolicyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivacyPolicyApi
     */
    getPrivacyPolicy(privacyPolicyId, options) {
        return PrivacyPolicyApiFp(this.configuration).getPrivacyPolicy(privacyPolicyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {PrivacyPolicy} privacyPolicy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivacyPolicyApi
     */
    savePrivacyPolicy(privacyPolicy, options) {
        return PrivacyPolicyApiFp(this.configuration).savePrivacyPolicy(privacyPolicy, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductGroupsApi - axios parameter creator
 * @export
 */
export const ProductGroupsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary get groups
         * @param {number} [offset]
         * @param {number} [count]
         * @param {string} [sort]
         * @param {string} [searchRegex]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups: (offset, count, sort, searchRegex, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/products/groups/get-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (searchRegex !== undefined) {
                localVarQueryParameter['searchRegex'] = searchRegex;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get open channels
         * @param {number} [offset]
         * @param {number} [count]
         * @param {string} [sort]
         * @param {string} [searchRegex]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpenChannels: (offset, count, sort, searchRegex, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/products/groups/get-open-channels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (searchRegex !== undefined) {
                localVarQueryParameter['searchRegex'] = searchRegex;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductGroups: (companyProductId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getProductGroups', 'companyProductId', companyProductId);
            const localVarPath = `/backend/api/v1/products/groups/get/{companyProductId}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get the groups app product including the company product by the assisto basic code
         * @param {string} assistoBasicCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductGroupsByAssistoBasicCode: (assistoBasicCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'assistoBasicCode' is not null or undefined
            assertParamExists('getProductGroupsByAssistoBasicCode', 'assistoBasicCode', assistoBasicCode);
            const localVarPath = `/backend/api/v1/products/groups/get-by-assisto-basic-code/{assistoBasicCode}`
                .replace(`{${"assistoBasicCode"}}`, encodeURIComponent(String(assistoBasicCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get the groups app product including the company product
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductGroupsWithCompany: (companyProductId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getProductGroupsWithCompany', 'companyProductId', companyProductId);
            const localVarPath = `/backend/api/v1/products/groups/get-with-company/{companyProductId}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get public channels
         * @param {number} [offset]
         * @param {number} [count]
         * @param {string} [sort]
         * @param {string} [searchRegex]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicChannels: (offset, count, sort, searchRegex, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/products/groups/get-public-channels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (searchRegex !== undefined) {
                localVarQueryParameter['searchRegex'] = searchRegex;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary peek if there was an update to the product
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        peekProductGroups: (companyProductId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('peekProductGroups', 'companyProductId', companyProductId);
            const localVarPath = `/backend/api/v1/products/groups/peek/{companyProductId}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {File} [uploadLogo] file
         * @param {number} [companyProductId] company_product_id
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {string} [primaryColor] primary_color
         * @param {string} [secondaryColor] secondary_color
         * @param {string} [imprint] imprint
         * @param {string} [userAgreement] user_agreement
         * @param {string} [assistoBasicCode] assisto_basic_code
         * @param {boolean} [showInAssistoBasic] show_in_assisto_basic
         * @param {string} [name] name
         * @param {string} [content] content
         * @param {string} [description] description
         * @param {string} [domain] domain
         * @param {string} [aboutUs] about_us
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductGroups: (uploadLogo, companyProductId, created, modified, deleted, primaryColor, secondaryColor, imprint, userAgreement, assistoBasicCode, showInAssistoBasic, name, content, description, domain, aboutUs, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/products/groups/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (uploadLogo !== undefined) {
                localVarFormParams.append('uploadLogo', uploadLogo);
            }
            if (companyProductId !== undefined) {
                localVarFormParams.append('company_product_id', companyProductId);
            }
            if (created !== undefined) {
                localVarFormParams.append('created', created);
            }
            if (modified !== undefined) {
                localVarFormParams.append('modified', modified);
            }
            if (deleted !== undefined) {
                localVarFormParams.append('deleted', deleted);
            }
            if (primaryColor !== undefined) {
                localVarFormParams.append('primary_color', primaryColor);
            }
            if (secondaryColor !== undefined) {
                localVarFormParams.append('secondary_color', secondaryColor);
            }
            if (imprint !== undefined) {
                localVarFormParams.append('imprint', imprint);
            }
            if (userAgreement !== undefined) {
                localVarFormParams.append('user_agreement', userAgreement);
            }
            if (assistoBasicCode !== undefined) {
                localVarFormParams.append('assisto_basic_code', assistoBasicCode);
            }
            if (showInAssistoBasic !== undefined) {
                localVarFormParams.append('show_in_assisto_basic', showInAssistoBasic);
            }
            if (name !== undefined) {
                localVarFormParams.append('name', name);
            }
            if (content !== undefined) {
                localVarFormParams.append('content', content);
            }
            if (description !== undefined) {
                localVarFormParams.append('description', description);
            }
            if (domain !== undefined) {
                localVarFormParams.append('domain', domain);
            }
            if (aboutUs !== undefined) {
                localVarFormParams.append('about_us', aboutUs);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductGroupsApi - functional programming interface
 * @export
 */
export const ProductGroupsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductGroupsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary get groups
         * @param {number} [offset]
         * @param {number} [count]
         * @param {string} [sort]
         * @param {string} [searchRegex]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups(offset, count, sort, searchRegex, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getGroups(offset, count, sort, searchRegex, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get open channels
         * @param {number} [offset]
         * @param {number} [count]
         * @param {string} [sort]
         * @param {string} [searchRegex]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpenChannels(offset, count, sort, searchRegex, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOpenChannels(offset, count, sort, searchRegex, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductGroups(companyProductId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductGroups(companyProductId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get the groups app product including the company product by the assisto basic code
         * @param {string} assistoBasicCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductGroupsByAssistoBasicCode(assistoBasicCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductGroupsByAssistoBasicCode(assistoBasicCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get the groups app product including the company product
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductGroupsWithCompany(companyProductId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductGroupsWithCompany(companyProductId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get public channels
         * @param {number} [offset]
         * @param {number} [count]
         * @param {string} [sort]
         * @param {string} [searchRegex]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicChannels(offset, count, sort, searchRegex, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPublicChannels(offset, count, sort, searchRegex, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary peek if there was an update to the product
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        peekProductGroups(companyProductId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.peekProductGroups(companyProductId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {File} [uploadLogo] file
         * @param {number} [companyProductId] company_product_id
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {string} [primaryColor] primary_color
         * @param {string} [secondaryColor] secondary_color
         * @param {string} [imprint] imprint
         * @param {string} [userAgreement] user_agreement
         * @param {string} [assistoBasicCode] assisto_basic_code
         * @param {boolean} [showInAssistoBasic] show_in_assisto_basic
         * @param {string} [name] name
         * @param {string} [content] content
         * @param {string} [description] description
         * @param {string} [domain] domain
         * @param {string} [aboutUs] about_us
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductGroups(uploadLogo, companyProductId, created, modified, deleted, primaryColor, secondaryColor, imprint, userAgreement, assistoBasicCode, showInAssistoBasic, name, content, description, domain, aboutUs, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveProductGroups(uploadLogo, companyProductId, created, modified, deleted, primaryColor, secondaryColor, imprint, userAgreement, assistoBasicCode, showInAssistoBasic, name, content, description, domain, aboutUs, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProductGroupsApi - factory interface
 * @export
 */
export const ProductGroupsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductGroupsApiFp(configuration);
    return {
        /**
         *
         * @summary get groups
         * @param {number} [offset]
         * @param {number} [count]
         * @param {string} [sort]
         * @param {string} [searchRegex]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups(offset, count, sort, searchRegex, options) {
            return localVarFp.getGroups(offset, count, sort, searchRegex, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get open channels
         * @param {number} [offset]
         * @param {number} [count]
         * @param {string} [sort]
         * @param {string} [searchRegex]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpenChannels(offset, count, sort, searchRegex, options) {
            return localVarFp.getOpenChannels(offset, count, sort, searchRegex, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductGroups(companyProductId, options) {
            return localVarFp.getProductGroups(companyProductId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get the groups app product including the company product by the assisto basic code
         * @param {string} assistoBasicCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductGroupsByAssistoBasicCode(assistoBasicCode, options) {
            return localVarFp.getProductGroupsByAssistoBasicCode(assistoBasicCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get the groups app product including the company product
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductGroupsWithCompany(companyProductId, options) {
            return localVarFp.getProductGroupsWithCompany(companyProductId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get public channels
         * @param {number} [offset]
         * @param {number} [count]
         * @param {string} [sort]
         * @param {string} [searchRegex]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicChannels(offset, count, sort, searchRegex, options) {
            return localVarFp.getPublicChannels(offset, count, sort, searchRegex, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary peek if there was an update to the product
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        peekProductGroups(companyProductId, options) {
            return localVarFp.peekProductGroups(companyProductId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {File} [uploadLogo] file
         * @param {number} [companyProductId] company_product_id
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {string} [primaryColor] primary_color
         * @param {string} [secondaryColor] secondary_color
         * @param {string} [imprint] imprint
         * @param {string} [userAgreement] user_agreement
         * @param {string} [assistoBasicCode] assisto_basic_code
         * @param {boolean} [showInAssistoBasic] show_in_assisto_basic
         * @param {string} [name] name
         * @param {string} [content] content
         * @param {string} [description] description
         * @param {string} [domain] domain
         * @param {string} [aboutUs] about_us
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductGroups(uploadLogo, companyProductId, created, modified, deleted, primaryColor, secondaryColor, imprint, userAgreement, assistoBasicCode, showInAssistoBasic, name, content, description, domain, aboutUs, options) {
            return localVarFp.saveProductGroups(uploadLogo, companyProductId, created, modified, deleted, primaryColor, secondaryColor, imprint, userAgreement, assistoBasicCode, showInAssistoBasic, name, content, description, domain, aboutUs, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductGroupsApi - object-oriented interface
 * @export
 * @class ProductGroupsApi
 * @extends {BaseAPI}
 */
export class ProductGroupsApi extends BaseAPI {
    /**
     *
     * @summary get groups
     * @param {number} [offset]
     * @param {number} [count]
     * @param {string} [sort]
     * @param {string} [searchRegex]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupsApi
     */
    getGroups(offset, count, sort, searchRegex, options) {
        return ProductGroupsApiFp(this.configuration).getGroups(offset, count, sort, searchRegex, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get open channels
     * @param {number} [offset]
     * @param {number} [count]
     * @param {string} [sort]
     * @param {string} [searchRegex]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupsApi
     */
    getOpenChannels(offset, count, sort, searchRegex, options) {
        return ProductGroupsApiFp(this.configuration).getOpenChannels(offset, count, sort, searchRegex, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} companyProductId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupsApi
     */
    getProductGroups(companyProductId, options) {
        return ProductGroupsApiFp(this.configuration).getProductGroups(companyProductId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get the groups app product including the company product by the assisto basic code
     * @param {string} assistoBasicCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupsApi
     */
    getProductGroupsByAssistoBasicCode(assistoBasicCode, options) {
        return ProductGroupsApiFp(this.configuration).getProductGroupsByAssistoBasicCode(assistoBasicCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get the groups app product including the company product
     * @param {number} companyProductId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupsApi
     */
    getProductGroupsWithCompany(companyProductId, options) {
        return ProductGroupsApiFp(this.configuration).getProductGroupsWithCompany(companyProductId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get public channels
     * @param {number} [offset]
     * @param {number} [count]
     * @param {string} [sort]
     * @param {string} [searchRegex]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupsApi
     */
    getPublicChannels(offset, count, sort, searchRegex, options) {
        return ProductGroupsApiFp(this.configuration).getPublicChannels(offset, count, sort, searchRegex, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary peek if there was an update to the product
     * @param {number} companyProductId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupsApi
     */
    peekProductGroups(companyProductId, options) {
        return ProductGroupsApiFp(this.configuration).peekProductGroups(companyProductId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {File} [uploadLogo] file
     * @param {number} [companyProductId] company_product_id
     * @param {number} [created] created
     * @param {number} [modified] modified
     * @param {number} [deleted] deleted
     * @param {string} [primaryColor] primary_color
     * @param {string} [secondaryColor] secondary_color
     * @param {string} [imprint] imprint
     * @param {string} [userAgreement] user_agreement
     * @param {string} [assistoBasicCode] assisto_basic_code
     * @param {boolean} [showInAssistoBasic] show_in_assisto_basic
     * @param {string} [name] name
     * @param {string} [content] content
     * @param {string} [description] description
     * @param {string} [domain] domain
     * @param {string} [aboutUs] about_us
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupsApi
     */
    saveProductGroups(uploadLogo, companyProductId, created, modified, deleted, primaryColor, secondaryColor, imprint, userAgreement, assistoBasicCode, showInAssistoBasic, name, content, description, domain, aboutUs, options) {
        return ProductGroupsApiFp(this.configuration).saveProductGroups(uploadLogo, companyProductId, created, modified, deleted, primaryColor, secondaryColor, imprint, userAgreement, assistoBasicCode, showInAssistoBasic, name, content, description, domain, aboutUs, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductGroupsAccessibilityInformationApi - axios parameter creator
 * @export
 */
export const ProductGroupsAccessibilityInformationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary delete
         * @param {number} accessibilityInformationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductGroupsAccessibilityInformation: (accessibilityInformationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accessibilityInformationId' is not null or undefined
            assertParamExists('deleteProductGroupsAccessibilityInformation', 'accessibilityInformationId', accessibilityInformationId);
            const localVarPath = `/backend/api/v1/products/groups/accessibility-information/delete/{accessibilityInformationId}`
                .replace(`{${"accessibilityInformationId"}}`, encodeURIComponent(String(accessibilityInformationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get accessibility information elements
         * @param {number} companyProductId
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductGroupsAccessibilityInformations: (companyProductId, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getAllProductGroupsAccessibilityInformations', 'companyProductId', companyProductId);
            const localVarPath = `/backend/api/v1/products/groups/accessibility-information/get-all/{companyProductId}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} accessibilityInformationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductGroupsAccessibilityInformation: (accessibilityInformationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accessibilityInformationId' is not null or undefined
            assertParamExists('getProductGroupsAccessibilityInformation', 'accessibilityInformationId', accessibilityInformationId);
            const localVarPath = `/backend/api/v1/products/groups/accessibility-information/get/{accessibilityInformationId}`
                .replace(`{${"accessibilityInformationId"}}`, encodeURIComponent(String(accessibilityInformationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {ProductGroupsAccessibilityInformation} productGroupsAccessibilityInformation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductGroupsAccessibilityInformation: (productGroupsAccessibilityInformation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productGroupsAccessibilityInformation' is not null or undefined
            assertParamExists('saveProductGroupsAccessibilityInformation', 'productGroupsAccessibilityInformation', productGroupsAccessibilityInformation);
            const localVarPath = `/backend/api/v1/products/groups/accessibility-information/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(productGroupsAccessibilityInformation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductGroupsAccessibilityInformationApi - functional programming interface
 * @export
 */
export const ProductGroupsAccessibilityInformationApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductGroupsAccessibilityInformationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} accessibilityInformationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductGroupsAccessibilityInformation(accessibilityInformationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteProductGroupsAccessibilityInformation(accessibilityInformationId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get accessibility information elements
         * @param {number} companyProductId
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductGroupsAccessibilityInformations(companyProductId, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllProductGroupsAccessibilityInformations(companyProductId, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} accessibilityInformationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductGroupsAccessibilityInformation(accessibilityInformationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductGroupsAccessibilityInformation(accessibilityInformationId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {ProductGroupsAccessibilityInformation} productGroupsAccessibilityInformation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductGroupsAccessibilityInformation(productGroupsAccessibilityInformation, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveProductGroupsAccessibilityInformation(productGroupsAccessibilityInformation, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProductGroupsAccessibilityInformationApi - factory interface
 * @export
 */
export const ProductGroupsAccessibilityInformationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductGroupsAccessibilityInformationApiFp(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} accessibilityInformationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductGroupsAccessibilityInformation(accessibilityInformationId, options) {
            return localVarFp.deleteProductGroupsAccessibilityInformation(accessibilityInformationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get accessibility information elements
         * @param {number} companyProductId
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductGroupsAccessibilityInformations(companyProductId, limit, options) {
            return localVarFp.getAllProductGroupsAccessibilityInformations(companyProductId, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} accessibilityInformationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductGroupsAccessibilityInformation(accessibilityInformationId, options) {
            return localVarFp.getProductGroupsAccessibilityInformation(accessibilityInformationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {ProductGroupsAccessibilityInformation} productGroupsAccessibilityInformation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductGroupsAccessibilityInformation(productGroupsAccessibilityInformation, options) {
            return localVarFp.saveProductGroupsAccessibilityInformation(productGroupsAccessibilityInformation, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductGroupsAccessibilityInformationApi - object-oriented interface
 * @export
 * @class ProductGroupsAccessibilityInformationApi
 * @extends {BaseAPI}
 */
export class ProductGroupsAccessibilityInformationApi extends BaseAPI {
    /**
     *
     * @summary delete
     * @param {number} accessibilityInformationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupsAccessibilityInformationApi
     */
    deleteProductGroupsAccessibilityInformation(accessibilityInformationId, options) {
        return ProductGroupsAccessibilityInformationApiFp(this.configuration).deleteProductGroupsAccessibilityInformation(accessibilityInformationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get accessibility information elements
     * @param {number} companyProductId
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupsAccessibilityInformationApi
     */
    getAllProductGroupsAccessibilityInformations(companyProductId, limit, options) {
        return ProductGroupsAccessibilityInformationApiFp(this.configuration).getAllProductGroupsAccessibilityInformations(companyProductId, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} accessibilityInformationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupsAccessibilityInformationApi
     */
    getProductGroupsAccessibilityInformation(accessibilityInformationId, options) {
        return ProductGroupsAccessibilityInformationApiFp(this.configuration).getProductGroupsAccessibilityInformation(accessibilityInformationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {ProductGroupsAccessibilityInformation} productGroupsAccessibilityInformation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupsAccessibilityInformationApi
     */
    saveProductGroupsAccessibilityInformation(productGroupsAccessibilityInformation, options) {
        return ProductGroupsAccessibilityInformationApiFp(this.configuration).saveProductGroupsAccessibilityInformation(productGroupsAccessibilityInformation, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductGroupsFaqApi - axios parameter creator
 * @export
 */
export const ProductGroupsFaqApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary delete
         * @param {number} faqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductGroupsFaq: (faqId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'faqId' is not null or undefined
            assertParamExists('deleteProductGroupsFaq', 'faqId', faqId);
            const localVarPath = `/backend/api/v1/products/groups/faq/delete/{faqId}`
                .replace(`{${"faqId"}}`, encodeURIComponent(String(faqId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get faq elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductGroupsFaqs: (companyProductId, filtered, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getAllProductGroupsFaqs', 'companyProductId', companyProductId);
            // verify required parameter 'filtered' is not null or undefined
            assertParamExists('getAllProductGroupsFaqs', 'filtered', filtered);
            const localVarPath = `/backend/api/v1/products/groups/faq/get-all/{companyProductId}/{filtered}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)))
                .replace(`{${"filtered"}}`, encodeURIComponent(String(filtered)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} faqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductGroupsFaq: (faqId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'faqId' is not null or undefined
            assertParamExists('getProductGroupsFaq', 'faqId', faqId);
            const localVarPath = `/backend/api/v1/products/groups/faq/get/{faqId}`
                .replace(`{${"faqId"}}`, encodeURIComponent(String(faqId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {Array<ProductGroupsFaq>} productGroupsFaq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllProductGroupsFaq: (productGroupsFaq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productGroupsFaq' is not null or undefined
            assertParamExists('saveAllProductGroupsFaq', 'productGroupsFaq', productGroupsFaq);
            const localVarPath = `/backend/api/v1/products/groups/faq/save-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(productGroupsFaq, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {ProductGroupsFaq} productGroupsFaq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductGroupsFaq: (productGroupsFaq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productGroupsFaq' is not null or undefined
            assertParamExists('saveProductGroupsFaq', 'productGroupsFaq', productGroupsFaq);
            const localVarPath = `/backend/api/v1/products/groups/faq/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(productGroupsFaq, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductGroupsFaqApi - functional programming interface
 * @export
 */
export const ProductGroupsFaqApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductGroupsFaqApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} faqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductGroupsFaq(faqId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteProductGroupsFaq(faqId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get faq elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductGroupsFaqs(companyProductId, filtered, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllProductGroupsFaqs(companyProductId, filtered, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} faqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductGroupsFaq(faqId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductGroupsFaq(faqId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {Array<ProductGroupsFaq>} productGroupsFaq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllProductGroupsFaq(productGroupsFaq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveAllProductGroupsFaq(productGroupsFaq, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {ProductGroupsFaq} productGroupsFaq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductGroupsFaq(productGroupsFaq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveProductGroupsFaq(productGroupsFaq, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProductGroupsFaqApi - factory interface
 * @export
 */
export const ProductGroupsFaqApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductGroupsFaqApiFp(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} faqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductGroupsFaq(faqId, options) {
            return localVarFp.deleteProductGroupsFaq(faqId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get faq elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductGroupsFaqs(companyProductId, filtered, limit, options) {
            return localVarFp.getAllProductGroupsFaqs(companyProductId, filtered, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} faqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductGroupsFaq(faqId, options) {
            return localVarFp.getProductGroupsFaq(faqId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {Array<ProductGroupsFaq>} productGroupsFaq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllProductGroupsFaq(productGroupsFaq, options) {
            return localVarFp.saveAllProductGroupsFaq(productGroupsFaq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {ProductGroupsFaq} productGroupsFaq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductGroupsFaq(productGroupsFaq, options) {
            return localVarFp.saveProductGroupsFaq(productGroupsFaq, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductGroupsFaqApi - object-oriented interface
 * @export
 * @class ProductGroupsFaqApi
 * @extends {BaseAPI}
 */
export class ProductGroupsFaqApi extends BaseAPI {
    /**
     *
     * @summary delete
     * @param {number} faqId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupsFaqApi
     */
    deleteProductGroupsFaq(faqId, options) {
        return ProductGroupsFaqApiFp(this.configuration).deleteProductGroupsFaq(faqId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get faq elements
     * @param {number} companyProductId
     * @param {number} filtered
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupsFaqApi
     */
    getAllProductGroupsFaqs(companyProductId, filtered, limit, options) {
        return ProductGroupsFaqApiFp(this.configuration).getAllProductGroupsFaqs(companyProductId, filtered, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} faqId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupsFaqApi
     */
    getProductGroupsFaq(faqId, options) {
        return ProductGroupsFaqApiFp(this.configuration).getProductGroupsFaq(faqId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {Array<ProductGroupsFaq>} productGroupsFaq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupsFaqApi
     */
    saveAllProductGroupsFaq(productGroupsFaq, options) {
        return ProductGroupsFaqApiFp(this.configuration).saveAllProductGroupsFaq(productGroupsFaq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {ProductGroupsFaq} productGroupsFaq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupsFaqApi
     */
    saveProductGroupsFaq(productGroupsFaq, options) {
        return ProductGroupsFaqApiFp(this.configuration).saveProductGroupsFaq(productGroupsFaq, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductGroupsKnowledgeApi - axios parameter creator
 * @export
 */
export const ProductGroupsKnowledgeApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary delete
         * @param {number} knowledgeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductGroupsKnowledge: (knowledgeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'knowledgeId' is not null or undefined
            assertParamExists('deleteProductGroupsKnowledge', 'knowledgeId', knowledgeId);
            const localVarPath = `/backend/api/v1/products/groups/knowledge/delete/{knowledgeId}`
                .replace(`{${"knowledgeId"}}`, encodeURIComponent(String(knowledgeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get knowledge elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductGroupsKnowledges: (companyProductId, filtered, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getAllProductGroupsKnowledges', 'companyProductId', companyProductId);
            // verify required parameter 'filtered' is not null or undefined
            assertParamExists('getAllProductGroupsKnowledges', 'filtered', filtered);
            const localVarPath = `/backend/api/v1/products/groups/knowledge/get-all/{companyProductId}/{filtered}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)))
                .replace(`{${"filtered"}}`, encodeURIComponent(String(filtered)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} knowledgeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductGroupsKnowledge: (knowledgeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'knowledgeId' is not null or undefined
            assertParamExists('getProductGroupsKnowledge', 'knowledgeId', knowledgeId);
            const localVarPath = `/backend/api/v1/products/groups/knowledge/get/{knowledgeId}`
                .replace(`{${"knowledgeId"}}`, encodeURIComponent(String(knowledgeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {Array<ProductGroupsKnowledge>} productGroupsKnowledge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllProductGroupsKnowledge: (productGroupsKnowledge, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productGroupsKnowledge' is not null or undefined
            assertParamExists('saveAllProductGroupsKnowledge', 'productGroupsKnowledge', productGroupsKnowledge);
            const localVarPath = `/backend/api/v1/products/groups/knowledge/save-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(productGroupsKnowledge, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {ProductGroupsKnowledge} productGroupsKnowledge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductGroupsKnowledge: (productGroupsKnowledge, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productGroupsKnowledge' is not null or undefined
            assertParamExists('saveProductGroupsKnowledge', 'productGroupsKnowledge', productGroupsKnowledge);
            const localVarPath = `/backend/api/v1/products/groups/knowledge/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(productGroupsKnowledge, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductGroupsKnowledgeApi - functional programming interface
 * @export
 */
export const ProductGroupsKnowledgeApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductGroupsKnowledgeApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} knowledgeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductGroupsKnowledge(knowledgeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteProductGroupsKnowledge(knowledgeId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get knowledge elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductGroupsKnowledges(companyProductId, filtered, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllProductGroupsKnowledges(companyProductId, filtered, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} knowledgeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductGroupsKnowledge(knowledgeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductGroupsKnowledge(knowledgeId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {Array<ProductGroupsKnowledge>} productGroupsKnowledge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllProductGroupsKnowledge(productGroupsKnowledge, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveAllProductGroupsKnowledge(productGroupsKnowledge, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {ProductGroupsKnowledge} productGroupsKnowledge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductGroupsKnowledge(productGroupsKnowledge, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveProductGroupsKnowledge(productGroupsKnowledge, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProductGroupsKnowledgeApi - factory interface
 * @export
 */
export const ProductGroupsKnowledgeApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductGroupsKnowledgeApiFp(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} knowledgeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductGroupsKnowledge(knowledgeId, options) {
            return localVarFp.deleteProductGroupsKnowledge(knowledgeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get knowledge elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductGroupsKnowledges(companyProductId, filtered, limit, options) {
            return localVarFp.getAllProductGroupsKnowledges(companyProductId, filtered, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} knowledgeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductGroupsKnowledge(knowledgeId, options) {
            return localVarFp.getProductGroupsKnowledge(knowledgeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {Array<ProductGroupsKnowledge>} productGroupsKnowledge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllProductGroupsKnowledge(productGroupsKnowledge, options) {
            return localVarFp.saveAllProductGroupsKnowledge(productGroupsKnowledge, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {ProductGroupsKnowledge} productGroupsKnowledge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductGroupsKnowledge(productGroupsKnowledge, options) {
            return localVarFp.saveProductGroupsKnowledge(productGroupsKnowledge, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductGroupsKnowledgeApi - object-oriented interface
 * @export
 * @class ProductGroupsKnowledgeApi
 * @extends {BaseAPI}
 */
export class ProductGroupsKnowledgeApi extends BaseAPI {
    /**
     *
     * @summary delete
     * @param {number} knowledgeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupsKnowledgeApi
     */
    deleteProductGroupsKnowledge(knowledgeId, options) {
        return ProductGroupsKnowledgeApiFp(this.configuration).deleteProductGroupsKnowledge(knowledgeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get knowledge elements
     * @param {number} companyProductId
     * @param {number} filtered
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupsKnowledgeApi
     */
    getAllProductGroupsKnowledges(companyProductId, filtered, limit, options) {
        return ProductGroupsKnowledgeApiFp(this.configuration).getAllProductGroupsKnowledges(companyProductId, filtered, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} knowledgeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupsKnowledgeApi
     */
    getProductGroupsKnowledge(knowledgeId, options) {
        return ProductGroupsKnowledgeApiFp(this.configuration).getProductGroupsKnowledge(knowledgeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {Array<ProductGroupsKnowledge>} productGroupsKnowledge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupsKnowledgeApi
     */
    saveAllProductGroupsKnowledge(productGroupsKnowledge, options) {
        return ProductGroupsKnowledgeApiFp(this.configuration).saveAllProductGroupsKnowledge(productGroupsKnowledge, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {ProductGroupsKnowledge} productGroupsKnowledge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGroupsKnowledgeApi
     */
    saveProductGroupsKnowledge(productGroupsKnowledge, options) {
        return ProductGroupsKnowledgeApiFp(this.configuration).saveProductGroupsKnowledge(productGroupsKnowledge, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductMessengerAppApi - axios parameter creator
 * @export
 */
export const ProductMessengerAppApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary get
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMessengerApp: (companyProductId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getProductMessengerApp', 'companyProductId', companyProductId);
            const localVarPath = `/backend/api/v1/products/messenger-app/get/{companyProductId}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get the messenger app product including the company product by the assisto basic code
         * @param {string} assistoBasicCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMessengerAppByAssistoBasicCode: (assistoBasicCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'assistoBasicCode' is not null or undefined
            assertParamExists('getProductMessengerAppByAssistoBasicCode', 'assistoBasicCode', assistoBasicCode);
            const localVarPath = `/backend/api/v1/products/messenger-app/get-by-assisto-basic-code/{assistoBasicCode}`
                .replace(`{${"assistoBasicCode"}}`, encodeURIComponent(String(assistoBasicCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get the messenger app product (not basic) including the company product by the assisto basic code
         * @param {string} assistoBasicCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMessengerAppByCodeNotBasic: (assistoBasicCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'assistoBasicCode' is not null or undefined
            assertParamExists('getProductMessengerAppByCodeNotBasic', 'assistoBasicCode', assistoBasicCode);
            const localVarPath = `/backend/api/v1/products/messenger-app/get-by-code-not-basic/{assistoBasicCode}`
                .replace(`{${"assistoBasicCode"}}`, encodeURIComponent(String(assistoBasicCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get the messenger app product including the company product
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMessengerAppWithCompany: (companyProductId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getProductMessengerAppWithCompany', 'companyProductId', companyProductId);
            const localVarPath = `/backend/api/v1/products/messenger-app/get-with-company/{companyProductId}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary peek if there was an update to the product
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        peekProductMessengerApp: (companyProductId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('peekProductMessengerApp', 'companyProductId', companyProductId);
            const localVarPath = `/backend/api/v1/products/messenger-app/peek/{companyProductId}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {File} [uploadLogo] file
         * @param {number} [companyProductId] company_product_id
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {string} [primaryColor] primary_color
         * @param {string} [secondaryColor] secondary_color
         * @param {string} [imprint] imprint
         * @param {string} [userAgreement] user_agreement
         * @param {string} [assistoBasicCode] assisto_basic_code
         * @param {boolean} [showInAssistoBasic] show_in_assisto_basic
         * @param {string} [title] title
         * @param {string} [content] content
         * @param {string} [aboutUs] about_us
         * @param {string} [logo] logo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductMessengerApp: (uploadLogo, companyProductId, created, modified, deleted, primaryColor, secondaryColor, imprint, userAgreement, assistoBasicCode, showInAssistoBasic, title, content, aboutUs, logo, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/products/messenger-app/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (uploadLogo !== undefined) {
                localVarFormParams.append('uploadLogo', uploadLogo);
            }
            if (companyProductId !== undefined) {
                localVarFormParams.append('company_product_id', companyProductId);
            }
            if (created !== undefined) {
                localVarFormParams.append('created', created);
            }
            if (modified !== undefined) {
                localVarFormParams.append('modified', modified);
            }
            if (deleted !== undefined) {
                localVarFormParams.append('deleted', deleted);
            }
            if (primaryColor !== undefined) {
                localVarFormParams.append('primary_color', primaryColor);
            }
            if (secondaryColor !== undefined) {
                localVarFormParams.append('secondary_color', secondaryColor);
            }
            if (imprint !== undefined) {
                localVarFormParams.append('imprint', imprint);
            }
            if (userAgreement !== undefined) {
                localVarFormParams.append('user_agreement', userAgreement);
            }
            if (assistoBasicCode !== undefined) {
                localVarFormParams.append('assisto_basic_code', assistoBasicCode);
            }
            if (showInAssistoBasic !== undefined) {
                localVarFormParams.append('show_in_assisto_basic', showInAssistoBasic);
            }
            if (title !== undefined) {
                localVarFormParams.append('title', title);
            }
            if (content !== undefined) {
                localVarFormParams.append('content', content);
            }
            if (aboutUs !== undefined) {
                localVarFormParams.append('about_us', aboutUs);
            }
            if (logo !== undefined) {
                localVarFormParams.append('logo', logo);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductMessengerAppApi - functional programming interface
 * @export
 */
export const ProductMessengerAppApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductMessengerAppApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary get
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMessengerApp(companyProductId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductMessengerApp(companyProductId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get the messenger app product including the company product by the assisto basic code
         * @param {string} assistoBasicCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMessengerAppByAssistoBasicCode(assistoBasicCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductMessengerAppByAssistoBasicCode(assistoBasicCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get the messenger app product (not basic) including the company product by the assisto basic code
         * @param {string} assistoBasicCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMessengerAppByCodeNotBasic(assistoBasicCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductMessengerAppByCodeNotBasic(assistoBasicCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get the messenger app product including the company product
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMessengerAppWithCompany(companyProductId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductMessengerAppWithCompany(companyProductId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary peek if there was an update to the product
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        peekProductMessengerApp(companyProductId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.peekProductMessengerApp(companyProductId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {File} [uploadLogo] file
         * @param {number} [companyProductId] company_product_id
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {string} [primaryColor] primary_color
         * @param {string} [secondaryColor] secondary_color
         * @param {string} [imprint] imprint
         * @param {string} [userAgreement] user_agreement
         * @param {string} [assistoBasicCode] assisto_basic_code
         * @param {boolean} [showInAssistoBasic] show_in_assisto_basic
         * @param {string} [title] title
         * @param {string} [content] content
         * @param {string} [aboutUs] about_us
         * @param {string} [logo] logo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductMessengerApp(uploadLogo, companyProductId, created, modified, deleted, primaryColor, secondaryColor, imprint, userAgreement, assistoBasicCode, showInAssistoBasic, title, content, aboutUs, logo, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveProductMessengerApp(uploadLogo, companyProductId, created, modified, deleted, primaryColor, secondaryColor, imprint, userAgreement, assistoBasicCode, showInAssistoBasic, title, content, aboutUs, logo, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProductMessengerAppApi - factory interface
 * @export
 */
export const ProductMessengerAppApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductMessengerAppApiFp(configuration);
    return {
        /**
         *
         * @summary get
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMessengerApp(companyProductId, options) {
            return localVarFp.getProductMessengerApp(companyProductId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get the messenger app product including the company product by the assisto basic code
         * @param {string} assistoBasicCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMessengerAppByAssistoBasicCode(assistoBasicCode, options) {
            return localVarFp.getProductMessengerAppByAssistoBasicCode(assistoBasicCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get the messenger app product (not basic) including the company product by the assisto basic code
         * @param {string} assistoBasicCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMessengerAppByCodeNotBasic(assistoBasicCode, options) {
            return localVarFp.getProductMessengerAppByCodeNotBasic(assistoBasicCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get the messenger app product including the company product
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMessengerAppWithCompany(companyProductId, options) {
            return localVarFp.getProductMessengerAppWithCompany(companyProductId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary peek if there was an update to the product
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        peekProductMessengerApp(companyProductId, options) {
            return localVarFp.peekProductMessengerApp(companyProductId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {File} [uploadLogo] file
         * @param {number} [companyProductId] company_product_id
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {string} [primaryColor] primary_color
         * @param {string} [secondaryColor] secondary_color
         * @param {string} [imprint] imprint
         * @param {string} [userAgreement] user_agreement
         * @param {string} [assistoBasicCode] assisto_basic_code
         * @param {boolean} [showInAssistoBasic] show_in_assisto_basic
         * @param {string} [title] title
         * @param {string} [content] content
         * @param {string} [aboutUs] about_us
         * @param {string} [logo] logo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductMessengerApp(uploadLogo, companyProductId, created, modified, deleted, primaryColor, secondaryColor, imprint, userAgreement, assistoBasicCode, showInAssistoBasic, title, content, aboutUs, logo, options) {
            return localVarFp.saveProductMessengerApp(uploadLogo, companyProductId, created, modified, deleted, primaryColor, secondaryColor, imprint, userAgreement, assistoBasicCode, showInAssistoBasic, title, content, aboutUs, logo, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductMessengerAppApi - object-oriented interface
 * @export
 * @class ProductMessengerAppApi
 * @extends {BaseAPI}
 */
export class ProductMessengerAppApi extends BaseAPI {
    /**
     *
     * @summary get
     * @param {number} companyProductId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMessengerAppApi
     */
    getProductMessengerApp(companyProductId, options) {
        return ProductMessengerAppApiFp(this.configuration).getProductMessengerApp(companyProductId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get the messenger app product including the company product by the assisto basic code
     * @param {string} assistoBasicCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMessengerAppApi
     */
    getProductMessengerAppByAssistoBasicCode(assistoBasicCode, options) {
        return ProductMessengerAppApiFp(this.configuration).getProductMessengerAppByAssistoBasicCode(assistoBasicCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get the messenger app product (not basic) including the company product by the assisto basic code
     * @param {string} assistoBasicCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMessengerAppApi
     */
    getProductMessengerAppByCodeNotBasic(assistoBasicCode, options) {
        return ProductMessengerAppApiFp(this.configuration).getProductMessengerAppByCodeNotBasic(assistoBasicCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get the messenger app product including the company product
     * @param {number} companyProductId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMessengerAppApi
     */
    getProductMessengerAppWithCompany(companyProductId, options) {
        return ProductMessengerAppApiFp(this.configuration).getProductMessengerAppWithCompany(companyProductId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary peek if there was an update to the product
     * @param {number} companyProductId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMessengerAppApi
     */
    peekProductMessengerApp(companyProductId, options) {
        return ProductMessengerAppApiFp(this.configuration).peekProductMessengerApp(companyProductId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {File} [uploadLogo] file
     * @param {number} [companyProductId] company_product_id
     * @param {number} [created] created
     * @param {number} [modified] modified
     * @param {number} [deleted] deleted
     * @param {string} [primaryColor] primary_color
     * @param {string} [secondaryColor] secondary_color
     * @param {string} [imprint] imprint
     * @param {string} [userAgreement] user_agreement
     * @param {string} [assistoBasicCode] assisto_basic_code
     * @param {boolean} [showInAssistoBasic] show_in_assisto_basic
     * @param {string} [title] title
     * @param {string} [content] content
     * @param {string} [aboutUs] about_us
     * @param {string} [logo] logo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMessengerAppApi
     */
    saveProductMessengerApp(uploadLogo, companyProductId, created, modified, deleted, primaryColor, secondaryColor, imprint, userAgreement, assistoBasicCode, showInAssistoBasic, title, content, aboutUs, logo, options) {
        return ProductMessengerAppApiFp(this.configuration).saveProductMessengerApp(uploadLogo, companyProductId, created, modified, deleted, primaryColor, secondaryColor, imprint, userAgreement, assistoBasicCode, showInAssistoBasic, title, content, aboutUs, logo, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductMessengerAppAccessibilityInformationApi - axios parameter creator
 * @export
 */
export const ProductMessengerAppAccessibilityInformationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary delete
         * @param {number} accessibilityInformationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductMessengerAppAccessibilityInformation: (accessibilityInformationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accessibilityInformationId' is not null or undefined
            assertParamExists('deleteProductMessengerAppAccessibilityInformation', 'accessibilityInformationId', accessibilityInformationId);
            const localVarPath = `/backend/api/v1/products/messenger-app/accessibility-information/delete/{accessibilityInformationId}`
                .replace(`{${"accessibilityInformationId"}}`, encodeURIComponent(String(accessibilityInformationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get accessibility information elements
         * @param {number} companyProductId
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductMessengerAppAccessibilityInformations: (companyProductId, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getAllProductMessengerAppAccessibilityInformations', 'companyProductId', companyProductId);
            const localVarPath = `/backend/api/v1/products/messenger-app/accessibility-information/get-all/{companyProductId}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} accessibilityInformationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMessengerAppAccessibilityInformation: (accessibilityInformationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accessibilityInformationId' is not null or undefined
            assertParamExists('getProductMessengerAppAccessibilityInformation', 'accessibilityInformationId', accessibilityInformationId);
            const localVarPath = `/backend/api/v1/products/messenger-app/accessibility-information/get/{accessibilityInformationId}`
                .replace(`{${"accessibilityInformationId"}}`, encodeURIComponent(String(accessibilityInformationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {ProductMessengerAppAccessibilityInformation} productMessengerAppAccessibilityInformation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductMessengerAppAccessibilityInformation: (productMessengerAppAccessibilityInformation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productMessengerAppAccessibilityInformation' is not null or undefined
            assertParamExists('saveProductMessengerAppAccessibilityInformation', 'productMessengerAppAccessibilityInformation', productMessengerAppAccessibilityInformation);
            const localVarPath = `/backend/api/v1/products/messenger-app/accessibility-information/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(productMessengerAppAccessibilityInformation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductMessengerAppAccessibilityInformationApi - functional programming interface
 * @export
 */
export const ProductMessengerAppAccessibilityInformationApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductMessengerAppAccessibilityInformationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} accessibilityInformationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductMessengerAppAccessibilityInformation(accessibilityInformationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteProductMessengerAppAccessibilityInformation(accessibilityInformationId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get accessibility information elements
         * @param {number} companyProductId
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductMessengerAppAccessibilityInformations(companyProductId, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllProductMessengerAppAccessibilityInformations(companyProductId, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} accessibilityInformationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMessengerAppAccessibilityInformation(accessibilityInformationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductMessengerAppAccessibilityInformation(accessibilityInformationId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {ProductMessengerAppAccessibilityInformation} productMessengerAppAccessibilityInformation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductMessengerAppAccessibilityInformation(productMessengerAppAccessibilityInformation, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveProductMessengerAppAccessibilityInformation(productMessengerAppAccessibilityInformation, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProductMessengerAppAccessibilityInformationApi - factory interface
 * @export
 */
export const ProductMessengerAppAccessibilityInformationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductMessengerAppAccessibilityInformationApiFp(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} accessibilityInformationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductMessengerAppAccessibilityInformation(accessibilityInformationId, options) {
            return localVarFp.deleteProductMessengerAppAccessibilityInformation(accessibilityInformationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get accessibility information elements
         * @param {number} companyProductId
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductMessengerAppAccessibilityInformations(companyProductId, limit, options) {
            return localVarFp.getAllProductMessengerAppAccessibilityInformations(companyProductId, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} accessibilityInformationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMessengerAppAccessibilityInformation(accessibilityInformationId, options) {
            return localVarFp.getProductMessengerAppAccessibilityInformation(accessibilityInformationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {ProductMessengerAppAccessibilityInformation} productMessengerAppAccessibilityInformation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductMessengerAppAccessibilityInformation(productMessengerAppAccessibilityInformation, options) {
            return localVarFp.saveProductMessengerAppAccessibilityInformation(productMessengerAppAccessibilityInformation, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductMessengerAppAccessibilityInformationApi - object-oriented interface
 * @export
 * @class ProductMessengerAppAccessibilityInformationApi
 * @extends {BaseAPI}
 */
export class ProductMessengerAppAccessibilityInformationApi extends BaseAPI {
    /**
     *
     * @summary delete
     * @param {number} accessibilityInformationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMessengerAppAccessibilityInformationApi
     */
    deleteProductMessengerAppAccessibilityInformation(accessibilityInformationId, options) {
        return ProductMessengerAppAccessibilityInformationApiFp(this.configuration).deleteProductMessengerAppAccessibilityInformation(accessibilityInformationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get accessibility information elements
     * @param {number} companyProductId
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMessengerAppAccessibilityInformationApi
     */
    getAllProductMessengerAppAccessibilityInformations(companyProductId, limit, options) {
        return ProductMessengerAppAccessibilityInformationApiFp(this.configuration).getAllProductMessengerAppAccessibilityInformations(companyProductId, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} accessibilityInformationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMessengerAppAccessibilityInformationApi
     */
    getProductMessengerAppAccessibilityInformation(accessibilityInformationId, options) {
        return ProductMessengerAppAccessibilityInformationApiFp(this.configuration).getProductMessengerAppAccessibilityInformation(accessibilityInformationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {ProductMessengerAppAccessibilityInformation} productMessengerAppAccessibilityInformation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMessengerAppAccessibilityInformationApi
     */
    saveProductMessengerAppAccessibilityInformation(productMessengerAppAccessibilityInformation, options) {
        return ProductMessengerAppAccessibilityInformationApiFp(this.configuration).saveProductMessengerAppAccessibilityInformation(productMessengerAppAccessibilityInformation, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductMessengerAppFaqApi - axios parameter creator
 * @export
 */
export const ProductMessengerAppFaqApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary delete
         * @param {number} faqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductMessengerAppFaq: (faqId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'faqId' is not null or undefined
            assertParamExists('deleteProductMessengerAppFaq', 'faqId', faqId);
            const localVarPath = `/backend/api/v1/products/messenger-app/faq/delete/{faqId}`
                .replace(`{${"faqId"}}`, encodeURIComponent(String(faqId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get faq elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductMessengerAppFaqs: (companyProductId, filtered, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getAllProductMessengerAppFaqs', 'companyProductId', companyProductId);
            // verify required parameter 'filtered' is not null or undefined
            assertParamExists('getAllProductMessengerAppFaqs', 'filtered', filtered);
            const localVarPath = `/backend/api/v1/products/messenger-app/faq/get-all/{companyProductId}/{filtered}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)))
                .replace(`{${"filtered"}}`, encodeURIComponent(String(filtered)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} faqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMessengerAppFaq: (faqId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'faqId' is not null or undefined
            assertParamExists('getProductMessengerAppFaq', 'faqId', faqId);
            const localVarPath = `/backend/api/v1/products/messenger-app/faq/get/{faqId}`
                .replace(`{${"faqId"}}`, encodeURIComponent(String(faqId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {Array<ProductMessengerAppFaq>} productMessengerAppFaq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllProductMessengerAppFaq: (productMessengerAppFaq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productMessengerAppFaq' is not null or undefined
            assertParamExists('saveAllProductMessengerAppFaq', 'productMessengerAppFaq', productMessengerAppFaq);
            const localVarPath = `/backend/api/v1/products/messenger-app/faq/save-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(productMessengerAppFaq, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {ProductMessengerAppFaq} productMessengerAppFaq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductMessengerAppFaq: (productMessengerAppFaq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productMessengerAppFaq' is not null or undefined
            assertParamExists('saveProductMessengerAppFaq', 'productMessengerAppFaq', productMessengerAppFaq);
            const localVarPath = `/backend/api/v1/products/messenger-app/faq/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(productMessengerAppFaq, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductMessengerAppFaqApi - functional programming interface
 * @export
 */
export const ProductMessengerAppFaqApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductMessengerAppFaqApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} faqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductMessengerAppFaq(faqId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteProductMessengerAppFaq(faqId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get faq elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductMessengerAppFaqs(companyProductId, filtered, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllProductMessengerAppFaqs(companyProductId, filtered, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} faqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMessengerAppFaq(faqId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductMessengerAppFaq(faqId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {Array<ProductMessengerAppFaq>} productMessengerAppFaq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllProductMessengerAppFaq(productMessengerAppFaq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveAllProductMessengerAppFaq(productMessengerAppFaq, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {ProductMessengerAppFaq} productMessengerAppFaq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductMessengerAppFaq(productMessengerAppFaq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveProductMessengerAppFaq(productMessengerAppFaq, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProductMessengerAppFaqApi - factory interface
 * @export
 */
export const ProductMessengerAppFaqApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductMessengerAppFaqApiFp(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} faqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductMessengerAppFaq(faqId, options) {
            return localVarFp.deleteProductMessengerAppFaq(faqId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get faq elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductMessengerAppFaqs(companyProductId, filtered, limit, options) {
            return localVarFp.getAllProductMessengerAppFaqs(companyProductId, filtered, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} faqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMessengerAppFaq(faqId, options) {
            return localVarFp.getProductMessengerAppFaq(faqId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {Array<ProductMessengerAppFaq>} productMessengerAppFaq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllProductMessengerAppFaq(productMessengerAppFaq, options) {
            return localVarFp.saveAllProductMessengerAppFaq(productMessengerAppFaq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {ProductMessengerAppFaq} productMessengerAppFaq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductMessengerAppFaq(productMessengerAppFaq, options) {
            return localVarFp.saveProductMessengerAppFaq(productMessengerAppFaq, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductMessengerAppFaqApi - object-oriented interface
 * @export
 * @class ProductMessengerAppFaqApi
 * @extends {BaseAPI}
 */
export class ProductMessengerAppFaqApi extends BaseAPI {
    /**
     *
     * @summary delete
     * @param {number} faqId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMessengerAppFaqApi
     */
    deleteProductMessengerAppFaq(faqId, options) {
        return ProductMessengerAppFaqApiFp(this.configuration).deleteProductMessengerAppFaq(faqId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get faq elements
     * @param {number} companyProductId
     * @param {number} filtered
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMessengerAppFaqApi
     */
    getAllProductMessengerAppFaqs(companyProductId, filtered, limit, options) {
        return ProductMessengerAppFaqApiFp(this.configuration).getAllProductMessengerAppFaqs(companyProductId, filtered, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} faqId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMessengerAppFaqApi
     */
    getProductMessengerAppFaq(faqId, options) {
        return ProductMessengerAppFaqApiFp(this.configuration).getProductMessengerAppFaq(faqId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {Array<ProductMessengerAppFaq>} productMessengerAppFaq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMessengerAppFaqApi
     */
    saveAllProductMessengerAppFaq(productMessengerAppFaq, options) {
        return ProductMessengerAppFaqApiFp(this.configuration).saveAllProductMessengerAppFaq(productMessengerAppFaq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {ProductMessengerAppFaq} productMessengerAppFaq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMessengerAppFaqApi
     */
    saveProductMessengerAppFaq(productMessengerAppFaq, options) {
        return ProductMessengerAppFaqApiFp(this.configuration).saveProductMessengerAppFaq(productMessengerAppFaq, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductMessengerAppKnowledgeApi - axios parameter creator
 * @export
 */
export const ProductMessengerAppKnowledgeApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary delete
         * @param {number} knowledgeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductMessengerAppKnowledge: (knowledgeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'knowledgeId' is not null or undefined
            assertParamExists('deleteProductMessengerAppKnowledge', 'knowledgeId', knowledgeId);
            const localVarPath = `/backend/api/v1/products/messenger-app/knowledge/delete/{knowledgeId}`
                .replace(`{${"knowledgeId"}}`, encodeURIComponent(String(knowledgeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get knowledge elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductMessengerAppKnowledges: (companyProductId, filtered, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getAllProductMessengerAppKnowledges', 'companyProductId', companyProductId);
            // verify required parameter 'filtered' is not null or undefined
            assertParamExists('getAllProductMessengerAppKnowledges', 'filtered', filtered);
            const localVarPath = `/backend/api/v1/products/messenger-app/knowledge/get-all/{companyProductId}/{filtered}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)))
                .replace(`{${"filtered"}}`, encodeURIComponent(String(filtered)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} knowledgeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMessengerAppKnowledge: (knowledgeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'knowledgeId' is not null or undefined
            assertParamExists('getProductMessengerAppKnowledge', 'knowledgeId', knowledgeId);
            const localVarPath = `/backend/api/v1/products/messenger-app/knowledge/get/{knowledgeId}`
                .replace(`{${"knowledgeId"}}`, encodeURIComponent(String(knowledgeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {Array<ProductMessengerAppKnowledge>} productMessengerAppKnowledge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllProductMessengerAppKnowledge: (productMessengerAppKnowledge, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productMessengerAppKnowledge' is not null or undefined
            assertParamExists('saveAllProductMessengerAppKnowledge', 'productMessengerAppKnowledge', productMessengerAppKnowledge);
            const localVarPath = `/backend/api/v1/products/messenger-app/knowledge/save-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(productMessengerAppKnowledge, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {string} [uploadImage] uploadImage
         * @param {number} [id] id
         * @param {number} [companyProductId] company_product_id
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {string} [title] title
         * @param {string} [content] content
         * @param {number} [placement] placement
         * @param {boolean} [isActive] is_active
         * @param {string} [image] image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductMessengerAppKnowledge: (uploadImage, id, companyProductId, created, modified, deleted, title, content, placement, isActive, image, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/products/messenger-app/knowledge/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (uploadImage !== undefined) {
                localVarFormParams.append('uploadImage', uploadImage);
            }
            if (id !== undefined) {
                localVarFormParams.append('id', id);
            }
            if (companyProductId !== undefined) {
                localVarFormParams.append('company_product_id', companyProductId);
            }
            if (created !== undefined) {
                localVarFormParams.append('created', created);
            }
            if (modified !== undefined) {
                localVarFormParams.append('modified', modified);
            }
            if (deleted !== undefined) {
                localVarFormParams.append('deleted', deleted);
            }
            if (title !== undefined) {
                localVarFormParams.append('title', title);
            }
            if (content !== undefined) {
                localVarFormParams.append('content', content);
            }
            if (placement !== undefined) {
                localVarFormParams.append('placement', placement);
            }
            if (isActive !== undefined) {
                localVarFormParams.append('is_active', isActive);
            }
            if (image !== undefined) {
                localVarFormParams.append('image', image);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductMessengerAppKnowledgeApi - functional programming interface
 * @export
 */
export const ProductMessengerAppKnowledgeApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductMessengerAppKnowledgeApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} knowledgeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductMessengerAppKnowledge(knowledgeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteProductMessengerAppKnowledge(knowledgeId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get knowledge elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductMessengerAppKnowledges(companyProductId, filtered, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllProductMessengerAppKnowledges(companyProductId, filtered, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} knowledgeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMessengerAppKnowledge(knowledgeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductMessengerAppKnowledge(knowledgeId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {Array<ProductMessengerAppKnowledge>} productMessengerAppKnowledge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllProductMessengerAppKnowledge(productMessengerAppKnowledge, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveAllProductMessengerAppKnowledge(productMessengerAppKnowledge, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {string} [uploadImage] uploadImage
         * @param {number} [id] id
         * @param {number} [companyProductId] company_product_id
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {string} [title] title
         * @param {string} [content] content
         * @param {number} [placement] placement
         * @param {boolean} [isActive] is_active
         * @param {string} [image] image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductMessengerAppKnowledge(uploadImage, id, companyProductId, created, modified, deleted, title, content, placement, isActive, image, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveProductMessengerAppKnowledge(uploadImage, id, companyProductId, created, modified, deleted, title, content, placement, isActive, image, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProductMessengerAppKnowledgeApi - factory interface
 * @export
 */
export const ProductMessengerAppKnowledgeApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductMessengerAppKnowledgeApiFp(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} knowledgeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductMessengerAppKnowledge(knowledgeId, options) {
            return localVarFp.deleteProductMessengerAppKnowledge(knowledgeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get knowledge elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductMessengerAppKnowledges(companyProductId, filtered, limit, options) {
            return localVarFp.getAllProductMessengerAppKnowledges(companyProductId, filtered, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} knowledgeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMessengerAppKnowledge(knowledgeId, options) {
            return localVarFp.getProductMessengerAppKnowledge(knowledgeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {Array<ProductMessengerAppKnowledge>} productMessengerAppKnowledge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllProductMessengerAppKnowledge(productMessengerAppKnowledge, options) {
            return localVarFp.saveAllProductMessengerAppKnowledge(productMessengerAppKnowledge, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {string} [uploadImage] uploadImage
         * @param {number} [id] id
         * @param {number} [companyProductId] company_product_id
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {string} [title] title
         * @param {string} [content] content
         * @param {number} [placement] placement
         * @param {boolean} [isActive] is_active
         * @param {string} [image] image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductMessengerAppKnowledge(uploadImage, id, companyProductId, created, modified, deleted, title, content, placement, isActive, image, options) {
            return localVarFp.saveProductMessengerAppKnowledge(uploadImage, id, companyProductId, created, modified, deleted, title, content, placement, isActive, image, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductMessengerAppKnowledgeApi - object-oriented interface
 * @export
 * @class ProductMessengerAppKnowledgeApi
 * @extends {BaseAPI}
 */
export class ProductMessengerAppKnowledgeApi extends BaseAPI {
    /**
     *
     * @summary delete
     * @param {number} knowledgeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMessengerAppKnowledgeApi
     */
    deleteProductMessengerAppKnowledge(knowledgeId, options) {
        return ProductMessengerAppKnowledgeApiFp(this.configuration).deleteProductMessengerAppKnowledge(knowledgeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get knowledge elements
     * @param {number} companyProductId
     * @param {number} filtered
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMessengerAppKnowledgeApi
     */
    getAllProductMessengerAppKnowledges(companyProductId, filtered, limit, options) {
        return ProductMessengerAppKnowledgeApiFp(this.configuration).getAllProductMessengerAppKnowledges(companyProductId, filtered, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} knowledgeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMessengerAppKnowledgeApi
     */
    getProductMessengerAppKnowledge(knowledgeId, options) {
        return ProductMessengerAppKnowledgeApiFp(this.configuration).getProductMessengerAppKnowledge(knowledgeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {Array<ProductMessengerAppKnowledge>} productMessengerAppKnowledge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMessengerAppKnowledgeApi
     */
    saveAllProductMessengerAppKnowledge(productMessengerAppKnowledge, options) {
        return ProductMessengerAppKnowledgeApiFp(this.configuration).saveAllProductMessengerAppKnowledge(productMessengerAppKnowledge, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {string} [uploadImage] uploadImage
     * @param {number} [id] id
     * @param {number} [companyProductId] company_product_id
     * @param {number} [created] created
     * @param {number} [modified] modified
     * @param {number} [deleted] deleted
     * @param {string} [title] title
     * @param {string} [content] content
     * @param {number} [placement] placement
     * @param {boolean} [isActive] is_active
     * @param {string} [image] image
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMessengerAppKnowledgeApi
     */
    saveProductMessengerAppKnowledge(uploadImage, id, companyProductId, created, modified, deleted, title, content, placement, isActive, image, options) {
        return ProductMessengerAppKnowledgeApiFp(this.configuration).saveProductMessengerAppKnowledge(uploadImage, id, companyProductId, created, modified, deleted, title, content, placement, isActive, image, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductQuestoApi - axios parameter creator
 * @export
 */
export const ProductQuestoApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Reserved for the questo API to authenticate the user against assisto by their JWT.
         * @summary check authentication of the user for questo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateQuestoUser: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/products/questo/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductQuesto: (companyProductId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getProductQuesto', 'companyProductId', companyProductId);
            const localVarPath = `/backend/api/v1/products/questo/get/{companyProductId}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get by domain
         * @param {string} questoDomain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductQuestoByDomain: (questoDomain, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'questoDomain' is not null or undefined
            assertParamExists('getProductQuestoByDomain', 'questoDomain', questoDomain);
            const localVarPath = `/backend/api/v1/products/questo/get-by-domain/{questoDomain}`
                .replace(`{${"questoDomain"}}`, encodeURIComponent(String(questoDomain)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get the questo product including the company product
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductQuestoWithCompany: (companyProductId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getProductQuestoWithCompany', 'companyProductId', companyProductId);
            const localVarPath = `/backend/api/v1/products/questo/get-with-company/{companyProductId}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {string} [uploadLogo] uploadLogo
         * @param {string} [uploadDashboardBgImage] uploadDashboardBgImage
         * @param {string} [uploadFavicon] uploadFavicon
         * @param {number} [companyProductId] company_product_id
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {string} [domain] domain
         * @param {string} [title] title
         * @param {string} [primaryColor] primary_color
         * @param {string} [secondaryColor] secondary_color
         * @param {string} [description] description
         * @param {string} [termsOfService] terms_of_service
         * @param {string} [imprint] imprint
         * @param {string} [privacyPolicy] privacy_policy
         * @param {string} [dashboardBgImage] dashboard_bg_image
         * @param {string} [favicon] favicon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductQuesto: (uploadLogo, uploadDashboardBgImage, uploadFavicon, companyProductId, created, modified, deleted, domain, title, primaryColor, secondaryColor, description, termsOfService, imprint, privacyPolicy, dashboardBgImage, favicon, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/products/questo/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (uploadLogo !== undefined) {
                localVarFormParams.append('uploadLogo', uploadLogo);
            }
            if (uploadDashboardBgImage !== undefined) {
                localVarFormParams.append('uploadDashboardBgImage', uploadDashboardBgImage);
            }
            if (uploadFavicon !== undefined) {
                localVarFormParams.append('uploadFavicon', uploadFavicon);
            }
            if (companyProductId !== undefined) {
                localVarFormParams.append('company_product_id', companyProductId);
            }
            if (created !== undefined) {
                localVarFormParams.append('created', created);
            }
            if (modified !== undefined) {
                localVarFormParams.append('modified', modified);
            }
            if (deleted !== undefined) {
                localVarFormParams.append('deleted', deleted);
            }
            if (domain !== undefined) {
                localVarFormParams.append('domain', domain);
            }
            if (title !== undefined) {
                localVarFormParams.append('title', title);
            }
            if (primaryColor !== undefined) {
                localVarFormParams.append('primary_color', primaryColor);
            }
            if (secondaryColor !== undefined) {
                localVarFormParams.append('secondary_color', secondaryColor);
            }
            if (description !== undefined) {
                localVarFormParams.append('description', description);
            }
            if (termsOfService !== undefined) {
                localVarFormParams.append('terms_of_service', termsOfService);
            }
            if (imprint !== undefined) {
                localVarFormParams.append('imprint', imprint);
            }
            if (privacyPolicy !== undefined) {
                localVarFormParams.append('privacy_policy', privacyPolicy);
            }
            if (dashboardBgImage !== undefined) {
                localVarFormParams.append('dashboard_bg_image', dashboardBgImage);
            }
            if (favicon !== undefined) {
                localVarFormParams.append('favicon', favicon);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductQuestoApi - functional programming interface
 * @export
 */
export const ProductQuestoApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductQuestoApiAxiosParamCreator(configuration);
    return {
        /**
         * Reserved for the questo API to authenticate the user against assisto by their JWT.
         * @summary check authentication of the user for questo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateQuestoUser(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authenticateQuestoUser(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductQuesto(companyProductId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductQuesto(companyProductId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get by domain
         * @param {string} questoDomain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductQuestoByDomain(questoDomain, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductQuestoByDomain(questoDomain, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get the questo product including the company product
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductQuestoWithCompany(companyProductId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductQuestoWithCompany(companyProductId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {string} [uploadLogo] uploadLogo
         * @param {string} [uploadDashboardBgImage] uploadDashboardBgImage
         * @param {string} [uploadFavicon] uploadFavicon
         * @param {number} [companyProductId] company_product_id
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {string} [domain] domain
         * @param {string} [title] title
         * @param {string} [primaryColor] primary_color
         * @param {string} [secondaryColor] secondary_color
         * @param {string} [description] description
         * @param {string} [termsOfService] terms_of_service
         * @param {string} [imprint] imprint
         * @param {string} [privacyPolicy] privacy_policy
         * @param {string} [dashboardBgImage] dashboard_bg_image
         * @param {string} [favicon] favicon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductQuesto(uploadLogo, uploadDashboardBgImage, uploadFavicon, companyProductId, created, modified, deleted, domain, title, primaryColor, secondaryColor, description, termsOfService, imprint, privacyPolicy, dashboardBgImage, favicon, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveProductQuesto(uploadLogo, uploadDashboardBgImage, uploadFavicon, companyProductId, created, modified, deleted, domain, title, primaryColor, secondaryColor, description, termsOfService, imprint, privacyPolicy, dashboardBgImage, favicon, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProductQuestoApi - factory interface
 * @export
 */
export const ProductQuestoApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductQuestoApiFp(configuration);
    return {
        /**
         * Reserved for the questo API to authenticate the user against assisto by their JWT.
         * @summary check authentication of the user for questo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateQuestoUser(options) {
            return localVarFp.authenticateQuestoUser(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductQuesto(companyProductId, options) {
            return localVarFp.getProductQuesto(companyProductId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get by domain
         * @param {string} questoDomain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductQuestoByDomain(questoDomain, options) {
            return localVarFp.getProductQuestoByDomain(questoDomain, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get the questo product including the company product
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductQuestoWithCompany(companyProductId, options) {
            return localVarFp.getProductQuestoWithCompany(companyProductId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {string} [uploadLogo] uploadLogo
         * @param {string} [uploadDashboardBgImage] uploadDashboardBgImage
         * @param {string} [uploadFavicon] uploadFavicon
         * @param {number} [companyProductId] company_product_id
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {string} [domain] domain
         * @param {string} [title] title
         * @param {string} [primaryColor] primary_color
         * @param {string} [secondaryColor] secondary_color
         * @param {string} [description] description
         * @param {string} [termsOfService] terms_of_service
         * @param {string} [imprint] imprint
         * @param {string} [privacyPolicy] privacy_policy
         * @param {string} [dashboardBgImage] dashboard_bg_image
         * @param {string} [favicon] favicon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductQuesto(uploadLogo, uploadDashboardBgImage, uploadFavicon, companyProductId, created, modified, deleted, domain, title, primaryColor, secondaryColor, description, termsOfService, imprint, privacyPolicy, dashboardBgImage, favicon, options) {
            return localVarFp.saveProductQuesto(uploadLogo, uploadDashboardBgImage, uploadFavicon, companyProductId, created, modified, deleted, domain, title, primaryColor, secondaryColor, description, termsOfService, imprint, privacyPolicy, dashboardBgImage, favicon, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductQuestoApi - object-oriented interface
 * @export
 * @class ProductQuestoApi
 * @extends {BaseAPI}
 */
export class ProductQuestoApi extends BaseAPI {
    /**
     * Reserved for the questo API to authenticate the user against assisto by their JWT.
     * @summary check authentication of the user for questo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductQuestoApi
     */
    authenticateQuestoUser(options) {
        return ProductQuestoApiFp(this.configuration).authenticateQuestoUser(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} companyProductId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductQuestoApi
     */
    getProductQuesto(companyProductId, options) {
        return ProductQuestoApiFp(this.configuration).getProductQuesto(companyProductId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get by domain
     * @param {string} questoDomain
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductQuestoApi
     */
    getProductQuestoByDomain(questoDomain, options) {
        return ProductQuestoApiFp(this.configuration).getProductQuestoByDomain(questoDomain, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get the questo product including the company product
     * @param {number} companyProductId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductQuestoApi
     */
    getProductQuestoWithCompany(companyProductId, options) {
        return ProductQuestoApiFp(this.configuration).getProductQuestoWithCompany(companyProductId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {string} [uploadLogo] uploadLogo
     * @param {string} [uploadDashboardBgImage] uploadDashboardBgImage
     * @param {string} [uploadFavicon] uploadFavicon
     * @param {number} [companyProductId] company_product_id
     * @param {number} [created] created
     * @param {number} [modified] modified
     * @param {number} [deleted] deleted
     * @param {string} [domain] domain
     * @param {string} [title] title
     * @param {string} [primaryColor] primary_color
     * @param {string} [secondaryColor] secondary_color
     * @param {string} [description] description
     * @param {string} [termsOfService] terms_of_service
     * @param {string} [imprint] imprint
     * @param {string} [privacyPolicy] privacy_policy
     * @param {string} [dashboardBgImage] dashboard_bg_image
     * @param {string} [favicon] favicon
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductQuestoApi
     */
    saveProductQuesto(uploadLogo, uploadDashboardBgImage, uploadFavicon, companyProductId, created, modified, deleted, domain, title, primaryColor, secondaryColor, description, termsOfService, imprint, privacyPolicy, dashboardBgImage, favicon, options) {
        return ProductQuestoApiFp(this.configuration).saveProductQuesto(uploadLogo, uploadDashboardBgImage, uploadFavicon, companyProductId, created, modified, deleted, domain, title, primaryColor, secondaryColor, description, termsOfService, imprint, privacyPolicy, dashboardBgImage, favicon, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductWebBasicApi - axios parameter creator
 * @export
 */
export const ProductWebBasicApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary get
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWebBasic: (companyProductId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getProductWebBasic', 'companyProductId', companyProductId);
            const localVarPath = `/backend/api/v1/products/web-basic/get/{companyProductId}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {string} [uploadLogo] uploadLogo
         * @param {string} [uploadDashboardBgImage] uploadDashboardBgImage
         * @param {number} [id] product id
         * @param {number} [companyProductId] company_product_id
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {string} [domain] domain
         * @param {string} [primaryColor] primary_color
         * @param {string} [secondaryColor] secondary_color
         * @param {string} [name] name
         * @param {string} [title] title
         * @param {string} [description] description
         * @param {string} [userAgreement] user_agreement
         * @param {string} [imprint] imprint
         * @param {string} [logo] logo
         * @param {boolean} [allowMessenger] allow_messenger
         * @param {boolean} [topicFilterEnabled] topic_filter_enabled
         * @param {boolean} [adviserListEnabled] adviser_list_enabled
         * @param {boolean} [exitBtn] exit_btn
         * @param {string} [aboutUs] about_us
         * @param {string} [privacyPolicy] privacy_policy
         * @param {string} [dashboardBgImage] dashboard_bg_image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductWebBasic: (uploadLogo, uploadDashboardBgImage, id, companyProductId, created, modified, deleted, domain, primaryColor, secondaryColor, name, title, description, userAgreement, imprint, logo, allowMessenger, topicFilterEnabled, adviserListEnabled, exitBtn, aboutUs, privacyPolicy, dashboardBgImage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/products/web-basic/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (uploadLogo !== undefined) {
                localVarFormParams.append('uploadLogo', uploadLogo);
            }
            if (uploadDashboardBgImage !== undefined) {
                localVarFormParams.append('uploadDashboardBgImage', uploadDashboardBgImage);
            }
            if (id !== undefined) {
                localVarFormParams.append('id', id);
            }
            if (companyProductId !== undefined) {
                localVarFormParams.append('company_product_id', companyProductId);
            }
            if (created !== undefined) {
                localVarFormParams.append('created', created);
            }
            if (modified !== undefined) {
                localVarFormParams.append('modified', modified);
            }
            if (deleted !== undefined) {
                localVarFormParams.append('deleted', deleted);
            }
            if (domain !== undefined) {
                localVarFormParams.append('domain', domain);
            }
            if (primaryColor !== undefined) {
                localVarFormParams.append('primary_color', primaryColor);
            }
            if (secondaryColor !== undefined) {
                localVarFormParams.append('secondary_color', secondaryColor);
            }
            if (name !== undefined) {
                localVarFormParams.append('name', name);
            }
            if (title !== undefined) {
                localVarFormParams.append('title', title);
            }
            if (description !== undefined) {
                localVarFormParams.append('description', description);
            }
            if (userAgreement !== undefined) {
                localVarFormParams.append('user_agreement', userAgreement);
            }
            if (imprint !== undefined) {
                localVarFormParams.append('imprint', imprint);
            }
            if (logo !== undefined) {
                localVarFormParams.append('logo', logo);
            }
            if (allowMessenger !== undefined) {
                localVarFormParams.append('allow_messenger', allowMessenger);
            }
            if (topicFilterEnabled !== undefined) {
                localVarFormParams.append('topic_filter_enabled', topicFilterEnabled);
            }
            if (adviserListEnabled !== undefined) {
                localVarFormParams.append('adviser_list_enabled', adviserListEnabled);
            }
            if (exitBtn !== undefined) {
                localVarFormParams.append('exit_btn', exitBtn);
            }
            if (aboutUs !== undefined) {
                localVarFormParams.append('about_us', aboutUs);
            }
            if (privacyPolicy !== undefined) {
                localVarFormParams.append('privacy_policy', privacyPolicy);
            }
            if (dashboardBgImage !== undefined) {
                localVarFormParams.append('dashboard_bg_image', dashboardBgImage);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductWebBasicApi - functional programming interface
 * @export
 */
export const ProductWebBasicApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductWebBasicApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary get
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWebBasic(companyProductId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductWebBasic(companyProductId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {string} [uploadLogo] uploadLogo
         * @param {string} [uploadDashboardBgImage] uploadDashboardBgImage
         * @param {number} [id] product id
         * @param {number} [companyProductId] company_product_id
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {string} [domain] domain
         * @param {string} [primaryColor] primary_color
         * @param {string} [secondaryColor] secondary_color
         * @param {string} [name] name
         * @param {string} [title] title
         * @param {string} [description] description
         * @param {string} [userAgreement] user_agreement
         * @param {string} [imprint] imprint
         * @param {string} [logo] logo
         * @param {boolean} [allowMessenger] allow_messenger
         * @param {boolean} [topicFilterEnabled] topic_filter_enabled
         * @param {boolean} [adviserListEnabled] adviser_list_enabled
         * @param {boolean} [exitBtn] exit_btn
         * @param {string} [aboutUs] about_us
         * @param {string} [privacyPolicy] privacy_policy
         * @param {string} [dashboardBgImage] dashboard_bg_image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductWebBasic(uploadLogo, uploadDashboardBgImage, id, companyProductId, created, modified, deleted, domain, primaryColor, secondaryColor, name, title, description, userAgreement, imprint, logo, allowMessenger, topicFilterEnabled, adviserListEnabled, exitBtn, aboutUs, privacyPolicy, dashboardBgImage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveProductWebBasic(uploadLogo, uploadDashboardBgImage, id, companyProductId, created, modified, deleted, domain, primaryColor, secondaryColor, name, title, description, userAgreement, imprint, logo, allowMessenger, topicFilterEnabled, adviserListEnabled, exitBtn, aboutUs, privacyPolicy, dashboardBgImage, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProductWebBasicApi - factory interface
 * @export
 */
export const ProductWebBasicApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductWebBasicApiFp(configuration);
    return {
        /**
         *
         * @summary get
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWebBasic(companyProductId, options) {
            return localVarFp.getProductWebBasic(companyProductId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {string} [uploadLogo] uploadLogo
         * @param {string} [uploadDashboardBgImage] uploadDashboardBgImage
         * @param {number} [id] product id
         * @param {number} [companyProductId] company_product_id
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {string} [domain] domain
         * @param {string} [primaryColor] primary_color
         * @param {string} [secondaryColor] secondary_color
         * @param {string} [name] name
         * @param {string} [title] title
         * @param {string} [description] description
         * @param {string} [userAgreement] user_agreement
         * @param {string} [imprint] imprint
         * @param {string} [logo] logo
         * @param {boolean} [allowMessenger] allow_messenger
         * @param {boolean} [topicFilterEnabled] topic_filter_enabled
         * @param {boolean} [adviserListEnabled] adviser_list_enabled
         * @param {boolean} [exitBtn] exit_btn
         * @param {string} [aboutUs] about_us
         * @param {string} [privacyPolicy] privacy_policy
         * @param {string} [dashboardBgImage] dashboard_bg_image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductWebBasic(uploadLogo, uploadDashboardBgImage, id, companyProductId, created, modified, deleted, domain, primaryColor, secondaryColor, name, title, description, userAgreement, imprint, logo, allowMessenger, topicFilterEnabled, adviserListEnabled, exitBtn, aboutUs, privacyPolicy, dashboardBgImage, options) {
            return localVarFp.saveProductWebBasic(uploadLogo, uploadDashboardBgImage, id, companyProductId, created, modified, deleted, domain, primaryColor, secondaryColor, name, title, description, userAgreement, imprint, logo, allowMessenger, topicFilterEnabled, adviserListEnabled, exitBtn, aboutUs, privacyPolicy, dashboardBgImage, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductWebBasicApi - object-oriented interface
 * @export
 * @class ProductWebBasicApi
 * @extends {BaseAPI}
 */
export class ProductWebBasicApi extends BaseAPI {
    /**
     *
     * @summary get
     * @param {number} companyProductId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebBasicApi
     */
    getProductWebBasic(companyProductId, options) {
        return ProductWebBasicApiFp(this.configuration).getProductWebBasic(companyProductId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {string} [uploadLogo] uploadLogo
     * @param {string} [uploadDashboardBgImage] uploadDashboardBgImage
     * @param {number} [id] product id
     * @param {number} [companyProductId] company_product_id
     * @param {number} [created] created
     * @param {number} [modified] modified
     * @param {number} [deleted] deleted
     * @param {string} [domain] domain
     * @param {string} [primaryColor] primary_color
     * @param {string} [secondaryColor] secondary_color
     * @param {string} [name] name
     * @param {string} [title] title
     * @param {string} [description] description
     * @param {string} [userAgreement] user_agreement
     * @param {string} [imprint] imprint
     * @param {string} [logo] logo
     * @param {boolean} [allowMessenger] allow_messenger
     * @param {boolean} [topicFilterEnabled] topic_filter_enabled
     * @param {boolean} [adviserListEnabled] adviser_list_enabled
     * @param {boolean} [exitBtn] exit_btn
     * @param {string} [aboutUs] about_us
     * @param {string} [privacyPolicy] privacy_policy
     * @param {string} [dashboardBgImage] dashboard_bg_image
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebBasicApi
     */
    saveProductWebBasic(uploadLogo, uploadDashboardBgImage, id, companyProductId, created, modified, deleted, domain, primaryColor, secondaryColor, name, title, description, userAgreement, imprint, logo, allowMessenger, topicFilterEnabled, adviserListEnabled, exitBtn, aboutUs, privacyPolicy, dashboardBgImage, options) {
        return ProductWebBasicApiFp(this.configuration).saveProductWebBasic(uploadLogo, uploadDashboardBgImage, id, companyProductId, created, modified, deleted, domain, primaryColor, secondaryColor, name, title, description, userAgreement, imprint, logo, allowMessenger, topicFilterEnabled, adviserListEnabled, exitBtn, aboutUs, privacyPolicy, dashboardBgImage, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductWebBasicFaqApi - axios parameter creator
 * @export
 */
export const ProductWebBasicFaqApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary delete
         * @param {number} faqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductWebBasicFaq: (faqId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'faqId' is not null or undefined
            assertParamExists('deleteProductWebBasicFaq', 'faqId', faqId);
            const localVarPath = `/backend/api/v1/products/web-basic/faq/delete/{faqId}`
                .replace(`{${"faqId"}}`, encodeURIComponent(String(faqId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get faq elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductWebBasicFaqs: (companyProductId, filtered, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getAllProductWebBasicFaqs', 'companyProductId', companyProductId);
            // verify required parameter 'filtered' is not null or undefined
            assertParamExists('getAllProductWebBasicFaqs', 'filtered', filtered);
            const localVarPath = `/backend/api/v1/products/web-basic/faq/get-all/{companyProductId}/{filtered}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)))
                .replace(`{${"filtered"}}`, encodeURIComponent(String(filtered)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} faqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWebBasicFaq: (faqId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'faqId' is not null or undefined
            assertParamExists('getProductWebBasicFaq', 'faqId', faqId);
            const localVarPath = `/backend/api/v1/products/web-basic/faq/get/{faqId}`
                .replace(`{${"faqId"}}`, encodeURIComponent(String(faqId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {Array<ProductWebBasicFaq>} productWebBasicFaq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllProductWebBasicFaq: (productWebBasicFaq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productWebBasicFaq' is not null or undefined
            assertParamExists('saveAllProductWebBasicFaq', 'productWebBasicFaq', productWebBasicFaq);
            const localVarPath = `/backend/api/v1/products/web-basic/faq/save-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(productWebBasicFaq, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {ProductWebBasicFaq} productWebBasicFaq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductWebBasicFaq: (productWebBasicFaq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productWebBasicFaq' is not null or undefined
            assertParamExists('saveProductWebBasicFaq', 'productWebBasicFaq', productWebBasicFaq);
            const localVarPath = `/backend/api/v1/products/web-basic/faq/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(productWebBasicFaq, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary take over faq elements
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        takeOverLegacyFaqs: (companyProductId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('takeOverLegacyFaqs', 'companyProductId', companyProductId);
            const localVarPath = `/backend/api/v1/products/web-basic/faq/take-over-legacy-faq/{companyProductId}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductWebBasicFaqApi - functional programming interface
 * @export
 */
export const ProductWebBasicFaqApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductWebBasicFaqApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} faqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductWebBasicFaq(faqId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteProductWebBasicFaq(faqId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get faq elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductWebBasicFaqs(companyProductId, filtered, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllProductWebBasicFaqs(companyProductId, filtered, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} faqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWebBasicFaq(faqId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductWebBasicFaq(faqId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {Array<ProductWebBasicFaq>} productWebBasicFaq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllProductWebBasicFaq(productWebBasicFaq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveAllProductWebBasicFaq(productWebBasicFaq, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {ProductWebBasicFaq} productWebBasicFaq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductWebBasicFaq(productWebBasicFaq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveProductWebBasicFaq(productWebBasicFaq, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary take over faq elements
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        takeOverLegacyFaqs(companyProductId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.takeOverLegacyFaqs(companyProductId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProductWebBasicFaqApi - factory interface
 * @export
 */
export const ProductWebBasicFaqApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductWebBasicFaqApiFp(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} faqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductWebBasicFaq(faqId, options) {
            return localVarFp.deleteProductWebBasicFaq(faqId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get faq elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductWebBasicFaqs(companyProductId, filtered, limit, options) {
            return localVarFp.getAllProductWebBasicFaqs(companyProductId, filtered, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} faqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWebBasicFaq(faqId, options) {
            return localVarFp.getProductWebBasicFaq(faqId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {Array<ProductWebBasicFaq>} productWebBasicFaq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllProductWebBasicFaq(productWebBasicFaq, options) {
            return localVarFp.saveAllProductWebBasicFaq(productWebBasicFaq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {ProductWebBasicFaq} productWebBasicFaq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductWebBasicFaq(productWebBasicFaq, options) {
            return localVarFp.saveProductWebBasicFaq(productWebBasicFaq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary take over faq elements
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        takeOverLegacyFaqs(companyProductId, options) {
            return localVarFp.takeOverLegacyFaqs(companyProductId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductWebBasicFaqApi - object-oriented interface
 * @export
 * @class ProductWebBasicFaqApi
 * @extends {BaseAPI}
 */
export class ProductWebBasicFaqApi extends BaseAPI {
    /**
     *
     * @summary delete
     * @param {number} faqId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebBasicFaqApi
     */
    deleteProductWebBasicFaq(faqId, options) {
        return ProductWebBasicFaqApiFp(this.configuration).deleteProductWebBasicFaq(faqId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get faq elements
     * @param {number} companyProductId
     * @param {number} filtered
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebBasicFaqApi
     */
    getAllProductWebBasicFaqs(companyProductId, filtered, limit, options) {
        return ProductWebBasicFaqApiFp(this.configuration).getAllProductWebBasicFaqs(companyProductId, filtered, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} faqId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebBasicFaqApi
     */
    getProductWebBasicFaq(faqId, options) {
        return ProductWebBasicFaqApiFp(this.configuration).getProductWebBasicFaq(faqId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {Array<ProductWebBasicFaq>} productWebBasicFaq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebBasicFaqApi
     */
    saveAllProductWebBasicFaq(productWebBasicFaq, options) {
        return ProductWebBasicFaqApiFp(this.configuration).saveAllProductWebBasicFaq(productWebBasicFaq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {ProductWebBasicFaq} productWebBasicFaq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebBasicFaqApi
     */
    saveProductWebBasicFaq(productWebBasicFaq, options) {
        return ProductWebBasicFaqApiFp(this.configuration).saveProductWebBasicFaq(productWebBasicFaq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary take over faq elements
     * @param {number} companyProductId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebBasicFaqApi
     */
    takeOverLegacyFaqs(companyProductId, options) {
        return ProductWebBasicFaqApiFp(this.configuration).takeOverLegacyFaqs(companyProductId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductWebMessengerApi - axios parameter creator
 * @export
 */
export const ProductWebMessengerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary get
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWebMessenger: (companyProductId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getProductWebMessenger', 'companyProductId', companyProductId);
            const localVarPath = `/backend/api/v1/products/web-messenger/get/{companyProductId}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get the messenger app product including the company product
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWebMessengerWithCompany: (companyProductId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getProductWebMessengerWithCompany', 'companyProductId', companyProductId);
            const localVarPath = `/backend/api/v1/products/web-messenger/get-with-company/{companyProductId}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary peek if there was an update to the product
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        peekProductWebMessenger: (companyProductId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('peekProductWebMessenger', 'companyProductId', companyProductId);
            const localVarPath = `/backend/api/v1/products/web-messenger/peek/{companyProductId}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {File} [uploadLogo] file
         * @param {number} [companyProductId] company_product_id
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {string} [domain] domain
         * @param {string} [primaryColor] primary_color
         * @param {string} [secondaryColor] secondary_color
         * @param {string} [imprint] imprint
         * @param {string} [userAgreement] user_agreement
         * @param {string} [name] name
         * @param {string} [description] description
         * @param {string} [privacyPolicy] privacy_policy
         * @param {string} [aboutUs] about_us
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductWebMessenger: (uploadLogo, companyProductId, created, modified, deleted, domain, primaryColor, secondaryColor, imprint, userAgreement, name, description, privacyPolicy, aboutUs, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/products/web-messenger/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (uploadLogo !== undefined) {
                localVarFormParams.append('uploadLogo', uploadLogo);
            }
            if (companyProductId !== undefined) {
                localVarFormParams.append('company_product_id', companyProductId);
            }
            if (created !== undefined) {
                localVarFormParams.append('created', created);
            }
            if (modified !== undefined) {
                localVarFormParams.append('modified', modified);
            }
            if (deleted !== undefined) {
                localVarFormParams.append('deleted', deleted);
            }
            if (domain !== undefined) {
                localVarFormParams.append('domain', domain);
            }
            if (primaryColor !== undefined) {
                localVarFormParams.append('primary_color', primaryColor);
            }
            if (secondaryColor !== undefined) {
                localVarFormParams.append('secondary_color', secondaryColor);
            }
            if (imprint !== undefined) {
                localVarFormParams.append('imprint', imprint);
            }
            if (userAgreement !== undefined) {
                localVarFormParams.append('user_agreement', userAgreement);
            }
            if (name !== undefined) {
                localVarFormParams.append('name', name);
            }
            if (description !== undefined) {
                localVarFormParams.append('description', description);
            }
            if (privacyPolicy !== undefined) {
                localVarFormParams.append('privacy_policy', privacyPolicy);
            }
            if (aboutUs !== undefined) {
                localVarFormParams.append('about_us', aboutUs);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductWebMessengerApi - functional programming interface
 * @export
 */
export const ProductWebMessengerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductWebMessengerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary get
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWebMessenger(companyProductId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductWebMessenger(companyProductId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get the messenger app product including the company product
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWebMessengerWithCompany(companyProductId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductWebMessengerWithCompany(companyProductId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary peek if there was an update to the product
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        peekProductWebMessenger(companyProductId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.peekProductWebMessenger(companyProductId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {File} [uploadLogo] file
         * @param {number} [companyProductId] company_product_id
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {string} [domain] domain
         * @param {string} [primaryColor] primary_color
         * @param {string} [secondaryColor] secondary_color
         * @param {string} [imprint] imprint
         * @param {string} [userAgreement] user_agreement
         * @param {string} [name] name
         * @param {string} [description] description
         * @param {string} [privacyPolicy] privacy_policy
         * @param {string} [aboutUs] about_us
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductWebMessenger(uploadLogo, companyProductId, created, modified, deleted, domain, primaryColor, secondaryColor, imprint, userAgreement, name, description, privacyPolicy, aboutUs, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveProductWebMessenger(uploadLogo, companyProductId, created, modified, deleted, domain, primaryColor, secondaryColor, imprint, userAgreement, name, description, privacyPolicy, aboutUs, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProductWebMessengerApi - factory interface
 * @export
 */
export const ProductWebMessengerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductWebMessengerApiFp(configuration);
    return {
        /**
         *
         * @summary get
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWebMessenger(companyProductId, options) {
            return localVarFp.getProductWebMessenger(companyProductId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get the messenger app product including the company product
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWebMessengerWithCompany(companyProductId, options) {
            return localVarFp.getProductWebMessengerWithCompany(companyProductId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary peek if there was an update to the product
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        peekProductWebMessenger(companyProductId, options) {
            return localVarFp.peekProductWebMessenger(companyProductId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {File} [uploadLogo] file
         * @param {number} [companyProductId] company_product_id
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {string} [domain] domain
         * @param {string} [primaryColor] primary_color
         * @param {string} [secondaryColor] secondary_color
         * @param {string} [imprint] imprint
         * @param {string} [userAgreement] user_agreement
         * @param {string} [name] name
         * @param {string} [description] description
         * @param {string} [privacyPolicy] privacy_policy
         * @param {string} [aboutUs] about_us
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductWebMessenger(uploadLogo, companyProductId, created, modified, deleted, domain, primaryColor, secondaryColor, imprint, userAgreement, name, description, privacyPolicy, aboutUs, options) {
            return localVarFp.saveProductWebMessenger(uploadLogo, companyProductId, created, modified, deleted, domain, primaryColor, secondaryColor, imprint, userAgreement, name, description, privacyPolicy, aboutUs, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductWebMessengerApi - object-oriented interface
 * @export
 * @class ProductWebMessengerApi
 * @extends {BaseAPI}
 */
export class ProductWebMessengerApi extends BaseAPI {
    /**
     *
     * @summary get
     * @param {number} companyProductId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebMessengerApi
     */
    getProductWebMessenger(companyProductId, options) {
        return ProductWebMessengerApiFp(this.configuration).getProductWebMessenger(companyProductId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get the messenger app product including the company product
     * @param {number} companyProductId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebMessengerApi
     */
    getProductWebMessengerWithCompany(companyProductId, options) {
        return ProductWebMessengerApiFp(this.configuration).getProductWebMessengerWithCompany(companyProductId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary peek if there was an update to the product
     * @param {number} companyProductId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebMessengerApi
     */
    peekProductWebMessenger(companyProductId, options) {
        return ProductWebMessengerApiFp(this.configuration).peekProductWebMessenger(companyProductId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {File} [uploadLogo] file
     * @param {number} [companyProductId] company_product_id
     * @param {number} [created] created
     * @param {number} [modified] modified
     * @param {number} [deleted] deleted
     * @param {string} [domain] domain
     * @param {string} [primaryColor] primary_color
     * @param {string} [secondaryColor] secondary_color
     * @param {string} [imprint] imprint
     * @param {string} [userAgreement] user_agreement
     * @param {string} [name] name
     * @param {string} [description] description
     * @param {string} [privacyPolicy] privacy_policy
     * @param {string} [aboutUs] about_us
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebMessengerApi
     */
    saveProductWebMessenger(uploadLogo, companyProductId, created, modified, deleted, domain, primaryColor, secondaryColor, imprint, userAgreement, name, description, privacyPolicy, aboutUs, options) {
        return ProductWebMessengerApiFp(this.configuration).saveProductWebMessenger(uploadLogo, companyProductId, created, modified, deleted, domain, primaryColor, secondaryColor, imprint, userAgreement, name, description, privacyPolicy, aboutUs, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductWebMessengerAccessibilityInformationApi - axios parameter creator
 * @export
 */
export const ProductWebMessengerAccessibilityInformationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary delete
         * @param {number} accessibilityInformationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductWebMessengerAccessibilityInformation: (accessibilityInformationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accessibilityInformationId' is not null or undefined
            assertParamExists('deleteProductWebMessengerAccessibilityInformation', 'accessibilityInformationId', accessibilityInformationId);
            const localVarPath = `/backend/api/v1/products/web-messenger/accessibility-information/delete/{accessibilityInformationId}`
                .replace(`{${"accessibilityInformationId"}}`, encodeURIComponent(String(accessibilityInformationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get accessibility information elements
         * @param {number} companyProductId
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductWebMessengerAccessibilityInformations: (companyProductId, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getAllProductWebMessengerAccessibilityInformations', 'companyProductId', companyProductId);
            const localVarPath = `/backend/api/v1/products/web-messenger/accessibility-information/get-all/{companyProductId}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} accessibilityInformationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWebMessengerAccessibilityInformation: (accessibilityInformationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accessibilityInformationId' is not null or undefined
            assertParamExists('getProductWebMessengerAccessibilityInformation', 'accessibilityInformationId', accessibilityInformationId);
            const localVarPath = `/backend/api/v1/products/web-messenger/accessibility-information/get/{accessibilityInformationId}`
                .replace(`{${"accessibilityInformationId"}}`, encodeURIComponent(String(accessibilityInformationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {ProductWebMessengerAccessibilityInformation} productWebMessengerAccessibilityInformation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductWebMessengerAccessibilityInformation: (productWebMessengerAccessibilityInformation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productWebMessengerAccessibilityInformation' is not null or undefined
            assertParamExists('saveProductWebMessengerAccessibilityInformation', 'productWebMessengerAccessibilityInformation', productWebMessengerAccessibilityInformation);
            const localVarPath = `/backend/api/v1/products/web-messenger/accessibility-information/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(productWebMessengerAccessibilityInformation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductWebMessengerAccessibilityInformationApi - functional programming interface
 * @export
 */
export const ProductWebMessengerAccessibilityInformationApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductWebMessengerAccessibilityInformationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} accessibilityInformationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductWebMessengerAccessibilityInformation(accessibilityInformationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteProductWebMessengerAccessibilityInformation(accessibilityInformationId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get accessibility information elements
         * @param {number} companyProductId
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductWebMessengerAccessibilityInformations(companyProductId, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllProductWebMessengerAccessibilityInformations(companyProductId, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} accessibilityInformationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWebMessengerAccessibilityInformation(accessibilityInformationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductWebMessengerAccessibilityInformation(accessibilityInformationId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {ProductWebMessengerAccessibilityInformation} productWebMessengerAccessibilityInformation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductWebMessengerAccessibilityInformation(productWebMessengerAccessibilityInformation, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveProductWebMessengerAccessibilityInformation(productWebMessengerAccessibilityInformation, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProductWebMessengerAccessibilityInformationApi - factory interface
 * @export
 */
export const ProductWebMessengerAccessibilityInformationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductWebMessengerAccessibilityInformationApiFp(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} accessibilityInformationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductWebMessengerAccessibilityInformation(accessibilityInformationId, options) {
            return localVarFp.deleteProductWebMessengerAccessibilityInformation(accessibilityInformationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get accessibility information elements
         * @param {number} companyProductId
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductWebMessengerAccessibilityInformations(companyProductId, limit, options) {
            return localVarFp.getAllProductWebMessengerAccessibilityInformations(companyProductId, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} accessibilityInformationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWebMessengerAccessibilityInformation(accessibilityInformationId, options) {
            return localVarFp.getProductWebMessengerAccessibilityInformation(accessibilityInformationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {ProductWebMessengerAccessibilityInformation} productWebMessengerAccessibilityInformation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductWebMessengerAccessibilityInformation(productWebMessengerAccessibilityInformation, options) {
            return localVarFp.saveProductWebMessengerAccessibilityInformation(productWebMessengerAccessibilityInformation, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductWebMessengerAccessibilityInformationApi - object-oriented interface
 * @export
 * @class ProductWebMessengerAccessibilityInformationApi
 * @extends {BaseAPI}
 */
export class ProductWebMessengerAccessibilityInformationApi extends BaseAPI {
    /**
     *
     * @summary delete
     * @param {number} accessibilityInformationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebMessengerAccessibilityInformationApi
     */
    deleteProductWebMessengerAccessibilityInformation(accessibilityInformationId, options) {
        return ProductWebMessengerAccessibilityInformationApiFp(this.configuration).deleteProductWebMessengerAccessibilityInformation(accessibilityInformationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get accessibility information elements
     * @param {number} companyProductId
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebMessengerAccessibilityInformationApi
     */
    getAllProductWebMessengerAccessibilityInformations(companyProductId, limit, options) {
        return ProductWebMessengerAccessibilityInformationApiFp(this.configuration).getAllProductWebMessengerAccessibilityInformations(companyProductId, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} accessibilityInformationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebMessengerAccessibilityInformationApi
     */
    getProductWebMessengerAccessibilityInformation(accessibilityInformationId, options) {
        return ProductWebMessengerAccessibilityInformationApiFp(this.configuration).getProductWebMessengerAccessibilityInformation(accessibilityInformationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {ProductWebMessengerAccessibilityInformation} productWebMessengerAccessibilityInformation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebMessengerAccessibilityInformationApi
     */
    saveProductWebMessengerAccessibilityInformation(productWebMessengerAccessibilityInformation, options) {
        return ProductWebMessengerAccessibilityInformationApiFp(this.configuration).saveProductWebMessengerAccessibilityInformation(productWebMessengerAccessibilityInformation, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductWebMessengerFaqApi - axios parameter creator
 * @export
 */
export const ProductWebMessengerFaqApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary delete
         * @param {number} faqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductWebMessengerFaq: (faqId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'faqId' is not null or undefined
            assertParamExists('deleteProductWebMessengerFaq', 'faqId', faqId);
            const localVarPath = `/backend/api/v1/products/web-messenger/faq/delete/{faqId}`
                .replace(`{${"faqId"}}`, encodeURIComponent(String(faqId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get faq elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductWebMessengerFaqs: (companyProductId, filtered, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getAllProductWebMessengerFaqs', 'companyProductId', companyProductId);
            // verify required parameter 'filtered' is not null or undefined
            assertParamExists('getAllProductWebMessengerFaqs', 'filtered', filtered);
            const localVarPath = `/backend/api/v1/products/web-messenger/faq/get-all/{companyProductId}/{filtered}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)))
                .replace(`{${"filtered"}}`, encodeURIComponent(String(filtered)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} faqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWebMessengerFaq: (faqId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'faqId' is not null or undefined
            assertParamExists('getProductWebMessengerFaq', 'faqId', faqId);
            const localVarPath = `/backend/api/v1/products/web-messenger/faq/get/{faqId}`
                .replace(`{${"faqId"}}`, encodeURIComponent(String(faqId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {Array<ProductWebMessengerFaq>} productWebMessengerFaq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllProductWebMessengerFaq: (productWebMessengerFaq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productWebMessengerFaq' is not null or undefined
            assertParamExists('saveAllProductWebMessengerFaq', 'productWebMessengerFaq', productWebMessengerFaq);
            const localVarPath = `/backend/api/v1/products/web-messenger/faq/save-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(productWebMessengerFaq, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {ProductWebMessengerFaq} productWebMessengerFaq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductWebMessengerFaq: (productWebMessengerFaq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productWebMessengerFaq' is not null or undefined
            assertParamExists('saveProductWebMessengerFaq', 'productWebMessengerFaq', productWebMessengerFaq);
            const localVarPath = `/backend/api/v1/products/web-messenger/faq/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(productWebMessengerFaq, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductWebMessengerFaqApi - functional programming interface
 * @export
 */
export const ProductWebMessengerFaqApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductWebMessengerFaqApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} faqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductWebMessengerFaq(faqId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteProductWebMessengerFaq(faqId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get faq elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductWebMessengerFaqs(companyProductId, filtered, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllProductWebMessengerFaqs(companyProductId, filtered, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} faqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWebMessengerFaq(faqId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductWebMessengerFaq(faqId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {Array<ProductWebMessengerFaq>} productWebMessengerFaq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllProductWebMessengerFaq(productWebMessengerFaq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveAllProductWebMessengerFaq(productWebMessengerFaq, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {ProductWebMessengerFaq} productWebMessengerFaq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductWebMessengerFaq(productWebMessengerFaq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveProductWebMessengerFaq(productWebMessengerFaq, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProductWebMessengerFaqApi - factory interface
 * @export
 */
export const ProductWebMessengerFaqApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductWebMessengerFaqApiFp(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} faqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductWebMessengerFaq(faqId, options) {
            return localVarFp.deleteProductWebMessengerFaq(faqId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get faq elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductWebMessengerFaqs(companyProductId, filtered, limit, options) {
            return localVarFp.getAllProductWebMessengerFaqs(companyProductId, filtered, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} faqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWebMessengerFaq(faqId, options) {
            return localVarFp.getProductWebMessengerFaq(faqId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {Array<ProductWebMessengerFaq>} productWebMessengerFaq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllProductWebMessengerFaq(productWebMessengerFaq, options) {
            return localVarFp.saveAllProductWebMessengerFaq(productWebMessengerFaq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {ProductWebMessengerFaq} productWebMessengerFaq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductWebMessengerFaq(productWebMessengerFaq, options) {
            return localVarFp.saveProductWebMessengerFaq(productWebMessengerFaq, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductWebMessengerFaqApi - object-oriented interface
 * @export
 * @class ProductWebMessengerFaqApi
 * @extends {BaseAPI}
 */
export class ProductWebMessengerFaqApi extends BaseAPI {
    /**
     *
     * @summary delete
     * @param {number} faqId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebMessengerFaqApi
     */
    deleteProductWebMessengerFaq(faqId, options) {
        return ProductWebMessengerFaqApiFp(this.configuration).deleteProductWebMessengerFaq(faqId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get faq elements
     * @param {number} companyProductId
     * @param {number} filtered
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebMessengerFaqApi
     */
    getAllProductWebMessengerFaqs(companyProductId, filtered, limit, options) {
        return ProductWebMessengerFaqApiFp(this.configuration).getAllProductWebMessengerFaqs(companyProductId, filtered, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} faqId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebMessengerFaqApi
     */
    getProductWebMessengerFaq(faqId, options) {
        return ProductWebMessengerFaqApiFp(this.configuration).getProductWebMessengerFaq(faqId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {Array<ProductWebMessengerFaq>} productWebMessengerFaq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebMessengerFaqApi
     */
    saveAllProductWebMessengerFaq(productWebMessengerFaq, options) {
        return ProductWebMessengerFaqApiFp(this.configuration).saveAllProductWebMessengerFaq(productWebMessengerFaq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {ProductWebMessengerFaq} productWebMessengerFaq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebMessengerFaqApi
     */
    saveProductWebMessengerFaq(productWebMessengerFaq, options) {
        return ProductWebMessengerFaqApiFp(this.configuration).saveProductWebMessengerFaq(productWebMessengerFaq, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductWebMessengerKnowledgeApi - axios parameter creator
 * @export
 */
export const ProductWebMessengerKnowledgeApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary delete
         * @param {number} knowledgeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductWebMessengerKnowledge: (knowledgeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'knowledgeId' is not null or undefined
            assertParamExists('deleteProductWebMessengerKnowledge', 'knowledgeId', knowledgeId);
            const localVarPath = `/backend/api/v1/products/web-messenger/knowledge/delete/{knowledgeId}`
                .replace(`{${"knowledgeId"}}`, encodeURIComponent(String(knowledgeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get knowledge elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductWebMessengerKnowledges: (companyProductId, filtered, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getAllProductWebMessengerKnowledges', 'companyProductId', companyProductId);
            // verify required parameter 'filtered' is not null or undefined
            assertParamExists('getAllProductWebMessengerKnowledges', 'filtered', filtered);
            const localVarPath = `/backend/api/v1/products/web-messenger/knowledge/get-all/{companyProductId}/{filtered}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)))
                .replace(`{${"filtered"}}`, encodeURIComponent(String(filtered)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} knowledgeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWebMessengerKnowledge: (knowledgeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'knowledgeId' is not null or undefined
            assertParamExists('getProductWebMessengerKnowledge', 'knowledgeId', knowledgeId);
            const localVarPath = `/backend/api/v1/products/web-messenger/knowledge/get/{knowledgeId}`
                .replace(`{${"knowledgeId"}}`, encodeURIComponent(String(knowledgeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {Array<ProductWebMessengerKnowledge>} productWebMessengerKnowledge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllProductWebMessengerKnowledge: (productWebMessengerKnowledge, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productWebMessengerKnowledge' is not null or undefined
            assertParamExists('saveAllProductWebMessengerKnowledge', 'productWebMessengerKnowledge', productWebMessengerKnowledge);
            const localVarPath = `/backend/api/v1/products/web-messenger/knowledge/save-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(productWebMessengerKnowledge, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {ProductWebMessengerKnowledge} productWebMessengerKnowledge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductWebMessengerKnowledge: (productWebMessengerKnowledge, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productWebMessengerKnowledge' is not null or undefined
            assertParamExists('saveProductWebMessengerKnowledge', 'productWebMessengerKnowledge', productWebMessengerKnowledge);
            const localVarPath = `/backend/api/v1/products/web-messenger/knowledge/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(productWebMessengerKnowledge, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductWebMessengerKnowledgeApi - functional programming interface
 * @export
 */
export const ProductWebMessengerKnowledgeApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductWebMessengerKnowledgeApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} knowledgeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductWebMessengerKnowledge(knowledgeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteProductWebMessengerKnowledge(knowledgeId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get knowledge elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductWebMessengerKnowledges(companyProductId, filtered, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllProductWebMessengerKnowledges(companyProductId, filtered, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} knowledgeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWebMessengerKnowledge(knowledgeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductWebMessengerKnowledge(knowledgeId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {Array<ProductWebMessengerKnowledge>} productWebMessengerKnowledge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllProductWebMessengerKnowledge(productWebMessengerKnowledge, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveAllProductWebMessengerKnowledge(productWebMessengerKnowledge, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {ProductWebMessengerKnowledge} productWebMessengerKnowledge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductWebMessengerKnowledge(productWebMessengerKnowledge, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveProductWebMessengerKnowledge(productWebMessengerKnowledge, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProductWebMessengerKnowledgeApi - factory interface
 * @export
 */
export const ProductWebMessengerKnowledgeApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductWebMessengerKnowledgeApiFp(configuration);
    return {
        /**
         *
         * @summary delete
         * @param {number} knowledgeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductWebMessengerKnowledge(knowledgeId, options) {
            return localVarFp.deleteProductWebMessengerKnowledge(knowledgeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get knowledge elements
         * @param {number} companyProductId
         * @param {number} filtered
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductWebMessengerKnowledges(companyProductId, filtered, limit, options) {
            return localVarFp.getAllProductWebMessengerKnowledges(companyProductId, filtered, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} knowledgeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWebMessengerKnowledge(knowledgeId, options) {
            return localVarFp.getProductWebMessengerKnowledge(knowledgeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {Array<ProductWebMessengerKnowledge>} productWebMessengerKnowledge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAllProductWebMessengerKnowledge(productWebMessengerKnowledge, options) {
            return localVarFp.saveAllProductWebMessengerKnowledge(productWebMessengerKnowledge, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {ProductWebMessengerKnowledge} productWebMessengerKnowledge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductWebMessengerKnowledge(productWebMessengerKnowledge, options) {
            return localVarFp.saveProductWebMessengerKnowledge(productWebMessengerKnowledge, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductWebMessengerKnowledgeApi - object-oriented interface
 * @export
 * @class ProductWebMessengerKnowledgeApi
 * @extends {BaseAPI}
 */
export class ProductWebMessengerKnowledgeApi extends BaseAPI {
    /**
     *
     * @summary delete
     * @param {number} knowledgeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebMessengerKnowledgeApi
     */
    deleteProductWebMessengerKnowledge(knowledgeId, options) {
        return ProductWebMessengerKnowledgeApiFp(this.configuration).deleteProductWebMessengerKnowledge(knowledgeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get knowledge elements
     * @param {number} companyProductId
     * @param {number} filtered
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebMessengerKnowledgeApi
     */
    getAllProductWebMessengerKnowledges(companyProductId, filtered, limit, options) {
        return ProductWebMessengerKnowledgeApiFp(this.configuration).getAllProductWebMessengerKnowledges(companyProductId, filtered, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} knowledgeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebMessengerKnowledgeApi
     */
    getProductWebMessengerKnowledge(knowledgeId, options) {
        return ProductWebMessengerKnowledgeApiFp(this.configuration).getProductWebMessengerKnowledge(knowledgeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {Array<ProductWebMessengerKnowledge>} productWebMessengerKnowledge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebMessengerKnowledgeApi
     */
    saveAllProductWebMessengerKnowledge(productWebMessengerKnowledge, options) {
        return ProductWebMessengerKnowledgeApiFp(this.configuration).saveAllProductWebMessengerKnowledge(productWebMessengerKnowledge, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {ProductWebMessengerKnowledge} productWebMessengerKnowledge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebMessengerKnowledgeApi
     */
    saveProductWebMessengerKnowledge(productWebMessengerKnowledge, options) {
        return ProductWebMessengerKnowledgeApiFp(this.configuration).saveProductWebMessengerKnowledge(productWebMessengerKnowledge, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductWebProjectApi - axios parameter creator
 * @export
 */
export const ProductWebProjectApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary get
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWebProject: (companyProductId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getProductWebProject', 'companyProductId', companyProductId);
            const localVarPath = `/backend/api/v1/products/web-project/get/{companyProductId}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {string} [uploadLogo] uploadLogo
         * @param {string} [uploadDashboardBgImage] uploadDashboardBgImage
         * @param {number} [companyProductId] company_product_id
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {string} [domain] domain
         * @param {string} [primaryColor] primary_color
         * @param {string} [secondaryColor] secondary_color
         * @param {string} [name] name
         * @param {string} [title] title
         * @param {string} [description] description
         * @param {string} [userAgreement] user_agreement
         * @param {string} [imprint] imprint
         * @param {string} [logo] logo
         * @param {boolean} [allowMessenger] allow_messenger
         * @param {string} [aboutUs] about_us
         * @param {string} [privacyPolicy] privacy_policy
         * @param {string} [dashboardBgImage] dashboard_bg_image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductWebProject: (uploadLogo, uploadDashboardBgImage, companyProductId, created, modified, deleted, domain, primaryColor, secondaryColor, name, title, description, userAgreement, imprint, logo, allowMessenger, aboutUs, privacyPolicy, dashboardBgImage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/products/web-project/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (uploadLogo !== undefined) {
                localVarFormParams.append('uploadLogo', uploadLogo);
            }
            if (uploadDashboardBgImage !== undefined) {
                localVarFormParams.append('uploadDashboardBgImage', uploadDashboardBgImage);
            }
            if (companyProductId !== undefined) {
                localVarFormParams.append('company_product_id', companyProductId);
            }
            if (created !== undefined) {
                localVarFormParams.append('created', created);
            }
            if (modified !== undefined) {
                localVarFormParams.append('modified', modified);
            }
            if (deleted !== undefined) {
                localVarFormParams.append('deleted', deleted);
            }
            if (domain !== undefined) {
                localVarFormParams.append('domain', domain);
            }
            if (primaryColor !== undefined) {
                localVarFormParams.append('primary_color', primaryColor);
            }
            if (secondaryColor !== undefined) {
                localVarFormParams.append('secondary_color', secondaryColor);
            }
            if (name !== undefined) {
                localVarFormParams.append('name', name);
            }
            if (title !== undefined) {
                localVarFormParams.append('title', title);
            }
            if (description !== undefined) {
                localVarFormParams.append('description', description);
            }
            if (userAgreement !== undefined) {
                localVarFormParams.append('user_agreement', userAgreement);
            }
            if (imprint !== undefined) {
                localVarFormParams.append('imprint', imprint);
            }
            if (logo !== undefined) {
                localVarFormParams.append('logo', logo);
            }
            if (allowMessenger !== undefined) {
                localVarFormParams.append('allow_messenger', allowMessenger);
            }
            if (aboutUs !== undefined) {
                localVarFormParams.append('about_us', aboutUs);
            }
            if (privacyPolicy !== undefined) {
                localVarFormParams.append('privacy_policy', privacyPolicy);
            }
            if (dashboardBgImage !== undefined) {
                localVarFormParams.append('dashboard_bg_image', dashboardBgImage);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductWebProjectApi - functional programming interface
 * @export
 */
export const ProductWebProjectApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductWebProjectApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary get
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWebProject(companyProductId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductWebProject(companyProductId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {string} [uploadLogo] uploadLogo
         * @param {string} [uploadDashboardBgImage] uploadDashboardBgImage
         * @param {number} [companyProductId] company_product_id
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {string} [domain] domain
         * @param {string} [primaryColor] primary_color
         * @param {string} [secondaryColor] secondary_color
         * @param {string} [name] name
         * @param {string} [title] title
         * @param {string} [description] description
         * @param {string} [userAgreement] user_agreement
         * @param {string} [imprint] imprint
         * @param {string} [logo] logo
         * @param {boolean} [allowMessenger] allow_messenger
         * @param {string} [aboutUs] about_us
         * @param {string} [privacyPolicy] privacy_policy
         * @param {string} [dashboardBgImage] dashboard_bg_image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductWebProject(uploadLogo, uploadDashboardBgImage, companyProductId, created, modified, deleted, domain, primaryColor, secondaryColor, name, title, description, userAgreement, imprint, logo, allowMessenger, aboutUs, privacyPolicy, dashboardBgImage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveProductWebProject(uploadLogo, uploadDashboardBgImage, companyProductId, created, modified, deleted, domain, primaryColor, secondaryColor, name, title, description, userAgreement, imprint, logo, allowMessenger, aboutUs, privacyPolicy, dashboardBgImage, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProductWebProjectApi - factory interface
 * @export
 */
export const ProductWebProjectApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductWebProjectApiFp(configuration);
    return {
        /**
         *
         * @summary get
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWebProject(companyProductId, options) {
            return localVarFp.getProductWebProject(companyProductId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {string} [uploadLogo] uploadLogo
         * @param {string} [uploadDashboardBgImage] uploadDashboardBgImage
         * @param {number} [companyProductId] company_product_id
         * @param {number} [created] created
         * @param {number} [modified] modified
         * @param {number} [deleted] deleted
         * @param {string} [domain] domain
         * @param {string} [primaryColor] primary_color
         * @param {string} [secondaryColor] secondary_color
         * @param {string} [name] name
         * @param {string} [title] title
         * @param {string} [description] description
         * @param {string} [userAgreement] user_agreement
         * @param {string} [imprint] imprint
         * @param {string} [logo] logo
         * @param {boolean} [allowMessenger] allow_messenger
         * @param {string} [aboutUs] about_us
         * @param {string} [privacyPolicy] privacy_policy
         * @param {string} [dashboardBgImage] dashboard_bg_image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProductWebProject(uploadLogo, uploadDashboardBgImage, companyProductId, created, modified, deleted, domain, primaryColor, secondaryColor, name, title, description, userAgreement, imprint, logo, allowMessenger, aboutUs, privacyPolicy, dashboardBgImage, options) {
            return localVarFp.saveProductWebProject(uploadLogo, uploadDashboardBgImage, companyProductId, created, modified, deleted, domain, primaryColor, secondaryColor, name, title, description, userAgreement, imprint, logo, allowMessenger, aboutUs, privacyPolicy, dashboardBgImage, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductWebProjectApi - object-oriented interface
 * @export
 * @class ProductWebProjectApi
 * @extends {BaseAPI}
 */
export class ProductWebProjectApi extends BaseAPI {
    /**
     *
     * @summary get
     * @param {number} companyProductId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebProjectApi
     */
    getProductWebProject(companyProductId, options) {
        return ProductWebProjectApiFp(this.configuration).getProductWebProject(companyProductId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {string} [uploadLogo] uploadLogo
     * @param {string} [uploadDashboardBgImage] uploadDashboardBgImage
     * @param {number} [companyProductId] company_product_id
     * @param {number} [created] created
     * @param {number} [modified] modified
     * @param {number} [deleted] deleted
     * @param {string} [domain] domain
     * @param {string} [primaryColor] primary_color
     * @param {string} [secondaryColor] secondary_color
     * @param {string} [name] name
     * @param {string} [title] title
     * @param {string} [description] description
     * @param {string} [userAgreement] user_agreement
     * @param {string} [imprint] imprint
     * @param {string} [logo] logo
     * @param {boolean} [allowMessenger] allow_messenger
     * @param {string} [aboutUs] about_us
     * @param {string} [privacyPolicy] privacy_policy
     * @param {string} [dashboardBgImage] dashboard_bg_image
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWebProjectApi
     */
    saveProductWebProject(uploadLogo, uploadDashboardBgImage, companyProductId, created, modified, deleted, domain, primaryColor, secondaryColor, name, title, description, userAgreement, imprint, logo, allowMessenger, aboutUs, privacyPolicy, dashboardBgImage, options) {
        return ProductWebProjectApiFp(this.configuration).saveProductWebProject(uploadLogo, uploadDashboardBgImage, companyProductId, created, modified, deleted, domain, primaryColor, secondaryColor, name, title, description, userAgreement, imprint, logo, allowMessenger, aboutUs, privacyPolicy, dashboardBgImage, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductsApi - axios parameter creator
 * @export
 */
export const ProductsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary get all products
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProducts: (page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/products/get-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct: (productId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProduct', 'productId', productId);
            const localVarPath = `/backend/api/v1/products/get/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {Product} product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProduct: (product, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'product' is not null or undefined
            assertParamExists('saveProduct', 'product', product);
            const localVarPath = `/backend/api/v1/products/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(product, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary get all products
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProducts(page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllProducts(page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct(productId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProduct(productId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {Product} product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProduct(product, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveProduct(product, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductsApiFp(configuration);
    return {
        /**
         *
         * @summary get all products
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProducts(page, limit, options) {
            return localVarFp.getAllProducts(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct(productId, options) {
            return localVarFp.getProduct(productId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {Product} product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProduct(product, options) {
            return localVarFp.saveProduct(product, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
    /**
     *
     * @summary get all products
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getAllProducts(page, limit, options) {
        return ProductsApiFp(this.configuration).getAllProducts(page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} productId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getProduct(productId, options) {
        return ProductsApiFp(this.configuration).getProduct(productId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {Product} product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    saveProduct(product, options) {
        return ProductsApiFp(this.configuration).saveProduct(product, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TermsOfServiceApi - axios parameter creator
 * @export
 */
export const TermsOfServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary get terms of service
         * @param {number} companyProductId
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTermsOfService: (companyProductId, page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getAllTermsOfService', 'companyProductId', companyProductId);
            const localVarPath = `/backend/api/v1/products/terms-of-service/get-all/{companyProductId}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get latest terms of service
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestTermsOfService: (companyProductId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyProductId' is not null or undefined
            assertParamExists('getLatestTermsOfService', 'companyProductId', companyProductId);
            const localVarPath = `/backend/api/v1/products/terms-of-service/get-latest/{companyProductId}`
                .replace(`{${"companyProductId"}}`, encodeURIComponent(String(companyProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} termsOfServiceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTermsOfService: (termsOfServiceId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'termsOfServiceId' is not null or undefined
            assertParamExists('getTermsOfService', 'termsOfServiceId', termsOfServiceId);
            const localVarPath = `/backend/api/v1/products/terms-of-service/get/{termsOfServiceId}`
                .replace(`{${"termsOfServiceId"}}`, encodeURIComponent(String(termsOfServiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {TermsOfService} termsOfService
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTermsOfService: (termsOfService, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'termsOfService' is not null or undefined
            assertParamExists('saveTermsOfService', 'termsOfService', termsOfService);
            const localVarPath = `/backend/api/v1/products/terms-of-service/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(termsOfService, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TermsOfServiceApi - functional programming interface
 * @export
 */
export const TermsOfServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = TermsOfServiceApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary get terms of service
         * @param {number} companyProductId
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTermsOfService(companyProductId, page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllTermsOfService(companyProductId, page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get latest terms of service
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestTermsOfService(companyProductId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLatestTermsOfService(companyProductId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} termsOfServiceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTermsOfService(termsOfServiceId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTermsOfService(termsOfServiceId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {TermsOfService} termsOfService
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTermsOfService(termsOfService, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveTermsOfService(termsOfService, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * TermsOfServiceApi - factory interface
 * @export
 */
export const TermsOfServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TermsOfServiceApiFp(configuration);
    return {
        /**
         *
         * @summary get terms of service
         * @param {number} companyProductId
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTermsOfService(companyProductId, page, limit, options) {
            return localVarFp.getAllTermsOfService(companyProductId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get latest terms of service
         * @param {number} companyProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestTermsOfService(companyProductId, options) {
            return localVarFp.getLatestTermsOfService(companyProductId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} termsOfServiceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTermsOfService(termsOfServiceId, options) {
            return localVarFp.getTermsOfService(termsOfServiceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {TermsOfService} termsOfService
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTermsOfService(termsOfService, options) {
            return localVarFp.saveTermsOfService(termsOfService, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TermsOfServiceApi - object-oriented interface
 * @export
 * @class TermsOfServiceApi
 * @extends {BaseAPI}
 */
export class TermsOfServiceApi extends BaseAPI {
    /**
     *
     * @summary get terms of service
     * @param {number} companyProductId
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermsOfServiceApi
     */
    getAllTermsOfService(companyProductId, page, limit, options) {
        return TermsOfServiceApiFp(this.configuration).getAllTermsOfService(companyProductId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get latest terms of service
     * @param {number} companyProductId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermsOfServiceApi
     */
    getLatestTermsOfService(companyProductId, options) {
        return TermsOfServiceApiFp(this.configuration).getLatestTermsOfService(companyProductId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} termsOfServiceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermsOfServiceApi
     */
    getTermsOfService(termsOfServiceId, options) {
        return TermsOfServiceApiFp(this.configuration).getTermsOfService(termsOfServiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {TermsOfService} termsOfService
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermsOfServiceApi
     */
    saveTermsOfService(termsOfService, options) {
        return TermsOfServiceApiFp(this.configuration).saveTermsOfService(termsOfService, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ThreadsApi - axios parameter creator
 * @export
 */
export const ThreadsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * addThread  seems to be broken
         * @summary addThread
         * @param {AddThreadRequest} addThreadRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addThread: (addThreadRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'addThreadRequest' is not null or undefined
            assertParamExists('addThread', 'addThreadRequest', addThreadRequest);
            const localVarPath = `/client/add-thread`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(addThreadRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary getThread
         * @param {GetThreadRequest} getThreadRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThread: (getThreadRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'getThreadRequest' is not null or undefined
            assertParamExists('getThread', 'getThreadRequest', getThreadRequest);
            const localVarPath = `/client/get-thread`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getThreadRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary globalSearchThreadsList
         * @param {ThreadsListRequest} threadsListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalSearchThreadsList: (threadsListRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'threadsListRequest' is not null or undefined
            assertParamExists('globalSearchThreadsList', 'threadsListRequest', threadsListRequest);
            const localVarPath = `/client/global-search-threads-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(threadsListRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary publicThreadsList
         * @param {PublicThreadsListRequest} publicThreadsListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicThreadsList: (publicThreadsListRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'publicThreadsListRequest' is not null or undefined
            assertParamExists('publicThreadsList', 'publicThreadsListRequest', publicThreadsListRequest);
            const localVarPath = `/client/public-threads-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(publicThreadsListRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary threadsList
         * @param {ThreadsListRequest} threadsListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadsList: (threadsListRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'threadsListRequest' is not null or undefined
            assertParamExists('threadsList', 'threadsListRequest', threadsListRequest);
            const localVarPath = `/client/threads-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(threadsListRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ThreadsApi - functional programming interface
 * @export
 */
export const ThreadsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ThreadsApiAxiosParamCreator(configuration);
    return {
        /**
         * addThread  seems to be broken
         * @summary addThread
         * @param {AddThreadRequest} addThreadRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addThread(addThreadRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addThread(addThreadRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary getThread
         * @param {GetThreadRequest} getThreadRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThread(getThreadRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getThread(getThreadRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary globalSearchThreadsList
         * @param {ThreadsListRequest} threadsListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalSearchThreadsList(threadsListRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.globalSearchThreadsList(threadsListRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary publicThreadsList
         * @param {PublicThreadsListRequest} publicThreadsListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicThreadsList(publicThreadsListRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.publicThreadsList(publicThreadsListRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary threadsList
         * @param {ThreadsListRequest} threadsListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadsList(threadsListRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.threadsList(threadsListRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ThreadsApi - factory interface
 * @export
 */
export const ThreadsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ThreadsApiFp(configuration);
    return {
        /**
         * addThread  seems to be broken
         * @summary addThread
         * @param {AddThreadRequest} addThreadRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addThread(addThreadRequest, options) {
            return localVarFp.addThread(addThreadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary getThread
         * @param {GetThreadRequest} getThreadRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThread(getThreadRequest, options) {
            return localVarFp.getThread(getThreadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary globalSearchThreadsList
         * @param {ThreadsListRequest} threadsListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalSearchThreadsList(threadsListRequest, options) {
            return localVarFp.globalSearchThreadsList(threadsListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary publicThreadsList
         * @param {PublicThreadsListRequest} publicThreadsListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicThreadsList(publicThreadsListRequest, options) {
            return localVarFp.publicThreadsList(publicThreadsListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary threadsList
         * @param {ThreadsListRequest} threadsListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadsList(threadsListRequest, options) {
            return localVarFp.threadsList(threadsListRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ThreadsApi - object-oriented interface
 * @export
 * @class ThreadsApi
 * @extends {BaseAPI}
 */
export class ThreadsApi extends BaseAPI {
    /**
     * addThread  seems to be broken
     * @summary addThread
     * @param {AddThreadRequest} addThreadRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThreadsApi
     */
    addThread(addThreadRequest, options) {
        return ThreadsApiFp(this.configuration).addThread(addThreadRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary getThread
     * @param {GetThreadRequest} getThreadRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThreadsApi
     */
    getThread(getThreadRequest, options) {
        return ThreadsApiFp(this.configuration).getThread(getThreadRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary globalSearchThreadsList
     * @param {ThreadsListRequest} threadsListRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThreadsApi
     */
    globalSearchThreadsList(threadsListRequest, options) {
        return ThreadsApiFp(this.configuration).globalSearchThreadsList(threadsListRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary publicThreadsList
     * @param {PublicThreadsListRequest} publicThreadsListRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThreadsApi
     */
    publicThreadsList(publicThreadsListRequest, options) {
        return ThreadsApiFp(this.configuration).publicThreadsList(publicThreadsListRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary threadsList
     * @param {ThreadsListRequest} threadsListRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThreadsApi
     */
    threadsList(threadsListRequest, options) {
        return ThreadsApiFp(this.configuration).threadsList(threadsListRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TopicsApi - axios parameter creator
 * @export
 */
export const TopicsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Fügt eine Topic hinzu, wenn diese noch nicht existiert. Es MUSS der Parameter name in den POST Daten vorhanden sein. Der Parameter color KANN in den POST Daten vorhanden sein. Es wird das Topic zurückgegeben, auch wenn das Topic schon existiert hat.
         * @summary addTopic
         * @param {AddTopicRequest} addTopicRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTopic: (addTopicRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'addTopicRequest' is not null or undefined
            assertParamExists('addTopic', 'addTopicRequest', addTopicRequest);
            const localVarPath = `/client/add-topic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(addTopicRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Ordnet Topics einer Person, oder Gruppe zu. Es können topicId, oder topicIds übergeben werden.
         * @summary assignTopic
         * @param {AssignTopicRequest} assignTopicRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignTopic: (assignTopicRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'assignTopicRequest' is not null or undefined
            assertParamExists('assignTopic', 'assignTopicRequest', assignTopicRequest);
            const localVarPath = `/client/topic-assign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(assignTopicRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * [overwrite description]
         * @summary overwriteTopic
         * @param {AssignTopicRequest} assignTopicRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overwriteTopic: (assignTopicRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'assignTopicRequest' is not null or undefined
            assertParamExists('overwriteTopic', 'assignTopicRequest', assignTopicRequest);
            const localVarPath = `/client/topic-overwrite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(assignTopicRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Überprüft, ob eine Topic schon existiert.
         * @summary topicExists
         * @param {TopicExistsRequest} topicExistsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topicExists: (topicExistsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'topicExistsRequest' is not null or undefined
            assertParamExists('topicExists', 'topicExistsRequest', topicExistsRequest);
            const localVarPath = `/client/topic-exists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(topicExistsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TopicsApi - functional programming interface
 * @export
 */
export const TopicsApiFp = function (configuration) {
    const localVarAxiosParamCreator = TopicsApiAxiosParamCreator(configuration);
    return {
        /**
         * Fügt eine Topic hinzu, wenn diese noch nicht existiert. Es MUSS der Parameter name in den POST Daten vorhanden sein. Der Parameter color KANN in den POST Daten vorhanden sein. Es wird das Topic zurückgegeben, auch wenn das Topic schon existiert hat.
         * @summary addTopic
         * @param {AddTopicRequest} addTopicRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTopic(addTopicRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addTopic(addTopicRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Ordnet Topics einer Person, oder Gruppe zu. Es können topicId, oder topicIds übergeben werden.
         * @summary assignTopic
         * @param {AssignTopicRequest} assignTopicRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignTopic(assignTopicRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.assignTopic(assignTopicRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * [overwrite description]
         * @summary overwriteTopic
         * @param {AssignTopicRequest} assignTopicRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overwriteTopic(assignTopicRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.overwriteTopic(assignTopicRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Überprüft, ob eine Topic schon existiert.
         * @summary topicExists
         * @param {TopicExistsRequest} topicExistsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topicExists(topicExistsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.topicExists(topicExistsRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * TopicsApi - factory interface
 * @export
 */
export const TopicsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TopicsApiFp(configuration);
    return {
        /**
         * Fügt eine Topic hinzu, wenn diese noch nicht existiert. Es MUSS der Parameter name in den POST Daten vorhanden sein. Der Parameter color KANN in den POST Daten vorhanden sein. Es wird das Topic zurückgegeben, auch wenn das Topic schon existiert hat.
         * @summary addTopic
         * @param {AddTopicRequest} addTopicRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTopic(addTopicRequest, options) {
            return localVarFp.addTopic(addTopicRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Ordnet Topics einer Person, oder Gruppe zu. Es können topicId, oder topicIds übergeben werden.
         * @summary assignTopic
         * @param {AssignTopicRequest} assignTopicRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignTopic(assignTopicRequest, options) {
            return localVarFp.assignTopic(assignTopicRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * [overwrite description]
         * @summary overwriteTopic
         * @param {AssignTopicRequest} assignTopicRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overwriteTopic(assignTopicRequest, options) {
            return localVarFp.overwriteTopic(assignTopicRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Überprüft, ob eine Topic schon existiert.
         * @summary topicExists
         * @param {TopicExistsRequest} topicExistsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topicExists(topicExistsRequest, options) {
            return localVarFp.topicExists(topicExistsRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TopicsApi - object-oriented interface
 * @export
 * @class TopicsApi
 * @extends {BaseAPI}
 */
export class TopicsApi extends BaseAPI {
    /**
     * Fügt eine Topic hinzu, wenn diese noch nicht existiert. Es MUSS der Parameter name in den POST Daten vorhanden sein. Der Parameter color KANN in den POST Daten vorhanden sein. Es wird das Topic zurückgegeben, auch wenn das Topic schon existiert hat.
     * @summary addTopic
     * @param {AddTopicRequest} addTopicRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    addTopic(addTopicRequest, options) {
        return TopicsApiFp(this.configuration).addTopic(addTopicRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Ordnet Topics einer Person, oder Gruppe zu. Es können topicId, oder topicIds übergeben werden.
     * @summary assignTopic
     * @param {AssignTopicRequest} assignTopicRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    assignTopic(assignTopicRequest, options) {
        return TopicsApiFp(this.configuration).assignTopic(assignTopicRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * [overwrite description]
     * @summary overwriteTopic
     * @param {AssignTopicRequest} assignTopicRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    overwriteTopic(assignTopicRequest, options) {
        return TopicsApiFp(this.configuration).overwriteTopic(assignTopicRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Überprüft, ob eine Topic schon existiert.
     * @summary topicExists
     * @param {TopicExistsRequest} topicExistsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    topicExists(topicExistsRequest, options) {
        return TopicsApiFp(this.configuration).topicExists(topicExistsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Login via username, password or token. Returns a new token when autologin is set and a new jwt on successful login.  Should be a post request.
         * @summary adviser backend login
         * @param {AdviserBackendLoginRequest} adviserBackendLoginRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adviserBackendLogin: (adviserBackendLoginRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'adviserBackendLoginRequest' is not null or undefined
            assertParamExists('adviserBackendLogin', 'adviserBackendLoginRequest', adviserBackendLoginRequest);
            const localVarPath = `/backend/api/v1/users/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adviserBackendLoginRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gibt einen Berater für eine Beratungsstelle mit de rgeringsten Auslastung, also mit der geringsten Streamanzahl zurück.
         * @summary adviserRoundRobin
         * @param {AdviserRoundRobinRequest} adviserRoundRobinRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adviserRoundRobin: (adviserRoundRobinRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'adviserRoundRobinRequest' is not null or undefined
            assertParamExists('adviserRoundRobin', 'adviserRoundRobinRequest', adviserRoundRobinRequest);
            const localVarPath = `/client/berater-round-robin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adviserRoundRobinRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Single Sign On Endpunkt für assisto Berater. Es wird ein Token übergeben, der in der DB überprüft wird.
         * @summary adviserSso
         * @param {AdviserSSORequest} adviserSSORequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adviserSso: (adviserSSORequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'adviserSSORequest' is not null or undefined
            assertParamExists('adviserSso', 'adviserSSORequest', adviserSSORequest);
            const localVarPath = `/client/adviser-sso`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adviserSSORequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Eine überarbeitete Login Methode. Erwartet einen Benutzernamen und einen Token/Passwort und versucht den User zu authentifizieren. Gibt im Erfolgsfall u.a. einen JWT zurück.  JSON return data: { \'jwt\': Der JWT zu dem User, \'status\': Der aktuelle Status des Users, \'deleted\': Ob der User als gelöscht markeirt ist. \'beratungLanguages\': Die verfügbaren Sprachen für diesen User. \'agb\': AGBs für die BEratungsstelle des Users. }
         * @summary apiMobileLogin
         * @param {ApiMobileLoginRequest} apiMobileLoginRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMobileLogin: (apiMobileLoginRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiMobileLoginRequest' is not null or undefined
            assertParamExists('apiMobileLogin', 'apiMobileLoginRequest', apiMobileLoginRequest);
            const localVarPath = `/api/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(apiMobileLoginRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gibt einen Berater zurück.  Erwartet in POST Daten \'userJwt\', \'beraterId\' und \'language\'.  JSON return data: { \'username\': Der Benutzername des Beraters, \'beraterId\': Die Berater ID aus assisto, \'beschreibung\': Die Übersetzte Beschreibung, \'sprachen\': Die angegebenen Sprachen des Beraters }
         * @summary beraterDetail
         * @param {BeraterDetailRequest} beraterDetailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        beraterDetail: (beraterDetailRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'beraterDetailRequest' is not null or undefined
            assertParamExists('beraterDetail', 'beraterDetailRequest', beraterDetailRequest);
            const localVarPath = `/client/berater-detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(beraterDetailRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * wird nur in alte Apps verwendet (mbeon - odyssey)
         * @summary beraterList
         * @param {BeraterListRequest} beraterListRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        beraterList: (beraterListRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'beraterListRequest' is not null or undefined
            assertParamExists('beraterList', 'beraterListRequest', beraterListRequest);
            const localVarPath = `/client/berater-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(beraterListRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * holt die Beraterliste sortiert nach Entfernung ab
         * @summary beraterListV2
         * @param {0 | 1} unfiltered
         * @param {BeraterListV2Request} beraterListV2Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        beraterListV2: (unfiltered, beraterListV2Request, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'unfiltered' is not null or undefined
            assertParamExists('beraterListV2', 'unfiltered', unfiltered);
            // verify required parameter 'beraterListV2Request' is not null or undefined
            assertParamExists('beraterListV2', 'beraterListV2Request', beraterListV2Request);
            const localVarPath = `/client/berater-list-v2/{unfiltered}`
                .replace(`{${"unfiltered"}}`, encodeURIComponent(String(unfiltered)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(beraterListV2Request, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gibt einen Berater Vorschlag zurück.  Erwartet in POST Daten \'userJwt\'und \'language\'.  JSON return data: [ { \'username\': Der Benutzername des Beraters, \'beraterId\': Die Berater ID aus assisto, \'available\': Ob der Berater verfügbar ist, \'beschreibung\': Die Übersetzte Beschreibung, \'sprachen\': Die angegebenen Sprachen des Beraters, \'img\': Bild des Beraters }, ... ]
         * @summary beraterSuggestion
         * @param {BeraterSuggestionRequest} beraterSuggestionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        beraterSuggestion: (beraterSuggestionRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'beraterSuggestionRequest' is not null or undefined
            assertParamExists('beraterSuggestion', 'beraterSuggestionRequest', beraterSuggestionRequest);
            const localVarPath = `/client/berater-suggestion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(beraterSuggestionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary changeNotificationSetting
         * @param {ChangeNotificationSettingRequest} changeNotificationSettingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeNotificationSetting: (changeNotificationSettingRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'changeNotificationSettingRequest' is not null or undefined
            assertParamExists('changeNotificationSetting', 'changeNotificationSettingRequest', changeNotificationSettingRequest);
            const localVarPath = `/client/change-notification-setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(changeNotificationSettingRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary changeVisibility
         * @param {ChangeVisibilityRequest} changeVisibilityRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeVisibility: (changeVisibilityRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'changeVisibilityRequest' is not null or undefined
            assertParamExists('changeVisibility', 'changeVisibilityRequest', changeVisibilityRequest);
            const localVarPath = `/client/change-visibility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(changeVisibilityRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * ATTENTION! THIS ENDPOINT RETURNS A QUOTED STRING INSTEAD OF VALID JSON.
         * @summary checkUserWithPMECAS
         * @param {CheckUserWithPMECASRequest} checkUserWithPMECASRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUserWithPMECAS: (checkUserWithPMECASRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'checkUserWithPMECASRequest' is not null or undefined
            assertParamExists('checkUserWithPMECAS', 'checkUserWithPMECASRequest', checkUserWithPMECASRequest);
            const localVarPath = `/client/pme-cas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(checkUserWithPMECASRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary codeResend
         * @param {CodeResendRequest} codeResendRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeResend: (codeResendRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'codeResendRequest' is not null or undefined
            assertParamExists('codeResend', 'codeResendRequest', codeResendRequest);
            const localVarPath = `/client/code-resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(codeResendRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary complaint
         * @param {ComplaintRequest} complaintRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complaint: (complaintRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'complaintRequest' is not null or undefined
            assertParamExists('complaint', 'complaintRequest', complaintRequest);
            const localVarPath = `/client/complaint`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(complaintRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary confirmAgb
         * @param {ConfirmAgbRequest} confirmAgbRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmAgb: (confirmAgbRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'confirmAgbRequest' is not null or undefined
            assertParamExists('confirmAgb', 'confirmAgbRequest', confirmAgbRequest);
            const localVarPath = `/client/confirm-agb`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(confirmAgbRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary confirmODBFlush
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmODBFlush: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/client/confirm-odb-flush`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * checks if there is already a user with this email or telefon in a certain company
         * @summary contactExists
         * @param {ContactExistsRequest} contactExistsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactExists: (contactExistsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'contactExistsRequest' is not null or undefined
            assertParamExists('contactExists', 'contactExistsRequest', contactExistsRequest);
            const localVarPath = `/client/contact-exists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(contactExistsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * CURRENTLY LEAKS THE ENTIRE BERANET USER, _matchingData and _joinData. NOT FULLY DOCUMENTED
         * @summary createStream
         * @param {CreateStreamRequest} createStreamRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStream: (createStreamRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createStreamRequest' is not null or undefined
            assertParamExists('createStream', 'createStreamRequest', createStreamRequest);
            const localVarPath = `/client/create-stream`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createStreamRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary delete
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUser', 'userId', userId);
            const localVarPath = `/backend/api/v1/users/delete/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * entfernt Nutzer Profilbild
         * @summary deleteUserImage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserImage: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/client/delete-user-image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * user deletion api method
         * @summary deleteUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecatedDeleteUser: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/users/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * scnd question async validator ... checks if existing user and contactValue and Username matches
         * @summary existingUser
         * @param {ExistingUserRequest} existingUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existingUser: (existingUserRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'existingUserRequest' is not null or undefined
            assertParamExists('existingUser', 'existingUserRequest', existingUserRequest);
            const localVarPath = `/client/existing-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(existingUserRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Die \"Schnell Registrierung\" ohne Email Bestätigung usw. Der Registrierte Benutzer ist sofort im System aktiviert. Der User kann sich nicht erneut als dieselbe Person, wie bei dem anderen Login, registriert werden.  Es wird zuerst ein BeranetUser Datensatz angelegt und im Anschluss ein assisto User, der mit dem BeraentUser verknüpft ist.  Wird bei (Fostercare?) oder irgendwo anders verwendet :/
         * @summary fast-register
         * @param {FastRegisterRequest} fastRegisterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fastRegister: (fastRegisterRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fastRegisterRequest' is not null or undefined
            assertParamExists('fastRegister', 'fastRegisterRequest', fastRegisterRequest);
            const localVarPath = `/client/fast-register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(fastRegisterRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gibt eine gefilterte Topics Liste zurück. Erwartet q mit einem String als Filter als POST Parameter.
         * @summary filteredTopicsList
         * @param {FilteredTopicsListRequest} filteredTopicsListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredTopicsList: (filteredTopicsListRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'filteredTopicsListRequest' is not null or undefined
            assertParamExists('filteredTopicsList', 'filteredTopicsListRequest', filteredTopicsListRequest);
            const localVarPath = `/client/filtered-topics-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(filteredTopicsListRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gibt eine Beraterliste zurück mit der ID als Key und dem Benutzernamen als Wert.
         * @summary flatAdvisersList
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flatAdvisersList: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/flat-advisers-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get adviser
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdviser: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAdviser', 'userId', userId);
            const localVarPath = `/backend/api/v1/users/get-adviser/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get own adviser profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdviserProfile: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/users/adviser-profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary getAgb
         * @param {GetAgbRequest} getAgbRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgb: (getAgbRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'getAgbRequest' is not null or undefined
            assertParamExists('getAgb', 'getAgbRequest', getAgbRequest);
            const localVarPath = `/client/get-agb`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getAgbRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get all users from all companies
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {string} [search] search for items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsers: (page, limit, search, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/users/get-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Return all users inside own company
         * @summary get all users inside own company
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {string} [search] search for items
         * @param {string} [role]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersInCompany: (page, limit, search, role, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/users/company/get-all/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns the company modules, module config and the current user.  Should be a get request.
         * @summary getConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfig: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/users/get-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * FULLY LEAKS THE BERANET CONFIG ENTRY
         * @summary getFirmaId
         * @param {GetFirmaIdRequest} getFirmaIdRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirmaId: (getFirmaIdRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'getFirmaIdRequest' is not null or undefined
            assertParamExists('getFirmaId', 'getFirmaIdRequest', getFirmaIdRequest);
            const localVarPath = `/client/get-firma-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getFirmaIdRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * ATTENTION! THIS ENDPOINT RETURNS A STRING INSTEAD OF VALID JSON
         * @summary getGuest
         * @param {GetGuestRequest} getGuestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuest: (getGuestRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'getGuestRequest' is not null or undefined
            assertParamExists('getGuest', 'getGuestRequest', getGuestRequest);
            const localVarPath = `/client/get-guest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getGuestRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns all users as a list
         * @summary get a list of users
         * @param {string} [role]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListofUsers: (role, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/users/get-user-list/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * [getMask description]
         * @summary getMask
         * @param {GetMaskRequest} getMaskRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMask: (getMaskRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'getMaskRequest' is not null or undefined
            assertParamExists('getMask', 'getMaskRequest', getMaskRequest);
            const localVarPath = `/client/get-mask`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getMaskRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get my data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary gets profile img for user
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileImg: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getProfileImg', 'userId', userId);
            const localVarPath = `/backend/api/v1/users/get-profile-img/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * get status of advisers by rocket chat id array
         * @summary get status of advisers by rocket chat id array
         * @param {GetStatusOfAdvisersByRCIdsRequest} getStatusOfAdvisersByRCIdsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusOfAdvisersByRCIds: (getStatusOfAdvisersByRCIdsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'getStatusOfAdvisersByRCIdsRequest' is not null or undefined
            assertParamExists('getStatusOfAdvisersByRCIds', 'getStatusOfAdvisersByRCIdsRequest', getStatusOfAdvisersByRCIdsRequest);
            const localVarPath = `/backend/api/v1/users/get-status-of-advisers-by-rc-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getStatusOfAdvisersByRCIdsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * getStream  Returns an existing stream or creates a new one if none exists.
         * @summary getStream
         * @param {GetStreamRequest} getStreamRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStream: (getStreamRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'getStreamRequest' is not null or undefined
            assertParamExists('getStream', 'getStreamRequest', getStreamRequest);
            const localVarPath = `/client/get-stream`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getStreamRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * getStreams  Returns all streams.
         * @summary getStreams
         * @param {GetStreamsRequest} getStreamsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStreams: (getStreamsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'getStreamsRequest' is not null or undefined
            assertParamExists('getStreams', 'getStreamsRequest', getStreamsRequest);
            const localVarPath = `/client/get-streams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getStreamsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUser', 'userId', userId);
            const localVarPath = `/backend/api/v1/users/get/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get by rocket chat id
         * @param {string} rcId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByRCId: (rcId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'rcId' is not null or undefined
            assertParamExists('getUserByRCId', 'rcId', rcId);
            const localVarPath = `/backend/api/v1/users/get-by-rc-id/{rcId}`
                .replace(`{${"rcId"}}`, encodeURIComponent(String(rcId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary getUserImg
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserImg: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserImg', 'userId', userId);
            const localVarPath = `/client/get-user-image/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * getter for webmessenger configuration
         * @summary getWebmessengerConfig
         * @param {number} [firmaId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebmessengerConfig: (firmaId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/client/get-webmessenger-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (firmaId !== undefined) {
                localVarQueryParameter['firmaId'] = firmaId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * check user activation for product groups app
         * @summary adviser backend login
         * @param {GroupsAppCheckUserActivationRequest} groupsAppCheckUserActivationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsAppCheckUserActivation: (groupsAppCheckUserActivationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupsAppCheckUserActivationRequest' is not null or undefined
            assertParamExists('groupsAppCheckUserActivation', 'groupsAppCheckUserActivationRequest', groupsAppCheckUserActivationRequest);
            const localVarPath = `/backend/api/v1/products/groups/users/check-activation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(groupsAppCheckUserActivationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * login for product groups app
         * @summary groups app login
         * @param {GroupsAppLoginRequest} groupsAppLoginRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsAppLogin: (groupsAppLoginRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupsAppLoginRequest' is not null or undefined
            assertParamExists('groupsAppLogin', 'groupsAppLoginRequest', groupsAppLoginRequest);
            const localVarPath = `/backend/api/v1/products/groups/users/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(groupsAppLoginRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * check user activation for product groups app
         * @summary nickname exists
         * @param {GroupsAppNicknameExistsRequest} groupsAppNicknameExistsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsAppNicknameExists: (groupsAppNicknameExistsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupsAppNicknameExistsRequest' is not null or undefined
            assertParamExists('groupsAppNicknameExists', 'groupsAppNicknameExistsRequest', groupsAppNicknameExistsRequest);
            const localVarPath = `/backend/api/v1/products/groups/users/nickname-exists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(groupsAppNicknameExistsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Registration for product groups app
         * @summary adviser backend login
         * @param {GroupsAppRegisterRequest} groupsAppRegisterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsAppRegister: (groupsAppRegisterRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupsAppRegisterRequest' is not null or undefined
            assertParamExists('groupsAppRegister', 'groupsAppRegisterRequest', groupsAppRegisterRequest);
            const localVarPath = `/backend/api/v1/products/groups/users/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(groupsAppRegisterRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary activates user
         * @param {string} activationToken activation token to activate user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsAppUsersActivate: (activationToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'activationToken' is not null or undefined
            assertParamExists('groupsAppUsersActivate', 'activationToken', activationToken);
            const localVarPath = `/backend/api/v1/products/groups/users/activate/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (activationToken !== undefined) {
                localVarQueryParameter['activationToken'] = activationToken;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * forgot password action
         * @summary forgot password
         * @param {GroupsForgotPasswordRequest} groupsForgotPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsForgotPassword: (groupsForgotPasswordRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupsForgotPasswordRequest' is not null or undefined
            assertParamExists('groupsForgotPassword', 'groupsForgotPasswordRequest', groupsForgotPasswordRequest);
            const localVarPath = `/backend/api/v1/products/groups/users/forgot-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(groupsForgotPasswordRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * set password action
         * @summary set password
         * @param {GroupsSetNewPasswordRequest} groupsSetNewPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsSetNewPassword: (groupsSetNewPasswordRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupsSetNewPasswordRequest' is not null or undefined
            assertParamExists('groupsSetNewPassword', 'groupsSetNewPasswordRequest', groupsSetNewPasswordRequest);
            const localVarPath = `/backend/api/v1/products/groups/users/set-new-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(groupsSetNewPasswordRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary set password
         * @param {GroupsSetPasswordRequest} groupsSetPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsSetPassword: (groupsSetPasswordRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupsSetPasswordRequest' is not null or undefined
            assertParamExists('groupsSetPassword', 'groupsSetPasswordRequest', groupsSetPasswordRequest);
            const localVarPath = `/backend/api/v1/products/groups/users/set-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(groupsSetPasswordRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Main adviser restfull ep.
         * @summary mainAdviser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainAdviser: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/client/main-adviser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary endpoint for matching advisers
         * @param {MatchingAdvisersRequest} matchingAdvisersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchingAdvisers: (matchingAdvisersRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'matchingAdvisersRequest' is not null or undefined
            assertParamExists('matchingAdvisers', 'matchingAdvisersRequest', matchingAdvisersRequest);
            const localVarPath = `/backend/api/v1/users/matching-advisers/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(matchingAdvisersRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * check user activation for product messenger app
         * @summary check user activation
         * @param {GroupsAppCheckUserActivationRequest} groupsAppCheckUserActivationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messengerAppCheckUserActivation: (groupsAppCheckUserActivationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupsAppCheckUserActivationRequest' is not null or undefined
            assertParamExists('messengerAppCheckUserActivation', 'groupsAppCheckUserActivationRequest', groupsAppCheckUserActivationRequest);
            const localVarPath = `/backend/api/v1/products/messenger-app/users/check-activation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(groupsAppCheckUserActivationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * check if user is verified
         * @summary verification check on user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messengerAppCheckUserVerification: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/products/messenger-app/users/check-verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * login for product messenger app
         * @summary messenger app login
         * @param {MessengerAppLoginRequest} messengerAppLoginRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messengerAppLogin: (messengerAppLoginRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'messengerAppLoginRequest' is not null or undefined
            assertParamExists('messengerAppLogin', 'messengerAppLoginRequest', messengerAppLoginRequest);
            const localVarPath = `/backend/api/v1/products/messenger-app/users/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(messengerAppLoginRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * check user activation for product messenger app
         * @summary nickname exists
         * @param {GroupsAppNicknameExistsRequest} groupsAppNicknameExistsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messengerAppNicknameExists: (groupsAppNicknameExistsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupsAppNicknameExistsRequest' is not null or undefined
            assertParamExists('messengerAppNicknameExists', 'groupsAppNicknameExistsRequest', groupsAppNicknameExistsRequest);
            const localVarPath = `/backend/api/v1/products/messenger-app/users/nickname-exists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(groupsAppNicknameExistsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Registration for product messenger app
         * @summary register user
         * @param {GroupsAppRegisterRequest} groupsAppRegisterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messengerAppRegister: (groupsAppRegisterRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupsAppRegisterRequest' is not null or undefined
            assertParamExists('messengerAppRegister', 'groupsAppRegisterRequest', groupsAppRegisterRequest);
            const localVarPath = `/backend/api/v1/products/messenger-app/users/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(groupsAppRegisterRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Resend registration for product messenger app
         * @summary resend registration mail
         * @param {MessengerAppRegisterResendMailRequest} messengerAppRegisterResendMailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messengerAppRegisterResendMail: (messengerAppRegisterResendMailRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'messengerAppRegisterResendMailRequest' is not null or undefined
            assertParamExists('messengerAppRegisterResendMail', 'messengerAppRegisterResendMailRequest', messengerAppRegisterResendMailRequest);
            const localVarPath = `/backend/api/v1/products/messenger-app/users/resend-registration-mail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(messengerAppRegisterResendMailRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * start verification process of anonymous user
         * @summary start verification of anonymous user
         * @param {GroupsForgotPasswordRequest} groupsForgotPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messengerAppStartVerification: (groupsForgotPasswordRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupsForgotPasswordRequest' is not null or undefined
            assertParamExists('messengerAppStartVerification', 'groupsForgotPasswordRequest', groupsForgotPasswordRequest);
            const localVarPath = `/backend/api/v1/products/messenger-app/users/start-verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(groupsForgotPasswordRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary activates user
         * @param {string} activationToken activation token to activate user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messengerAppUsersActivate: (activationToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'activationToken' is not null or undefined
            assertParamExists('messengerAppUsersActivate', 'activationToken', activationToken);
            const localVarPath = `/backend/api/v1/products/messenger-app/users/activate/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (activationToken !== undefined) {
                localVarQueryParameter['activationToken'] = activationToken;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Login Methode.
         * @summary mobileLogin
         * @param {MobileLoginRequest} mobileLoginRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        mobileLogin: (mobileLoginRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'mobileLoginRequest' is not null or undefined
            assertParamExists('mobileLogin', 'mobileLoginRequest', mobileLoginRequest);
            const localVarPath = `/client/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(mobileLoginRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary mobileLoginV2
         * @param {MobileLoginV2Request} mobileLoginV2Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileLoginV2: (mobileLoginV2Request, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'mobileLoginV2Request' is not null or undefined
            assertParamExists('mobileLoginV2', 'mobileLoginV2Request', mobileLoginV2Request);
            const localVarPath = `/client/login2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(mobileLoginV2Request, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Die Daten, die nach dem Login geschickt werden.
         * @summary postLogin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLogin: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/client/post-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * TODO
         * @summary preLogin
         * @param {CheckVersionRequest} checkVersionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preLogin: (checkVersionRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'checkVersionRequest' is not null or undefined
            assertParamExists('preLogin', 'checkVersionRequest', checkVersionRequest);
            const localVarPath = `/client/pre-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(checkVersionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary publicUsersList
         * @param {PublicUsersListRequest} publicUsersListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicUsersList: (publicUsersListRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'publicUsersListRequest' is not null or undefined
            assertParamExists('publicUsersList', 'publicUsersListRequest', publicUsersListRequest);
            const localVarPath = `/client/public-users-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(publicUsersListRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary register user
         * @param {RegisterRequest} registerRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: (registerRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'registerRequest' is not null or undefined
            assertParamExists('register', 'registerRequest', registerRequest);
            const localVarPath = `/backend/api/v1/products/web-basic/users/register/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(registerRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary registerMobileConfirm
         * @param {RegisterConfirmRequest} registerConfirmRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerConfirm: (registerConfirmRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'registerConfirmRequest' is not null or undefined
            assertParamExists('registerConfirm', 'registerConfirmRequest', registerConfirmRequest);
            const localVarPath = `/client/register-confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(registerConfirmRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * register methode for landingpage
         * @summary registerLandingpage
         * @param {RegisterLandingpageRequest} registerLandingpageRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerLandingpage: (registerLandingpageRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'registerLandingpageRequest' is not null or undefined
            assertParamExists('registerLandingpage', 'registerLandingpageRequest', registerLandingpageRequest);
            const localVarPath = `/client/landingpage-register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(registerLandingpageRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary registerMobile
         * @param {RegisterMobileRequest} registerMobileRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerMobile: (registerMobileRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'registerMobileRequest' is not null or undefined
            assertParamExists('registerMobile', 'registerMobileRequest', registerMobileRequest);
            const localVarPath = `/client/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(registerMobileRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Überarbeitete Register Methode. Eigentlich nur refaktoriesert und verschlankt.
         * @summary registerMobileV2
         * @param {RegisterMobileV2Request} registerMobileV2Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerMobileV2: (registerMobileV2Request, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'registerMobileV2Request' is not null or undefined
            assertParamExists('registerMobileV2', 'registerMobileV2Request', registerMobileV2Request);
            const localVarPath = `/client/register-v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(registerMobileV2Request, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * register for web either webmodule or something else, basically a guest login for api
         * @summary registerWeb
         * @param {RegisterWebRequest} registerWebRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerWeb: (registerWebRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'registerWebRequest' is not null or undefined
            assertParamExists('registerWeb', 'registerWebRequest', registerWebRequest);
            const localVarPath = `/client/register-web`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(registerWebRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save adviser profile image
         * @param {File} [files] profile image file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAdvisersProfileImage: (files, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/users/save-adviser-img`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (files !== undefined) {
                localVarFormParams.append('files[]', files);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary save
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUser: (user, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'user' is not null or undefined
            assertParamExists('saveUser', 'user', user);
            const localVarPath = `/backend/api/v1/users/save/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(user, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary selfDelete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfDelete: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/client/self-delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * sends message to registration source
         * @summary sendMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessage: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/client/send-message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Überprüft, ob zusätzliche Informationen zu dem Nutzer, der anhand des übermittelten JWTs erkannt wird, vorhanden sind und gespeichert werden müssen und speichert diese ggf.
         * @summary setAdditionalInfo
         * @param {SetAdditionalInfoRequest} setAdditionalInfoRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAdditionalInfo: (setAdditionalInfoRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'setAdditionalInfoRequest' is not null or undefined
            assertParamExists('setAdditionalInfo', 'setAdditionalInfoRequest', setAdditionalInfoRequest);
            const localVarPath = `/client/set-additional-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(setAdditionalInfoRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get or set own adviser profile
         * @summary set own adviser profile
         * @param {AdviserInfo} adviserInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAdviserProfile: (adviserInfo, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'adviserInfo' is not null or undefined
            assertParamExists('setAdviserProfile', 'adviserInfo', adviserInfo);
            const localVarPath = `/backend/api/v1/users/adviser-profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adviserInfo, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * endpoint for setting own main adviser
         * @summary endpoint for setting own main adviser
         * @param {SetMainAdviserRequest} setMainAdviserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMainAdviser: (setMainAdviserRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'setMainAdviserRequest' is not null or undefined
            assertParamExists('setMainAdviser', 'setMainAdviserRequest', setMainAdviserRequest);
            const localVarPath = `/backend/api/v1/users/set-main-adviser/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(setMainAdviserRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Sets the adviser with the specified ID as main adviser for the specified user. Use `0` as adviser ID to un-set the main adviser for the user.
         * @summary Set main adviser for specific user
         * @param {SetMainAdviserForUserRequest} setMainAdviserForUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMainAdviserForUser: (setMainAdviserForUserRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'setMainAdviserForUserRequest' is not null or undefined
            assertParamExists('setMainAdviserForUser', 'setMainAdviserForUserRequest', setMainAdviserForUserRequest);
            const localVarPath = `/backend/api/v1/users/set-main-adviser-for-user/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(setMainAdviserForUserRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary setUserImage
         * @param {File} file file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserImage: (file, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('setUserImage', 'file', file);
            const localVarPath = `/client/set-user-image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * start a chat with given adviser
         * @summary start a chat with given adviser
         * @param {StartChatWithAdviserRequest} startChatWithAdviserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startChatWithAdviser: (startChatWithAdviserRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'startChatWithAdviserRequest' is not null or undefined
            assertParamExists('startChatWithAdviser', 'startChatWithAdviserRequest', startChatWithAdviserRequest);
            const localVarPath = `/backend/api/v1/users/start-chat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(startChatWithAdviserRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary updatePushId
         * @param {UpdatePushIdRequest} updatePushIdRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePushId: (updatePushIdRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'updatePushIdRequest' is not null or undefined
            assertParamExists('updatePushId', 'updatePushIdRequest', updatePushIdRequest);
            const localVarPath = `/client/update-push-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updatePushIdRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This endpoint doesnt handle an invalid user id at all. Returns an empty array if the user was not found
         * @summary userDetail
         * @param {UserDetailRequest} userDetailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDetail: (userDetailRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userDetailRequest' is not null or undefined
            assertParamExists('userDetail', 'userDetailRequest', userDetailRequest);
            const localVarPath = `/client/user-detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userDetailRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * checks if there is already a user with telefon or email
         * @summary userExists
         * @param {UserExistsRequest} userExistsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userExists: (userExistsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userExistsRequest' is not null or undefined
            assertParamExists('userExists', 'userExistsRequest', userExistsRequest);
            const localVarPath = `/client/user-exists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userExistsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary usernameExists
         * @param {UsernameExistsRequest} usernameExistsRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        usernameExists: (usernameExistsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'usernameExistsRequest' is not null or undefined
            assertParamExists('usernameExists', 'usernameExistsRequest', usernameExistsRequest);
            const localVarPath = `/client/username-exists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(usernameExistsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * checks if there is already a user with username
         * @summary usernameExistsApp
         * @param {UsernameExistsAppRequest} usernameExistsAppRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usernameExistsApp: (usernameExistsAppRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'usernameExistsAppRequest' is not null or undefined
            assertParamExists('usernameExistsApp', 'usernameExistsAppRequest', usernameExistsAppRequest);
            const localVarPath = `/client/username-exists-app`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(usernameExistsAppRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * forgot password action
         * @summary forgot password
         * @param {UsersForgotPasswordRequest} usersForgotPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersForgotPassword: (usersForgotPasswordRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'usersForgotPasswordRequest' is not null or undefined
            assertParamExists('usersForgotPassword', 'usersForgotPasswordRequest', usersForgotPasswordRequest);
            const localVarPath = `/backend/api/v1/users/forgot-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(usersForgotPasswordRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary usersList
         * @param {UsersListRequest} usersListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersList: (usersListRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'usersListRequest' is not null or undefined
            assertParamExists('usersList', 'usersListRequest', usersListRequest);
            const localVarPath = `/client/users-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserJwt required
            yield setApiKeyToObject(localVarQueryParameter, "userJwt", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(usersListRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * set new password action
         * @summary set password
         * @param {GroupsSetNewPasswordRequest} groupsSetNewPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersSetNewPassword: (groupsSetNewPasswordRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupsSetNewPasswordRequest' is not null or undefined
            assertParamExists('usersSetNewPassword', 'groupsSetNewPasswordRequest', groupsSetNewPasswordRequest);
            const localVarPath = `/backend/api/v1/users/set-new-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(groupsSetNewPasswordRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * login for product webbasic
         * @summary webbasic login
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webBasicLogin: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/backend/api/v1/products/web-basic/users/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BackendJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * check user activation for product messenger app
         * @summary adviser backend login
         * @param {GroupsAppCheckUserActivationRequest} groupsAppCheckUserActivationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webMessengerCheckUserActivation: (groupsAppCheckUserActivationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupsAppCheckUserActivationRequest' is not null or undefined
            assertParamExists('webMessengerCheckUserActivation', 'groupsAppCheckUserActivationRequest', groupsAppCheckUserActivationRequest);
            const localVarPath = `/backend/api/v1/products/web-messenger/users/check-activation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(groupsAppCheckUserActivationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * login for product messenger app
         * @summary messenger app login
         * @param {MessengerAppLoginRequest} messengerAppLoginRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webMessengerLogin: (messengerAppLoginRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'messengerAppLoginRequest' is not null or undefined
            assertParamExists('webMessengerLogin', 'messengerAppLoginRequest', messengerAppLoginRequest);
            const localVarPath = `/backend/api/v1/products/web-messenger/users/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(messengerAppLoginRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * check user activation for product messenger app
         * @summary nickname exists
         * @param {GroupsAppNicknameExistsRequest} groupsAppNicknameExistsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webMessengerNicknameExists: (groupsAppNicknameExistsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupsAppNicknameExistsRequest' is not null or undefined
            assertParamExists('webMessengerNicknameExists', 'groupsAppNicknameExistsRequest', groupsAppNicknameExistsRequest);
            const localVarPath = `/backend/api/v1/products/web-messenger/users/nickname-exists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(groupsAppNicknameExistsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Registration for product messenger app
         * @summary adviser backend login
         * @param {GroupsAppRegisterRequest} groupsAppRegisterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webMessengerRegister: (groupsAppRegisterRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupsAppRegisterRequest' is not null or undefined
            assertParamExists('webMessengerRegister', 'groupsAppRegisterRequest', groupsAppRegisterRequest);
            const localVarPath = `/backend/api/v1/products/web-messenger/users/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(groupsAppRegisterRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Resend Registration for product messenger app
         * @summary messenger resend registration mail
         * @param {MessengerAppRegisterResendMailRequest} messengerAppRegisterResendMailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webMessengerResendRegistrationMail: (messengerAppRegisterResendMailRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'messengerAppRegisterResendMailRequest' is not null or undefined
            assertParamExists('webMessengerResendRegistrationMail', 'messengerAppRegisterResendMailRequest', messengerAppRegisterResendMailRequest);
            const localVarPath = `/backend/api/v1/products/web-messenger/users/resend-registration-mail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(messengerAppRegisterResendMailRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary activates user
         * @param {string} activationToken activation token to activate user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webMessengerUsersActivate: (activationToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'activationToken' is not null or undefined
            assertParamExists('webMessengerUsersActivate', 'activationToken', activationToken);
            const localVarPath = `/backend/api/v1/products/web-messenger/users/activate/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (activationToken !== undefined) {
                localVarQueryParameter['activationToken'] = activationToken;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function (configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration);
    return {
        /**
         * Login via username, password or token. Returns a new token when autologin is set and a new jwt on successful login.  Should be a post request.
         * @summary adviser backend login
         * @param {AdviserBackendLoginRequest} adviserBackendLoginRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adviserBackendLogin(adviserBackendLoginRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adviserBackendLogin(adviserBackendLoginRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Gibt einen Berater für eine Beratungsstelle mit de rgeringsten Auslastung, also mit der geringsten Streamanzahl zurück.
         * @summary adviserRoundRobin
         * @param {AdviserRoundRobinRequest} adviserRoundRobinRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adviserRoundRobin(adviserRoundRobinRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adviserRoundRobin(adviserRoundRobinRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Single Sign On Endpunkt für assisto Berater. Es wird ein Token übergeben, der in der DB überprüft wird.
         * @summary adviserSso
         * @param {AdviserSSORequest} adviserSSORequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adviserSso(adviserSSORequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adviserSso(adviserSSORequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Eine überarbeitete Login Methode. Erwartet einen Benutzernamen und einen Token/Passwort und versucht den User zu authentifizieren. Gibt im Erfolgsfall u.a. einen JWT zurück.  JSON return data: { \'jwt\': Der JWT zu dem User, \'status\': Der aktuelle Status des Users, \'deleted\': Ob der User als gelöscht markeirt ist. \'beratungLanguages\': Die verfügbaren Sprachen für diesen User. \'agb\': AGBs für die BEratungsstelle des Users. }
         * @summary apiMobileLogin
         * @param {ApiMobileLoginRequest} apiMobileLoginRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMobileLogin(apiMobileLoginRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiMobileLogin(apiMobileLoginRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Gibt einen Berater zurück.  Erwartet in POST Daten \'userJwt\', \'beraterId\' und \'language\'.  JSON return data: { \'username\': Der Benutzername des Beraters, \'beraterId\': Die Berater ID aus assisto, \'beschreibung\': Die Übersetzte Beschreibung, \'sprachen\': Die angegebenen Sprachen des Beraters }
         * @summary beraterDetail
         * @param {BeraterDetailRequest} beraterDetailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        beraterDetail(beraterDetailRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.beraterDetail(beraterDetailRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * wird nur in alte Apps verwendet (mbeon - odyssey)
         * @summary beraterList
         * @param {BeraterListRequest} beraterListRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        beraterList(beraterListRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.beraterList(beraterListRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * holt die Beraterliste sortiert nach Entfernung ab
         * @summary beraterListV2
         * @param {0 | 1} unfiltered
         * @param {BeraterListV2Request} beraterListV2Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        beraterListV2(unfiltered, beraterListV2Request, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.beraterListV2(unfiltered, beraterListV2Request, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Gibt einen Berater Vorschlag zurück.  Erwartet in POST Daten \'userJwt\'und \'language\'.  JSON return data: [ { \'username\': Der Benutzername des Beraters, \'beraterId\': Die Berater ID aus assisto, \'available\': Ob der Berater verfügbar ist, \'beschreibung\': Die Übersetzte Beschreibung, \'sprachen\': Die angegebenen Sprachen des Beraters, \'img\': Bild des Beraters }, ... ]
         * @summary beraterSuggestion
         * @param {BeraterSuggestionRequest} beraterSuggestionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        beraterSuggestion(beraterSuggestionRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.beraterSuggestion(beraterSuggestionRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary changeNotificationSetting
         * @param {ChangeNotificationSettingRequest} changeNotificationSettingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeNotificationSetting(changeNotificationSettingRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.changeNotificationSetting(changeNotificationSettingRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary changeVisibility
         * @param {ChangeVisibilityRequest} changeVisibilityRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeVisibility(changeVisibilityRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.changeVisibility(changeVisibilityRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * ATTENTION! THIS ENDPOINT RETURNS A QUOTED STRING INSTEAD OF VALID JSON.
         * @summary checkUserWithPMECAS
         * @param {CheckUserWithPMECASRequest} checkUserWithPMECASRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUserWithPMECAS(checkUserWithPMECASRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkUserWithPMECAS(checkUserWithPMECASRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary codeResend
         * @param {CodeResendRequest} codeResendRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeResend(codeResendRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.codeResend(codeResendRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary complaint
         * @param {ComplaintRequest} complaintRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complaint(complaintRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.complaint(complaintRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary confirmAgb
         * @param {ConfirmAgbRequest} confirmAgbRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmAgb(confirmAgbRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.confirmAgb(confirmAgbRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary confirmODBFlush
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmODBFlush(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.confirmODBFlush(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * checks if there is already a user with this email or telefon in a certain company
         * @summary contactExists
         * @param {ContactExistsRequest} contactExistsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactExists(contactExistsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.contactExists(contactExistsRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * CURRENTLY LEAKS THE ENTIRE BERANET USER, _matchingData and _joinData. NOT FULLY DOCUMENTED
         * @summary createStream
         * @param {CreateStreamRequest} createStreamRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStream(createStreamRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createStream(createStreamRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary delete
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteUser(userId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * entfernt Nutzer Profilbild
         * @summary deleteUserImage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserImage(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteUserImage(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * user deletion api method
         * @summary deleteUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecatedDeleteUser(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deprecatedDeleteUser(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * scnd question async validator ... checks if existing user and contactValue and Username matches
         * @summary existingUser
         * @param {ExistingUserRequest} existingUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existingUser(existingUserRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.existingUser(existingUserRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Die \"Schnell Registrierung\" ohne Email Bestätigung usw. Der Registrierte Benutzer ist sofort im System aktiviert. Der User kann sich nicht erneut als dieselbe Person, wie bei dem anderen Login, registriert werden.  Es wird zuerst ein BeranetUser Datensatz angelegt und im Anschluss ein assisto User, der mit dem BeraentUser verknüpft ist.  Wird bei (Fostercare?) oder irgendwo anders verwendet :/
         * @summary fast-register
         * @param {FastRegisterRequest} fastRegisterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fastRegister(fastRegisterRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fastRegister(fastRegisterRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Gibt eine gefilterte Topics Liste zurück. Erwartet q mit einem String als Filter als POST Parameter.
         * @summary filteredTopicsList
         * @param {FilteredTopicsListRequest} filteredTopicsListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredTopicsList(filteredTopicsListRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.filteredTopicsList(filteredTopicsListRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Gibt eine Beraterliste zurück mit der ID als Key und dem Benutzernamen als Wert.
         * @summary flatAdvisersList
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flatAdvisersList(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.flatAdvisersList(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get adviser
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdviser(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAdviser(userId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get own adviser profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdviserProfile(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAdviserProfile(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary getAgb
         * @param {GetAgbRequest} getAgbRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgb(getAgbRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAgb(getAgbRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get all users from all companies
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {string} [search] search for items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsers(page, limit, search, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllUsers(page, limit, search, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Return all users inside own company
         * @summary get all users inside own company
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {string} [search] search for items
         * @param {string} [role]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersInCompany(page, limit, search, role, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllUsersInCompany(page, limit, search, role, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns the company modules, module config and the current user.  Should be a get request.
         * @summary getConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfig(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getConfig(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * FULLY LEAKS THE BERANET CONFIG ENTRY
         * @summary getFirmaId
         * @param {GetFirmaIdRequest} getFirmaIdRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirmaId(getFirmaIdRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getFirmaId(getFirmaIdRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * ATTENTION! THIS ENDPOINT RETURNS A STRING INSTEAD OF VALID JSON
         * @summary getGuest
         * @param {GetGuestRequest} getGuestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuest(getGuestRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getGuest(getGuestRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns all users as a list
         * @summary get a list of users
         * @param {string} [role]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListofUsers(role, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getListofUsers(role, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * [getMask description]
         * @summary getMask
         * @param {GetMaskRequest} getMaskRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMask(getMaskRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMask(getMaskRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get my data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMe(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary gets profile img for user
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileImg(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProfileImg(userId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * get status of advisers by rocket chat id array
         * @summary get status of advisers by rocket chat id array
         * @param {GetStatusOfAdvisersByRCIdsRequest} getStatusOfAdvisersByRCIdsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusOfAdvisersByRCIds(getStatusOfAdvisersByRCIdsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStatusOfAdvisersByRCIds(getStatusOfAdvisersByRCIdsRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * getStream  Returns an existing stream or creates a new one if none exists.
         * @summary getStream
         * @param {GetStreamRequest} getStreamRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStream(getStreamRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStream(getStreamRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * getStreams  Returns all streams.
         * @summary getStreams
         * @param {GetStreamsRequest} getStreamsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStreams(getStreamsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStreams(getStreamsRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUser(userId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get by rocket chat id
         * @param {string} rcId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByRCId(rcId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserByRCId(rcId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary getUserImg
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserImg(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserImg(userId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * getter for webmessenger configuration
         * @summary getWebmessengerConfig
         * @param {number} [firmaId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebmessengerConfig(firmaId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWebmessengerConfig(firmaId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * check user activation for product groups app
         * @summary adviser backend login
         * @param {GroupsAppCheckUserActivationRequest} groupsAppCheckUserActivationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsAppCheckUserActivation(groupsAppCheckUserActivationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.groupsAppCheckUserActivation(groupsAppCheckUserActivationRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * login for product groups app
         * @summary groups app login
         * @param {GroupsAppLoginRequest} groupsAppLoginRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsAppLogin(groupsAppLoginRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.groupsAppLogin(groupsAppLoginRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * check user activation for product groups app
         * @summary nickname exists
         * @param {GroupsAppNicknameExistsRequest} groupsAppNicknameExistsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsAppNicknameExists(groupsAppNicknameExistsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.groupsAppNicknameExists(groupsAppNicknameExistsRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Registration for product groups app
         * @summary adviser backend login
         * @param {GroupsAppRegisterRequest} groupsAppRegisterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsAppRegister(groupsAppRegisterRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.groupsAppRegister(groupsAppRegisterRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary activates user
         * @param {string} activationToken activation token to activate user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsAppUsersActivate(activationToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.groupsAppUsersActivate(activationToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * forgot password action
         * @summary forgot password
         * @param {GroupsForgotPasswordRequest} groupsForgotPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsForgotPassword(groupsForgotPasswordRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.groupsForgotPassword(groupsForgotPasswordRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * set password action
         * @summary set password
         * @param {GroupsSetNewPasswordRequest} groupsSetNewPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsSetNewPassword(groupsSetNewPasswordRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.groupsSetNewPassword(groupsSetNewPasswordRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary set password
         * @param {GroupsSetPasswordRequest} groupsSetPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsSetPassword(groupsSetPasswordRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.groupsSetPassword(groupsSetPasswordRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Main adviser restfull ep.
         * @summary mainAdviser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainAdviser(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.mainAdviser(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary endpoint for matching advisers
         * @param {MatchingAdvisersRequest} matchingAdvisersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchingAdvisers(matchingAdvisersRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.matchingAdvisers(matchingAdvisersRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * check user activation for product messenger app
         * @summary check user activation
         * @param {GroupsAppCheckUserActivationRequest} groupsAppCheckUserActivationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messengerAppCheckUserActivation(groupsAppCheckUserActivationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.messengerAppCheckUserActivation(groupsAppCheckUserActivationRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * check if user is verified
         * @summary verification check on user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messengerAppCheckUserVerification(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.messengerAppCheckUserVerification(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * login for product messenger app
         * @summary messenger app login
         * @param {MessengerAppLoginRequest} messengerAppLoginRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messengerAppLogin(messengerAppLoginRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.messengerAppLogin(messengerAppLoginRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * check user activation for product messenger app
         * @summary nickname exists
         * @param {GroupsAppNicknameExistsRequest} groupsAppNicknameExistsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messengerAppNicknameExists(groupsAppNicknameExistsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.messengerAppNicknameExists(groupsAppNicknameExistsRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Registration for product messenger app
         * @summary register user
         * @param {GroupsAppRegisterRequest} groupsAppRegisterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messengerAppRegister(groupsAppRegisterRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.messengerAppRegister(groupsAppRegisterRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Resend registration for product messenger app
         * @summary resend registration mail
         * @param {MessengerAppRegisterResendMailRequest} messengerAppRegisterResendMailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messengerAppRegisterResendMail(messengerAppRegisterResendMailRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.messengerAppRegisterResendMail(messengerAppRegisterResendMailRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * start verification process of anonymous user
         * @summary start verification of anonymous user
         * @param {GroupsForgotPasswordRequest} groupsForgotPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messengerAppStartVerification(groupsForgotPasswordRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.messengerAppStartVerification(groupsForgotPasswordRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary activates user
         * @param {string} activationToken activation token to activate user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messengerAppUsersActivate(activationToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.messengerAppUsersActivate(activationToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Login Methode.
         * @summary mobileLogin
         * @param {MobileLoginRequest} mobileLoginRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        mobileLogin(mobileLoginRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.mobileLogin(mobileLoginRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary mobileLoginV2
         * @param {MobileLoginV2Request} mobileLoginV2Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileLoginV2(mobileLoginV2Request, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.mobileLoginV2(mobileLoginV2Request, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Die Daten, die nach dem Login geschickt werden.
         * @summary postLogin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLogin(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.postLogin(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * TODO
         * @summary preLogin
         * @param {CheckVersionRequest} checkVersionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preLogin(checkVersionRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.preLogin(checkVersionRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary publicUsersList
         * @param {PublicUsersListRequest} publicUsersListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicUsersList(publicUsersListRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.publicUsersList(publicUsersListRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary register user
         * @param {RegisterRequest} registerRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(registerRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.register(registerRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary registerMobileConfirm
         * @param {RegisterConfirmRequest} registerConfirmRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerConfirm(registerConfirmRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.registerConfirm(registerConfirmRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * register methode for landingpage
         * @summary registerLandingpage
         * @param {RegisterLandingpageRequest} registerLandingpageRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerLandingpage(registerLandingpageRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.registerLandingpage(registerLandingpageRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary registerMobile
         * @param {RegisterMobileRequest} registerMobileRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerMobile(registerMobileRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.registerMobile(registerMobileRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Überarbeitete Register Methode. Eigentlich nur refaktoriesert und verschlankt.
         * @summary registerMobileV2
         * @param {RegisterMobileV2Request} registerMobileV2Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerMobileV2(registerMobileV2Request, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.registerMobileV2(registerMobileV2Request, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * register for web either webmodule or something else, basically a guest login for api
         * @summary registerWeb
         * @param {RegisterWebRequest} registerWebRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerWeb(registerWebRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.registerWeb(registerWebRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save adviser profile image
         * @param {File} [files] profile image file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAdvisersProfileImage(files, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveAdvisersProfileImage(files, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary save
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUser(user, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveUser(user, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary selfDelete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfDelete(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.selfDelete(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * sends message to registration source
         * @summary sendMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessage(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendMessage(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Überprüft, ob zusätzliche Informationen zu dem Nutzer, der anhand des übermittelten JWTs erkannt wird, vorhanden sind und gespeichert werden müssen und speichert diese ggf.
         * @summary setAdditionalInfo
         * @param {SetAdditionalInfoRequest} setAdditionalInfoRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAdditionalInfo(setAdditionalInfoRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setAdditionalInfo(setAdditionalInfoRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Get or set own adviser profile
         * @summary set own adviser profile
         * @param {AdviserInfo} adviserInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAdviserProfile(adviserInfo, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setAdviserProfile(adviserInfo, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * endpoint for setting own main adviser
         * @summary endpoint for setting own main adviser
         * @param {SetMainAdviserRequest} setMainAdviserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMainAdviser(setMainAdviserRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setMainAdviser(setMainAdviserRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Sets the adviser with the specified ID as main adviser for the specified user. Use `0` as adviser ID to un-set the main adviser for the user.
         * @summary Set main adviser for specific user
         * @param {SetMainAdviserForUserRequest} setMainAdviserForUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMainAdviserForUser(setMainAdviserForUserRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setMainAdviserForUser(setMainAdviserForUserRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary setUserImage
         * @param {File} file file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserImage(file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setUserImage(file, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * start a chat with given adviser
         * @summary start a chat with given adviser
         * @param {StartChatWithAdviserRequest} startChatWithAdviserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startChatWithAdviser(startChatWithAdviserRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.startChatWithAdviser(startChatWithAdviserRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary updatePushId
         * @param {UpdatePushIdRequest} updatePushIdRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePushId(updatePushIdRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePushId(updatePushIdRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * This endpoint doesnt handle an invalid user id at all. Returns an empty array if the user was not found
         * @summary userDetail
         * @param {UserDetailRequest} userDetailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDetail(userDetailRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userDetail(userDetailRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * checks if there is already a user with telefon or email
         * @summary userExists
         * @param {UserExistsRequest} userExistsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userExists(userExistsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userExists(userExistsRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary usernameExists
         * @param {UsernameExistsRequest} usernameExistsRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        usernameExists(usernameExistsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usernameExists(usernameExistsRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * checks if there is already a user with username
         * @summary usernameExistsApp
         * @param {UsernameExistsAppRequest} usernameExistsAppRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usernameExistsApp(usernameExistsAppRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usernameExistsApp(usernameExistsAppRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * forgot password action
         * @summary forgot password
         * @param {UsersForgotPasswordRequest} usersForgotPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersForgotPassword(usersForgotPasswordRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersForgotPassword(usersForgotPasswordRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary usersList
         * @param {UsersListRequest} usersListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersList(usersListRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersList(usersListRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * set new password action
         * @summary set password
         * @param {GroupsSetNewPasswordRequest} groupsSetNewPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersSetNewPassword(groupsSetNewPasswordRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersSetNewPassword(groupsSetNewPasswordRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * login for product webbasic
         * @summary webbasic login
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webBasicLogin(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.webBasicLogin(body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * check user activation for product messenger app
         * @summary adviser backend login
         * @param {GroupsAppCheckUserActivationRequest} groupsAppCheckUserActivationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webMessengerCheckUserActivation(groupsAppCheckUserActivationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.webMessengerCheckUserActivation(groupsAppCheckUserActivationRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * login for product messenger app
         * @summary messenger app login
         * @param {MessengerAppLoginRequest} messengerAppLoginRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webMessengerLogin(messengerAppLoginRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.webMessengerLogin(messengerAppLoginRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * check user activation for product messenger app
         * @summary nickname exists
         * @param {GroupsAppNicknameExistsRequest} groupsAppNicknameExistsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webMessengerNicknameExists(groupsAppNicknameExistsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.webMessengerNicknameExists(groupsAppNicknameExistsRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Registration for product messenger app
         * @summary adviser backend login
         * @param {GroupsAppRegisterRequest} groupsAppRegisterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webMessengerRegister(groupsAppRegisterRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.webMessengerRegister(groupsAppRegisterRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Resend Registration for product messenger app
         * @summary messenger resend registration mail
         * @param {MessengerAppRegisterResendMailRequest} messengerAppRegisterResendMailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webMessengerResendRegistrationMail(messengerAppRegisterResendMailRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.webMessengerResendRegistrationMail(messengerAppRegisterResendMailRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary activates user
         * @param {string} activationToken activation token to activate user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webMessengerUsersActivate(activationToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.webMessengerUsersActivate(activationToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UsersApiFp(configuration);
    return {
        /**
         * Login via username, password or token. Returns a new token when autologin is set and a new jwt on successful login.  Should be a post request.
         * @summary adviser backend login
         * @param {AdviserBackendLoginRequest} adviserBackendLoginRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adviserBackendLogin(adviserBackendLoginRequest, options) {
            return localVarFp.adviserBackendLogin(adviserBackendLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Gibt einen Berater für eine Beratungsstelle mit de rgeringsten Auslastung, also mit der geringsten Streamanzahl zurück.
         * @summary adviserRoundRobin
         * @param {AdviserRoundRobinRequest} adviserRoundRobinRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adviserRoundRobin(adviserRoundRobinRequest, options) {
            return localVarFp.adviserRoundRobin(adviserRoundRobinRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Single Sign On Endpunkt für assisto Berater. Es wird ein Token übergeben, der in der DB überprüft wird.
         * @summary adviserSso
         * @param {AdviserSSORequest} adviserSSORequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adviserSso(adviserSSORequest, options) {
            return localVarFp.adviserSso(adviserSSORequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Eine überarbeitete Login Methode. Erwartet einen Benutzernamen und einen Token/Passwort und versucht den User zu authentifizieren. Gibt im Erfolgsfall u.a. einen JWT zurück.  JSON return data: { \'jwt\': Der JWT zu dem User, \'status\': Der aktuelle Status des Users, \'deleted\': Ob der User als gelöscht markeirt ist. \'beratungLanguages\': Die verfügbaren Sprachen für diesen User. \'agb\': AGBs für die BEratungsstelle des Users. }
         * @summary apiMobileLogin
         * @param {ApiMobileLoginRequest} apiMobileLoginRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMobileLogin(apiMobileLoginRequest, options) {
            return localVarFp.apiMobileLogin(apiMobileLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Gibt einen Berater zurück.  Erwartet in POST Daten \'userJwt\', \'beraterId\' und \'language\'.  JSON return data: { \'username\': Der Benutzername des Beraters, \'beraterId\': Die Berater ID aus assisto, \'beschreibung\': Die Übersetzte Beschreibung, \'sprachen\': Die angegebenen Sprachen des Beraters }
         * @summary beraterDetail
         * @param {BeraterDetailRequest} beraterDetailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        beraterDetail(beraterDetailRequest, options) {
            return localVarFp.beraterDetail(beraterDetailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * wird nur in alte Apps verwendet (mbeon - odyssey)
         * @summary beraterList
         * @param {BeraterListRequest} beraterListRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        beraterList(beraterListRequest, options) {
            return localVarFp.beraterList(beraterListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * holt die Beraterliste sortiert nach Entfernung ab
         * @summary beraterListV2
         * @param {0 | 1} unfiltered
         * @param {BeraterListV2Request} beraterListV2Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        beraterListV2(unfiltered, beraterListV2Request, options) {
            return localVarFp.beraterListV2(unfiltered, beraterListV2Request, options).then((request) => request(axios, basePath));
        },
        /**
         * Gibt einen Berater Vorschlag zurück.  Erwartet in POST Daten \'userJwt\'und \'language\'.  JSON return data: [ { \'username\': Der Benutzername des Beraters, \'beraterId\': Die Berater ID aus assisto, \'available\': Ob der Berater verfügbar ist, \'beschreibung\': Die Übersetzte Beschreibung, \'sprachen\': Die angegebenen Sprachen des Beraters, \'img\': Bild des Beraters }, ... ]
         * @summary beraterSuggestion
         * @param {BeraterSuggestionRequest} beraterSuggestionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        beraterSuggestion(beraterSuggestionRequest, options) {
            return localVarFp.beraterSuggestion(beraterSuggestionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary changeNotificationSetting
         * @param {ChangeNotificationSettingRequest} changeNotificationSettingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeNotificationSetting(changeNotificationSettingRequest, options) {
            return localVarFp.changeNotificationSetting(changeNotificationSettingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary changeVisibility
         * @param {ChangeVisibilityRequest} changeVisibilityRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeVisibility(changeVisibilityRequest, options) {
            return localVarFp.changeVisibility(changeVisibilityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ATTENTION! THIS ENDPOINT RETURNS A QUOTED STRING INSTEAD OF VALID JSON.
         * @summary checkUserWithPMECAS
         * @param {CheckUserWithPMECASRequest} checkUserWithPMECASRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUserWithPMECAS(checkUserWithPMECASRequest, options) {
            return localVarFp.checkUserWithPMECAS(checkUserWithPMECASRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary codeResend
         * @param {CodeResendRequest} codeResendRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeResend(codeResendRequest, options) {
            return localVarFp.codeResend(codeResendRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary complaint
         * @param {ComplaintRequest} complaintRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complaint(complaintRequest, options) {
            return localVarFp.complaint(complaintRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary confirmAgb
         * @param {ConfirmAgbRequest} confirmAgbRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmAgb(confirmAgbRequest, options) {
            return localVarFp.confirmAgb(confirmAgbRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary confirmODBFlush
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmODBFlush(options) {
            return localVarFp.confirmODBFlush(options).then((request) => request(axios, basePath));
        },
        /**
         * checks if there is already a user with this email or telefon in a certain company
         * @summary contactExists
         * @param {ContactExistsRequest} contactExistsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactExists(contactExistsRequest, options) {
            return localVarFp.contactExists(contactExistsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * CURRENTLY LEAKS THE ENTIRE BERANET USER, _matchingData and _joinData. NOT FULLY DOCUMENTED
         * @summary createStream
         * @param {CreateStreamRequest} createStreamRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStream(createStreamRequest, options) {
            return localVarFp.createStream(createStreamRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary delete
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(userId, options) {
            return localVarFp.deleteUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * entfernt Nutzer Profilbild
         * @summary deleteUserImage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserImage(options) {
            return localVarFp.deleteUserImage(options).then((request) => request(axios, basePath));
        },
        /**
         * user deletion api method
         * @summary deleteUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecatedDeleteUser(options) {
            return localVarFp.deprecatedDeleteUser(options).then((request) => request(axios, basePath));
        },
        /**
         * scnd question async validator ... checks if existing user and contactValue and Username matches
         * @summary existingUser
         * @param {ExistingUserRequest} existingUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existingUser(existingUserRequest, options) {
            return localVarFp.existingUser(existingUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Die \"Schnell Registrierung\" ohne Email Bestätigung usw. Der Registrierte Benutzer ist sofort im System aktiviert. Der User kann sich nicht erneut als dieselbe Person, wie bei dem anderen Login, registriert werden.  Es wird zuerst ein BeranetUser Datensatz angelegt und im Anschluss ein assisto User, der mit dem BeraentUser verknüpft ist.  Wird bei (Fostercare?) oder irgendwo anders verwendet :/
         * @summary fast-register
         * @param {FastRegisterRequest} fastRegisterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fastRegister(fastRegisterRequest, options) {
            return localVarFp.fastRegister(fastRegisterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Gibt eine gefilterte Topics Liste zurück. Erwartet q mit einem String als Filter als POST Parameter.
         * @summary filteredTopicsList
         * @param {FilteredTopicsListRequest} filteredTopicsListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredTopicsList(filteredTopicsListRequest, options) {
            return localVarFp.filteredTopicsList(filteredTopicsListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Gibt eine Beraterliste zurück mit der ID als Key und dem Benutzernamen als Wert.
         * @summary flatAdvisersList
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flatAdvisersList(options) {
            return localVarFp.flatAdvisersList(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get adviser
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdviser(userId, options) {
            return localVarFp.getAdviser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get own adviser profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdviserProfile(options) {
            return localVarFp.getAdviserProfile(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary getAgb
         * @param {GetAgbRequest} getAgbRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgb(getAgbRequest, options) {
            return localVarFp.getAgb(getAgbRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get all users from all companies
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {string} [search] search for items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsers(page, limit, search, options) {
            return localVarFp.getAllUsers(page, limit, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Return all users inside own company
         * @summary get all users inside own company
         * @param {number} [page] page nr of requested page
         * @param {number} [limit] limit for items page
         * @param {string} [search] search for items
         * @param {string} [role]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersInCompany(page, limit, search, role, options) {
            return localVarFp.getAllUsersInCompany(page, limit, search, role, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the company modules, module config and the current user.  Should be a get request.
         * @summary getConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfig(options) {
            return localVarFp.getConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * FULLY LEAKS THE BERANET CONFIG ENTRY
         * @summary getFirmaId
         * @param {GetFirmaIdRequest} getFirmaIdRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirmaId(getFirmaIdRequest, options) {
            return localVarFp.getFirmaId(getFirmaIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ATTENTION! THIS ENDPOINT RETURNS A STRING INSTEAD OF VALID JSON
         * @summary getGuest
         * @param {GetGuestRequest} getGuestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuest(getGuestRequest, options) {
            return localVarFp.getGuest(getGuestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all users as a list
         * @summary get a list of users
         * @param {string} [role]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListofUsers(role, options) {
            return localVarFp.getListofUsers(role, options).then((request) => request(axios, basePath));
        },
        /**
         * [getMask description]
         * @summary getMask
         * @param {GetMaskRequest} getMaskRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMask(getMaskRequest, options) {
            return localVarFp.getMask(getMaskRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get my data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe(options) {
            return localVarFp.getMe(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary gets profile img for user
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileImg(userId, options) {
            return localVarFp.getProfileImg(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * get status of advisers by rocket chat id array
         * @summary get status of advisers by rocket chat id array
         * @param {GetStatusOfAdvisersByRCIdsRequest} getStatusOfAdvisersByRCIdsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusOfAdvisersByRCIds(getStatusOfAdvisersByRCIdsRequest, options) {
            return localVarFp.getStatusOfAdvisersByRCIds(getStatusOfAdvisersByRCIdsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * getStream  Returns an existing stream or creates a new one if none exists.
         * @summary getStream
         * @param {GetStreamRequest} getStreamRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStream(getStreamRequest, options) {
            return localVarFp.getStream(getStreamRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * getStreams  Returns all streams.
         * @summary getStreams
         * @param {GetStreamsRequest} getStreamsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStreams(getStreamsRequest, options) {
            return localVarFp.getStreams(getStreamsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(userId, options) {
            return localVarFp.getUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get by rocket chat id
         * @param {string} rcId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByRCId(rcId, options) {
            return localVarFp.getUserByRCId(rcId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary getUserImg
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserImg(userId, options) {
            return localVarFp.getUserImg(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * getter for webmessenger configuration
         * @summary getWebmessengerConfig
         * @param {number} [firmaId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebmessengerConfig(firmaId, options) {
            return localVarFp.getWebmessengerConfig(firmaId, options).then((request) => request(axios, basePath));
        },
        /**
         * check user activation for product groups app
         * @summary adviser backend login
         * @param {GroupsAppCheckUserActivationRequest} groupsAppCheckUserActivationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsAppCheckUserActivation(groupsAppCheckUserActivationRequest, options) {
            return localVarFp.groupsAppCheckUserActivation(groupsAppCheckUserActivationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * login for product groups app
         * @summary groups app login
         * @param {GroupsAppLoginRequest} groupsAppLoginRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsAppLogin(groupsAppLoginRequest, options) {
            return localVarFp.groupsAppLogin(groupsAppLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * check user activation for product groups app
         * @summary nickname exists
         * @param {GroupsAppNicknameExistsRequest} groupsAppNicknameExistsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsAppNicknameExists(groupsAppNicknameExistsRequest, options) {
            return localVarFp.groupsAppNicknameExists(groupsAppNicknameExistsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Registration for product groups app
         * @summary adviser backend login
         * @param {GroupsAppRegisterRequest} groupsAppRegisterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsAppRegister(groupsAppRegisterRequest, options) {
            return localVarFp.groupsAppRegister(groupsAppRegisterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary activates user
         * @param {string} activationToken activation token to activate user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsAppUsersActivate(activationToken, options) {
            return localVarFp.groupsAppUsersActivate(activationToken, options).then((request) => request(axios, basePath));
        },
        /**
         * forgot password action
         * @summary forgot password
         * @param {GroupsForgotPasswordRequest} groupsForgotPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsForgotPassword(groupsForgotPasswordRequest, options) {
            return localVarFp.groupsForgotPassword(groupsForgotPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * set password action
         * @summary set password
         * @param {GroupsSetNewPasswordRequest} groupsSetNewPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsSetNewPassword(groupsSetNewPasswordRequest, options) {
            return localVarFp.groupsSetNewPassword(groupsSetNewPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary set password
         * @param {GroupsSetPasswordRequest} groupsSetPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsSetPassword(groupsSetPasswordRequest, options) {
            return localVarFp.groupsSetPassword(groupsSetPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Main adviser restfull ep.
         * @summary mainAdviser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainAdviser(options) {
            return localVarFp.mainAdviser(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary endpoint for matching advisers
         * @param {MatchingAdvisersRequest} matchingAdvisersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchingAdvisers(matchingAdvisersRequest, options) {
            return localVarFp.matchingAdvisers(matchingAdvisersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * check user activation for product messenger app
         * @summary check user activation
         * @param {GroupsAppCheckUserActivationRequest} groupsAppCheckUserActivationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messengerAppCheckUserActivation(groupsAppCheckUserActivationRequest, options) {
            return localVarFp.messengerAppCheckUserActivation(groupsAppCheckUserActivationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * check if user is verified
         * @summary verification check on user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messengerAppCheckUserVerification(options) {
            return localVarFp.messengerAppCheckUserVerification(options).then((request) => request(axios, basePath));
        },
        /**
         * login for product messenger app
         * @summary messenger app login
         * @param {MessengerAppLoginRequest} messengerAppLoginRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messengerAppLogin(messengerAppLoginRequest, options) {
            return localVarFp.messengerAppLogin(messengerAppLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * check user activation for product messenger app
         * @summary nickname exists
         * @param {GroupsAppNicknameExistsRequest} groupsAppNicknameExistsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messengerAppNicknameExists(groupsAppNicknameExistsRequest, options) {
            return localVarFp.messengerAppNicknameExists(groupsAppNicknameExistsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Registration for product messenger app
         * @summary register user
         * @param {GroupsAppRegisterRequest} groupsAppRegisterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messengerAppRegister(groupsAppRegisterRequest, options) {
            return localVarFp.messengerAppRegister(groupsAppRegisterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Resend registration for product messenger app
         * @summary resend registration mail
         * @param {MessengerAppRegisterResendMailRequest} messengerAppRegisterResendMailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messengerAppRegisterResendMail(messengerAppRegisterResendMailRequest, options) {
            return localVarFp.messengerAppRegisterResendMail(messengerAppRegisterResendMailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * start verification process of anonymous user
         * @summary start verification of anonymous user
         * @param {GroupsForgotPasswordRequest} groupsForgotPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messengerAppStartVerification(groupsForgotPasswordRequest, options) {
            return localVarFp.messengerAppStartVerification(groupsForgotPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary activates user
         * @param {string} activationToken activation token to activate user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messengerAppUsersActivate(activationToken, options) {
            return localVarFp.messengerAppUsersActivate(activationToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Login Methode.
         * @summary mobileLogin
         * @param {MobileLoginRequest} mobileLoginRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        mobileLogin(mobileLoginRequest, options) {
            return localVarFp.mobileLogin(mobileLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary mobileLoginV2
         * @param {MobileLoginV2Request} mobileLoginV2Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileLoginV2(mobileLoginV2Request, options) {
            return localVarFp.mobileLoginV2(mobileLoginV2Request, options).then((request) => request(axios, basePath));
        },
        /**
         * Die Daten, die nach dem Login geschickt werden.
         * @summary postLogin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLogin(options) {
            return localVarFp.postLogin(options).then((request) => request(axios, basePath));
        },
        /**
         * TODO
         * @summary preLogin
         * @param {CheckVersionRequest} checkVersionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preLogin(checkVersionRequest, options) {
            return localVarFp.preLogin(checkVersionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary publicUsersList
         * @param {PublicUsersListRequest} publicUsersListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicUsersList(publicUsersListRequest, options) {
            return localVarFp.publicUsersList(publicUsersListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary register user
         * @param {RegisterRequest} registerRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(registerRequest, options) {
            return localVarFp.register(registerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary registerMobileConfirm
         * @param {RegisterConfirmRequest} registerConfirmRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerConfirm(registerConfirmRequest, options) {
            return localVarFp.registerConfirm(registerConfirmRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * register methode for landingpage
         * @summary registerLandingpage
         * @param {RegisterLandingpageRequest} registerLandingpageRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerLandingpage(registerLandingpageRequest, options) {
            return localVarFp.registerLandingpage(registerLandingpageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary registerMobile
         * @param {RegisterMobileRequest} registerMobileRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerMobile(registerMobileRequest, options) {
            return localVarFp.registerMobile(registerMobileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Überarbeitete Register Methode. Eigentlich nur refaktoriesert und verschlankt.
         * @summary registerMobileV2
         * @param {RegisterMobileV2Request} registerMobileV2Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerMobileV2(registerMobileV2Request, options) {
            return localVarFp.registerMobileV2(registerMobileV2Request, options).then((request) => request(axios, basePath));
        },
        /**
         * register for web either webmodule or something else, basically a guest login for api
         * @summary registerWeb
         * @param {RegisterWebRequest} registerWebRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerWeb(registerWebRequest, options) {
            return localVarFp.registerWeb(registerWebRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save adviser profile image
         * @param {File} [files] profile image file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAdvisersProfileImage(files, options) {
            return localVarFp.saveAdvisersProfileImage(files, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary save
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUser(user, options) {
            return localVarFp.saveUser(user, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary selfDelete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfDelete(options) {
            return localVarFp.selfDelete(options).then((request) => request(axios, basePath));
        },
        /**
         * sends message to registration source
         * @summary sendMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessage(options) {
            return localVarFp.sendMessage(options).then((request) => request(axios, basePath));
        },
        /**
         * Überprüft, ob zusätzliche Informationen zu dem Nutzer, der anhand des übermittelten JWTs erkannt wird, vorhanden sind und gespeichert werden müssen und speichert diese ggf.
         * @summary setAdditionalInfo
         * @param {SetAdditionalInfoRequest} setAdditionalInfoRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAdditionalInfo(setAdditionalInfoRequest, options) {
            return localVarFp.setAdditionalInfo(setAdditionalInfoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get or set own adviser profile
         * @summary set own adviser profile
         * @param {AdviserInfo} adviserInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAdviserProfile(adviserInfo, options) {
            return localVarFp.setAdviserProfile(adviserInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for setting own main adviser
         * @summary endpoint for setting own main adviser
         * @param {SetMainAdviserRequest} setMainAdviserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMainAdviser(setMainAdviserRequest, options) {
            return localVarFp.setMainAdviser(setMainAdviserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets the adviser with the specified ID as main adviser for the specified user. Use `0` as adviser ID to un-set the main adviser for the user.
         * @summary Set main adviser for specific user
         * @param {SetMainAdviserForUserRequest} setMainAdviserForUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMainAdviserForUser(setMainAdviserForUserRequest, options) {
            return localVarFp.setMainAdviserForUser(setMainAdviserForUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary setUserImage
         * @param {File} file file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserImage(file, options) {
            return localVarFp.setUserImage(file, options).then((request) => request(axios, basePath));
        },
        /**
         * start a chat with given adviser
         * @summary start a chat with given adviser
         * @param {StartChatWithAdviserRequest} startChatWithAdviserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startChatWithAdviser(startChatWithAdviserRequest, options) {
            return localVarFp.startChatWithAdviser(startChatWithAdviserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary updatePushId
         * @param {UpdatePushIdRequest} updatePushIdRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePushId(updatePushIdRequest, options) {
            return localVarFp.updatePushId(updatePushIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint doesnt handle an invalid user id at all. Returns an empty array if the user was not found
         * @summary userDetail
         * @param {UserDetailRequest} userDetailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDetail(userDetailRequest, options) {
            return localVarFp.userDetail(userDetailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * checks if there is already a user with telefon or email
         * @summary userExists
         * @param {UserExistsRequest} userExistsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userExists(userExistsRequest, options) {
            return localVarFp.userExists(userExistsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary usernameExists
         * @param {UsernameExistsRequest} usernameExistsRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        usernameExists(usernameExistsRequest, options) {
            return localVarFp.usernameExists(usernameExistsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * checks if there is already a user with username
         * @summary usernameExistsApp
         * @param {UsernameExistsAppRequest} usernameExistsAppRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usernameExistsApp(usernameExistsAppRequest, options) {
            return localVarFp.usernameExistsApp(usernameExistsAppRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * forgot password action
         * @summary forgot password
         * @param {UsersForgotPasswordRequest} usersForgotPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersForgotPassword(usersForgotPasswordRequest, options) {
            return localVarFp.usersForgotPassword(usersForgotPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary usersList
         * @param {UsersListRequest} usersListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersList(usersListRequest, options) {
            return localVarFp.usersList(usersListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * set new password action
         * @summary set password
         * @param {GroupsSetNewPasswordRequest} groupsSetNewPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersSetNewPassword(groupsSetNewPasswordRequest, options) {
            return localVarFp.usersSetNewPassword(groupsSetNewPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * login for product webbasic
         * @summary webbasic login
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webBasicLogin(body, options) {
            return localVarFp.webBasicLogin(body, options).then((request) => request(axios, basePath));
        },
        /**
         * check user activation for product messenger app
         * @summary adviser backend login
         * @param {GroupsAppCheckUserActivationRequest} groupsAppCheckUserActivationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webMessengerCheckUserActivation(groupsAppCheckUserActivationRequest, options) {
            return localVarFp.webMessengerCheckUserActivation(groupsAppCheckUserActivationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * login for product messenger app
         * @summary messenger app login
         * @param {MessengerAppLoginRequest} messengerAppLoginRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webMessengerLogin(messengerAppLoginRequest, options) {
            return localVarFp.webMessengerLogin(messengerAppLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * check user activation for product messenger app
         * @summary nickname exists
         * @param {GroupsAppNicknameExistsRequest} groupsAppNicknameExistsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webMessengerNicknameExists(groupsAppNicknameExistsRequest, options) {
            return localVarFp.webMessengerNicknameExists(groupsAppNicknameExistsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Registration for product messenger app
         * @summary adviser backend login
         * @param {GroupsAppRegisterRequest} groupsAppRegisterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webMessengerRegister(groupsAppRegisterRequest, options) {
            return localVarFp.webMessengerRegister(groupsAppRegisterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Resend Registration for product messenger app
         * @summary messenger resend registration mail
         * @param {MessengerAppRegisterResendMailRequest} messengerAppRegisterResendMailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webMessengerResendRegistrationMail(messengerAppRegisterResendMailRequest, options) {
            return localVarFp.webMessengerResendRegistrationMail(messengerAppRegisterResendMailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary activates user
         * @param {string} activationToken activation token to activate user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webMessengerUsersActivate(activationToken, options) {
            return localVarFp.webMessengerUsersActivate(activationToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * Login via username, password or token. Returns a new token when autologin is set and a new jwt on successful login.  Should be a post request.
     * @summary adviser backend login
     * @param {AdviserBackendLoginRequest} adviserBackendLoginRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    adviserBackendLogin(adviserBackendLoginRequest, options) {
        return UsersApiFp(this.configuration).adviserBackendLogin(adviserBackendLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gibt einen Berater für eine Beratungsstelle mit de rgeringsten Auslastung, also mit der geringsten Streamanzahl zurück.
     * @summary adviserRoundRobin
     * @param {AdviserRoundRobinRequest} adviserRoundRobinRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    adviserRoundRobin(adviserRoundRobinRequest, options) {
        return UsersApiFp(this.configuration).adviserRoundRobin(adviserRoundRobinRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Single Sign On Endpunkt für assisto Berater. Es wird ein Token übergeben, der in der DB überprüft wird.
     * @summary adviserSso
     * @param {AdviserSSORequest} adviserSSORequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    adviserSso(adviserSSORequest, options) {
        return UsersApiFp(this.configuration).adviserSso(adviserSSORequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Eine überarbeitete Login Methode. Erwartet einen Benutzernamen und einen Token/Passwort und versucht den User zu authentifizieren. Gibt im Erfolgsfall u.a. einen JWT zurück.  JSON return data: { \'jwt\': Der JWT zu dem User, \'status\': Der aktuelle Status des Users, \'deleted\': Ob der User als gelöscht markeirt ist. \'beratungLanguages\': Die verfügbaren Sprachen für diesen User. \'agb\': AGBs für die BEratungsstelle des Users. }
     * @summary apiMobileLogin
     * @param {ApiMobileLoginRequest} apiMobileLoginRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    apiMobileLogin(apiMobileLoginRequest, options) {
        return UsersApiFp(this.configuration).apiMobileLogin(apiMobileLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gibt einen Berater zurück.  Erwartet in POST Daten \'userJwt\', \'beraterId\' und \'language\'.  JSON return data: { \'username\': Der Benutzername des Beraters, \'beraterId\': Die Berater ID aus assisto, \'beschreibung\': Die Übersetzte Beschreibung, \'sprachen\': Die angegebenen Sprachen des Beraters }
     * @summary beraterDetail
     * @param {BeraterDetailRequest} beraterDetailRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    beraterDetail(beraterDetailRequest, options) {
        return UsersApiFp(this.configuration).beraterDetail(beraterDetailRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * wird nur in alte Apps verwendet (mbeon - odyssey)
     * @summary beraterList
     * @param {BeraterListRequest} beraterListRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    beraterList(beraterListRequest, options) {
        return UsersApiFp(this.configuration).beraterList(beraterListRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * holt die Beraterliste sortiert nach Entfernung ab
     * @summary beraterListV2
     * @param {0 | 1} unfiltered
     * @param {BeraterListV2Request} beraterListV2Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    beraterListV2(unfiltered, beraterListV2Request, options) {
        return UsersApiFp(this.configuration).beraterListV2(unfiltered, beraterListV2Request, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gibt einen Berater Vorschlag zurück.  Erwartet in POST Daten \'userJwt\'und \'language\'.  JSON return data: [ { \'username\': Der Benutzername des Beraters, \'beraterId\': Die Berater ID aus assisto, \'available\': Ob der Berater verfügbar ist, \'beschreibung\': Die Übersetzte Beschreibung, \'sprachen\': Die angegebenen Sprachen des Beraters, \'img\': Bild des Beraters }, ... ]
     * @summary beraterSuggestion
     * @param {BeraterSuggestionRequest} beraterSuggestionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    beraterSuggestion(beraterSuggestionRequest, options) {
        return UsersApiFp(this.configuration).beraterSuggestion(beraterSuggestionRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary changeNotificationSetting
     * @param {ChangeNotificationSettingRequest} changeNotificationSettingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    changeNotificationSetting(changeNotificationSettingRequest, options) {
        return UsersApiFp(this.configuration).changeNotificationSetting(changeNotificationSettingRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary changeVisibility
     * @param {ChangeVisibilityRequest} changeVisibilityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    changeVisibility(changeVisibilityRequest, options) {
        return UsersApiFp(this.configuration).changeVisibility(changeVisibilityRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * ATTENTION! THIS ENDPOINT RETURNS A QUOTED STRING INSTEAD OF VALID JSON.
     * @summary checkUserWithPMECAS
     * @param {CheckUserWithPMECASRequest} checkUserWithPMECASRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    checkUserWithPMECAS(checkUserWithPMECASRequest, options) {
        return UsersApiFp(this.configuration).checkUserWithPMECAS(checkUserWithPMECASRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary codeResend
     * @param {CodeResendRequest} codeResendRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    codeResend(codeResendRequest, options) {
        return UsersApiFp(this.configuration).codeResend(codeResendRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary complaint
     * @param {ComplaintRequest} complaintRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    complaint(complaintRequest, options) {
        return UsersApiFp(this.configuration).complaint(complaintRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary confirmAgb
     * @param {ConfirmAgbRequest} confirmAgbRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    confirmAgb(confirmAgbRequest, options) {
        return UsersApiFp(this.configuration).confirmAgb(confirmAgbRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary confirmODBFlush
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    confirmODBFlush(options) {
        return UsersApiFp(this.configuration).confirmODBFlush(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * checks if there is already a user with this email or telefon in a certain company
     * @summary contactExists
     * @param {ContactExistsRequest} contactExistsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    contactExists(contactExistsRequest, options) {
        return UsersApiFp(this.configuration).contactExists(contactExistsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * CURRENTLY LEAKS THE ENTIRE BERANET USER, _matchingData and _joinData. NOT FULLY DOCUMENTED
     * @summary createStream
     * @param {CreateStreamRequest} createStreamRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    createStream(createStreamRequest, options) {
        return UsersApiFp(this.configuration).createStream(createStreamRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary delete
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    deleteUser(userId, options) {
        return UsersApiFp(this.configuration).deleteUser(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * entfernt Nutzer Profilbild
     * @summary deleteUserImage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    deleteUserImage(options) {
        return UsersApiFp(this.configuration).deleteUserImage(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * user deletion api method
     * @summary deleteUser
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    deprecatedDeleteUser(options) {
        return UsersApiFp(this.configuration).deprecatedDeleteUser(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * scnd question async validator ... checks if existing user and contactValue and Username matches
     * @summary existingUser
     * @param {ExistingUserRequest} existingUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    existingUser(existingUserRequest, options) {
        return UsersApiFp(this.configuration).existingUser(existingUserRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Die \"Schnell Registrierung\" ohne Email Bestätigung usw. Der Registrierte Benutzer ist sofort im System aktiviert. Der User kann sich nicht erneut als dieselbe Person, wie bei dem anderen Login, registriert werden.  Es wird zuerst ein BeranetUser Datensatz angelegt und im Anschluss ein assisto User, der mit dem BeraentUser verknüpft ist.  Wird bei (Fostercare?) oder irgendwo anders verwendet :/
     * @summary fast-register
     * @param {FastRegisterRequest} fastRegisterRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    fastRegister(fastRegisterRequest, options) {
        return UsersApiFp(this.configuration).fastRegister(fastRegisterRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gibt eine gefilterte Topics Liste zurück. Erwartet q mit einem String als Filter als POST Parameter.
     * @summary filteredTopicsList
     * @param {FilteredTopicsListRequest} filteredTopicsListRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    filteredTopicsList(filteredTopicsListRequest, options) {
        return UsersApiFp(this.configuration).filteredTopicsList(filteredTopicsListRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gibt eine Beraterliste zurück mit der ID als Key und dem Benutzernamen als Wert.
     * @summary flatAdvisersList
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    flatAdvisersList(options) {
        return UsersApiFp(this.configuration).flatAdvisersList(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get adviser
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getAdviser(userId, options) {
        return UsersApiFp(this.configuration).getAdviser(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get own adviser profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getAdviserProfile(options) {
        return UsersApiFp(this.configuration).getAdviserProfile(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary getAgb
     * @param {GetAgbRequest} getAgbRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getAgb(getAgbRequest, options) {
        return UsersApiFp(this.configuration).getAgb(getAgbRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get all users from all companies
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {string} [search] search for items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getAllUsers(page, limit, search, options) {
        return UsersApiFp(this.configuration).getAllUsers(page, limit, search, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Return all users inside own company
     * @summary get all users inside own company
     * @param {number} [page] page nr of requested page
     * @param {number} [limit] limit for items page
     * @param {string} [search] search for items
     * @param {string} [role]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getAllUsersInCompany(page, limit, search, role, options) {
        return UsersApiFp(this.configuration).getAllUsersInCompany(page, limit, search, role, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns the company modules, module config and the current user.  Should be a get request.
     * @summary getConfig
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getConfig(options) {
        return UsersApiFp(this.configuration).getConfig(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * FULLY LEAKS THE BERANET CONFIG ENTRY
     * @summary getFirmaId
     * @param {GetFirmaIdRequest} getFirmaIdRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getFirmaId(getFirmaIdRequest, options) {
        return UsersApiFp(this.configuration).getFirmaId(getFirmaIdRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * ATTENTION! THIS ENDPOINT RETURNS A STRING INSTEAD OF VALID JSON
     * @summary getGuest
     * @param {GetGuestRequest} getGuestRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getGuest(getGuestRequest, options) {
        return UsersApiFp(this.configuration).getGuest(getGuestRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns all users as a list
     * @summary get a list of users
     * @param {string} [role]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getListofUsers(role, options) {
        return UsersApiFp(this.configuration).getListofUsers(role, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * [getMask description]
     * @summary getMask
     * @param {GetMaskRequest} getMaskRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getMask(getMaskRequest, options) {
        return UsersApiFp(this.configuration).getMask(getMaskRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get my data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getMe(options) {
        return UsersApiFp(this.configuration).getMe(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary gets profile img for user
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getProfileImg(userId, options) {
        return UsersApiFp(this.configuration).getProfileImg(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * get status of advisers by rocket chat id array
     * @summary get status of advisers by rocket chat id array
     * @param {GetStatusOfAdvisersByRCIdsRequest} getStatusOfAdvisersByRCIdsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getStatusOfAdvisersByRCIds(getStatusOfAdvisersByRCIdsRequest, options) {
        return UsersApiFp(this.configuration).getStatusOfAdvisersByRCIds(getStatusOfAdvisersByRCIdsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * getStream  Returns an existing stream or creates a new one if none exists.
     * @summary getStream
     * @param {GetStreamRequest} getStreamRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getStream(getStreamRequest, options) {
        return UsersApiFp(this.configuration).getStream(getStreamRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * getStreams  Returns all streams.
     * @summary getStreams
     * @param {GetStreamsRequest} getStreamsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getStreams(getStreamsRequest, options) {
        return UsersApiFp(this.configuration).getStreams(getStreamsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getUser(userId, options) {
        return UsersApiFp(this.configuration).getUser(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get by rocket chat id
     * @param {string} rcId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getUserByRCId(rcId, options) {
        return UsersApiFp(this.configuration).getUserByRCId(rcId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary getUserImg
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getUserImg(userId, options) {
        return UsersApiFp(this.configuration).getUserImg(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * getter for webmessenger configuration
     * @summary getWebmessengerConfig
     * @param {number} [firmaId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getWebmessengerConfig(firmaId, options) {
        return UsersApiFp(this.configuration).getWebmessengerConfig(firmaId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * check user activation for product groups app
     * @summary adviser backend login
     * @param {GroupsAppCheckUserActivationRequest} groupsAppCheckUserActivationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    groupsAppCheckUserActivation(groupsAppCheckUserActivationRequest, options) {
        return UsersApiFp(this.configuration).groupsAppCheckUserActivation(groupsAppCheckUserActivationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * login for product groups app
     * @summary groups app login
     * @param {GroupsAppLoginRequest} groupsAppLoginRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    groupsAppLogin(groupsAppLoginRequest, options) {
        return UsersApiFp(this.configuration).groupsAppLogin(groupsAppLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * check user activation for product groups app
     * @summary nickname exists
     * @param {GroupsAppNicknameExistsRequest} groupsAppNicknameExistsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    groupsAppNicknameExists(groupsAppNicknameExistsRequest, options) {
        return UsersApiFp(this.configuration).groupsAppNicknameExists(groupsAppNicknameExistsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Registration for product groups app
     * @summary adviser backend login
     * @param {GroupsAppRegisterRequest} groupsAppRegisterRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    groupsAppRegister(groupsAppRegisterRequest, options) {
        return UsersApiFp(this.configuration).groupsAppRegister(groupsAppRegisterRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary activates user
     * @param {string} activationToken activation token to activate user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    groupsAppUsersActivate(activationToken, options) {
        return UsersApiFp(this.configuration).groupsAppUsersActivate(activationToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * forgot password action
     * @summary forgot password
     * @param {GroupsForgotPasswordRequest} groupsForgotPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    groupsForgotPassword(groupsForgotPasswordRequest, options) {
        return UsersApiFp(this.configuration).groupsForgotPassword(groupsForgotPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * set password action
     * @summary set password
     * @param {GroupsSetNewPasswordRequest} groupsSetNewPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    groupsSetNewPassword(groupsSetNewPasswordRequest, options) {
        return UsersApiFp(this.configuration).groupsSetNewPassword(groupsSetNewPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary set password
     * @param {GroupsSetPasswordRequest} groupsSetPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    groupsSetPassword(groupsSetPasswordRequest, options) {
        return UsersApiFp(this.configuration).groupsSetPassword(groupsSetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Main adviser restfull ep.
     * @summary mainAdviser
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    mainAdviser(options) {
        return UsersApiFp(this.configuration).mainAdviser(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary endpoint for matching advisers
     * @param {MatchingAdvisersRequest} matchingAdvisersRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    matchingAdvisers(matchingAdvisersRequest, options) {
        return UsersApiFp(this.configuration).matchingAdvisers(matchingAdvisersRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * check user activation for product messenger app
     * @summary check user activation
     * @param {GroupsAppCheckUserActivationRequest} groupsAppCheckUserActivationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    messengerAppCheckUserActivation(groupsAppCheckUserActivationRequest, options) {
        return UsersApiFp(this.configuration).messengerAppCheckUserActivation(groupsAppCheckUserActivationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * check if user is verified
     * @summary verification check on user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    messengerAppCheckUserVerification(options) {
        return UsersApiFp(this.configuration).messengerAppCheckUserVerification(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * login for product messenger app
     * @summary messenger app login
     * @param {MessengerAppLoginRequest} messengerAppLoginRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    messengerAppLogin(messengerAppLoginRequest, options) {
        return UsersApiFp(this.configuration).messengerAppLogin(messengerAppLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * check user activation for product messenger app
     * @summary nickname exists
     * @param {GroupsAppNicknameExistsRequest} groupsAppNicknameExistsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    messengerAppNicknameExists(groupsAppNicknameExistsRequest, options) {
        return UsersApiFp(this.configuration).messengerAppNicknameExists(groupsAppNicknameExistsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Registration for product messenger app
     * @summary register user
     * @param {GroupsAppRegisterRequest} groupsAppRegisterRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    messengerAppRegister(groupsAppRegisterRequest, options) {
        return UsersApiFp(this.configuration).messengerAppRegister(groupsAppRegisterRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Resend registration for product messenger app
     * @summary resend registration mail
     * @param {MessengerAppRegisterResendMailRequest} messengerAppRegisterResendMailRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    messengerAppRegisterResendMail(messengerAppRegisterResendMailRequest, options) {
        return UsersApiFp(this.configuration).messengerAppRegisterResendMail(messengerAppRegisterResendMailRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * start verification process of anonymous user
     * @summary start verification of anonymous user
     * @param {GroupsForgotPasswordRequest} groupsForgotPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    messengerAppStartVerification(groupsForgotPasswordRequest, options) {
        return UsersApiFp(this.configuration).messengerAppStartVerification(groupsForgotPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary activates user
     * @param {string} activationToken activation token to activate user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    messengerAppUsersActivate(activationToken, options) {
        return UsersApiFp(this.configuration).messengerAppUsersActivate(activationToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Login Methode.
     * @summary mobileLogin
     * @param {MobileLoginRequest} mobileLoginRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    mobileLogin(mobileLoginRequest, options) {
        return UsersApiFp(this.configuration).mobileLogin(mobileLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary mobileLoginV2
     * @param {MobileLoginV2Request} mobileLoginV2Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    mobileLoginV2(mobileLoginV2Request, options) {
        return UsersApiFp(this.configuration).mobileLoginV2(mobileLoginV2Request, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Die Daten, die nach dem Login geschickt werden.
     * @summary postLogin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    postLogin(options) {
        return UsersApiFp(this.configuration).postLogin(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * TODO
     * @summary preLogin
     * @param {CheckVersionRequest} checkVersionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    preLogin(checkVersionRequest, options) {
        return UsersApiFp(this.configuration).preLogin(checkVersionRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary publicUsersList
     * @param {PublicUsersListRequest} publicUsersListRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    publicUsersList(publicUsersListRequest, options) {
        return UsersApiFp(this.configuration).publicUsersList(publicUsersListRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary register user
     * @param {RegisterRequest} registerRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    register(registerRequest, options) {
        return UsersApiFp(this.configuration).register(registerRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary registerMobileConfirm
     * @param {RegisterConfirmRequest} registerConfirmRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    registerConfirm(registerConfirmRequest, options) {
        return UsersApiFp(this.configuration).registerConfirm(registerConfirmRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * register methode for landingpage
     * @summary registerLandingpage
     * @param {RegisterLandingpageRequest} registerLandingpageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    registerLandingpage(registerLandingpageRequest, options) {
        return UsersApiFp(this.configuration).registerLandingpage(registerLandingpageRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary registerMobile
     * @param {RegisterMobileRequest} registerMobileRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    registerMobile(registerMobileRequest, options) {
        return UsersApiFp(this.configuration).registerMobile(registerMobileRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Überarbeitete Register Methode. Eigentlich nur refaktoriesert und verschlankt.
     * @summary registerMobileV2
     * @param {RegisterMobileV2Request} registerMobileV2Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    registerMobileV2(registerMobileV2Request, options) {
        return UsersApiFp(this.configuration).registerMobileV2(registerMobileV2Request, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * register for web either webmodule or something else, basically a guest login for api
     * @summary registerWeb
     * @param {RegisterWebRequest} registerWebRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    registerWeb(registerWebRequest, options) {
        return UsersApiFp(this.configuration).registerWeb(registerWebRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save adviser profile image
     * @param {File} [files] profile image file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    saveAdvisersProfileImage(files, options) {
        return UsersApiFp(this.configuration).saveAdvisersProfileImage(files, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary save
     * @param {User} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    saveUser(user, options) {
        return UsersApiFp(this.configuration).saveUser(user, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary selfDelete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    selfDelete(options) {
        return UsersApiFp(this.configuration).selfDelete(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * sends message to registration source
     * @summary sendMessage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    sendMessage(options) {
        return UsersApiFp(this.configuration).sendMessage(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Überprüft, ob zusätzliche Informationen zu dem Nutzer, der anhand des übermittelten JWTs erkannt wird, vorhanden sind und gespeichert werden müssen und speichert diese ggf.
     * @summary setAdditionalInfo
     * @param {SetAdditionalInfoRequest} setAdditionalInfoRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    setAdditionalInfo(setAdditionalInfoRequest, options) {
        return UsersApiFp(this.configuration).setAdditionalInfo(setAdditionalInfoRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get or set own adviser profile
     * @summary set own adviser profile
     * @param {AdviserInfo} adviserInfo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    setAdviserProfile(adviserInfo, options) {
        return UsersApiFp(this.configuration).setAdviserProfile(adviserInfo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * endpoint for setting own main adviser
     * @summary endpoint for setting own main adviser
     * @param {SetMainAdviserRequest} setMainAdviserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    setMainAdviser(setMainAdviserRequest, options) {
        return UsersApiFp(this.configuration).setMainAdviser(setMainAdviserRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sets the adviser with the specified ID as main adviser for the specified user. Use `0` as adviser ID to un-set the main adviser for the user.
     * @summary Set main adviser for specific user
     * @param {SetMainAdviserForUserRequest} setMainAdviserForUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    setMainAdviserForUser(setMainAdviserForUserRequest, options) {
        return UsersApiFp(this.configuration).setMainAdviserForUser(setMainAdviserForUserRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary setUserImage
     * @param {File} file file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    setUserImage(file, options) {
        return UsersApiFp(this.configuration).setUserImage(file, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * start a chat with given adviser
     * @summary start a chat with given adviser
     * @param {StartChatWithAdviserRequest} startChatWithAdviserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    startChatWithAdviser(startChatWithAdviserRequest, options) {
        return UsersApiFp(this.configuration).startChatWithAdviser(startChatWithAdviserRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary updatePushId
     * @param {UpdatePushIdRequest} updatePushIdRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    updatePushId(updatePushIdRequest, options) {
        return UsersApiFp(this.configuration).updatePushId(updatePushIdRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This endpoint doesnt handle an invalid user id at all. Returns an empty array if the user was not found
     * @summary userDetail
     * @param {UserDetailRequest} userDetailRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    userDetail(userDetailRequest, options) {
        return UsersApiFp(this.configuration).userDetail(userDetailRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * checks if there is already a user with telefon or email
     * @summary userExists
     * @param {UserExistsRequest} userExistsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    userExists(userExistsRequest, options) {
        return UsersApiFp(this.configuration).userExists(userExistsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary usernameExists
     * @param {UsernameExistsRequest} usernameExistsRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usernameExists(usernameExistsRequest, options) {
        return UsersApiFp(this.configuration).usernameExists(usernameExistsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * checks if there is already a user with username
     * @summary usernameExistsApp
     * @param {UsernameExistsAppRequest} usernameExistsAppRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usernameExistsApp(usernameExistsAppRequest, options) {
        return UsersApiFp(this.configuration).usernameExistsApp(usernameExistsAppRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * forgot password action
     * @summary forgot password
     * @param {UsersForgotPasswordRequest} usersForgotPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersForgotPassword(usersForgotPasswordRequest, options) {
        return UsersApiFp(this.configuration).usersForgotPassword(usersForgotPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary usersList
     * @param {UsersListRequest} usersListRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersList(usersListRequest, options) {
        return UsersApiFp(this.configuration).usersList(usersListRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * set new password action
     * @summary set password
     * @param {GroupsSetNewPasswordRequest} groupsSetNewPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersSetNewPassword(groupsSetNewPasswordRequest, options) {
        return UsersApiFp(this.configuration).usersSetNewPassword(groupsSetNewPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * login for product webbasic
     * @summary webbasic login
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    webBasicLogin(body, options) {
        return UsersApiFp(this.configuration).webBasicLogin(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * check user activation for product messenger app
     * @summary adviser backend login
     * @param {GroupsAppCheckUserActivationRequest} groupsAppCheckUserActivationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    webMessengerCheckUserActivation(groupsAppCheckUserActivationRequest, options) {
        return UsersApiFp(this.configuration).webMessengerCheckUserActivation(groupsAppCheckUserActivationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * login for product messenger app
     * @summary messenger app login
     * @param {MessengerAppLoginRequest} messengerAppLoginRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    webMessengerLogin(messengerAppLoginRequest, options) {
        return UsersApiFp(this.configuration).webMessengerLogin(messengerAppLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * check user activation for product messenger app
     * @summary nickname exists
     * @param {GroupsAppNicknameExistsRequest} groupsAppNicknameExistsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    webMessengerNicknameExists(groupsAppNicknameExistsRequest, options) {
        return UsersApiFp(this.configuration).webMessengerNicknameExists(groupsAppNicknameExistsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Registration for product messenger app
     * @summary adviser backend login
     * @param {GroupsAppRegisterRequest} groupsAppRegisterRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    webMessengerRegister(groupsAppRegisterRequest, options) {
        return UsersApiFp(this.configuration).webMessengerRegister(groupsAppRegisterRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Resend Registration for product messenger app
     * @summary messenger resend registration mail
     * @param {MessengerAppRegisterResendMailRequest} messengerAppRegisterResendMailRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    webMessengerResendRegistrationMail(messengerAppRegisterResendMailRequest, options) {
        return UsersApiFp(this.configuration).webMessengerResendRegistrationMail(messengerAppRegisterResendMailRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary activates user
     * @param {string} activationToken activation token to activate user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    webMessengerUsersActivate(activationToken, options) {
        return UsersApiFp(this.configuration).webMessengerUsersActivate(activationToken, options).then((request) => request(this.axios, this.basePath));
    }
}
